import React from 'react' // eslint-disable-line no-unused-vars
import { Link } from 'react-router-dom'
import { UncontrolledTooltip } from 'reactstrap'
import Footer from '../Footer'
import Select from '../../forms/Select'
import InputGroup from '../../forms/InputGroup'
import HeroImage from '../HeroImage'
import connect from 'react-redux/es/connect/connect'
import { validateField } from '../../pages/functions'
import { api } from '../index.api'
import { isMobileDevice } from '../../functions.js'
import imgHeaderStabilityToolMobile from './assets/img_header_stability_tool_mobile.jpg'
import imgHeaderStabilityTool from './assets/img_header_stability_tool.jpg'
import { PATIENT, REF_DATA, SELECTED_COUNTRY } from '../../constants'
import StaticConfig from '../StaticConfig'


class StabilityTool_common extends React.Component {
  constructor(props) {
    super(props)
    let content
    let preferredTemp
    if (props.userType === PATIENT) {
      content = this.props.pageContent.content.module.patientStabilityTool
      preferredTemp = StaticConfig.Context.ComponentConfig.ppTempPreference
    } else {
      content = this.props.pageContent.content.module.stabilityTool
      preferredTemp = StaticConfig.Context.ComponentConfig.hcpTempPreference
    }
    this.preferredTemp = preferredTemp
    this.state = {
      selectedRole: this.props.userType === PATIENT ? 'PATIENT' : null,
      selectedTemperatueExcursionType: null,
      selectedProduct: null,
      response: null,
      products: [],
      ranges: [],
      fields: {
        productName: {
          name: 'productName',
          rules: { title: content.product, required: true }
        },
        tempRange: {
          name: 'tempRange',
          rules: { title: content.tempRange, required: true }
        },
        tempActual: {
          name: 'tempActual',
          rules: {
            title: content.degrees,
            required: { message: content.tempRequired },
            format: {
              regex: /^(-?\d{1,3})$/,
              message: content.tempRequirement
            }
          }
        },
        tempIndicator: preferredTemp === 'F' ? {
          name: 'tempIndicator',
          rules: { title: content.tempIndicatorF, required: true }
        } : {
          name: 'tempIndicator',
          rules: { title: content.tempIndicatorC, required: true }
        },
        days: {
          name: 'days',
          rules: {
            title: content.days
            // required: true,
            // format: {
            //   regex: /^([0-9]{1,2}){1}$/,
            //   message: content.durationRequirement
            // }
          }
        },
        hours: {
          name: 'hours',
          rules: {
            title: content.hours
            // required: true,
            // format: {
            //   regex: /^([0-9]{1,2}){1}$/,
            //   message: content.durationRequirement
            // }
          }
        },
        minutes: {
          name: 'minutes',
          rules: {
            title: content.minutes
            // required: true,
            // format: {
            //   regex: /^([0-9]{1,2}){1}$/,
            //   message: content.durationRequirement
            // }
          }
        }
      }
    }
    if (this.preferredTemp === 'F') {
      this.tempOptions = [
        { value: 'F', label: '°F' },
        { value: 'C', label: '°C' }
      ]
    } else {
      this.tempOptions = [
        { value: 'C', label: '°C' },
        { value: 'F', label: '°F' }
      ]
    }
    this.dayOptions = []
    for (let i = 0; i < 100; i++) {
      let dayLabel = i.toString()
      if (i === 7) { dayLabel = i.toString() + ' (1 week)' } else if (i > 0 && i % 7 === 0) {
        dayLabel = i.toString() + ' (' + (i / 7).toString() + ' weeks)'
      }

      this.dayOptions.push({ value: i.toString(), label: dayLabel })
    }
    this.dayOptions.push({ value: '100', label: '100 or more' })

    this.hourOptions = []
    for (let i = 0; i < 24; i++) {
      this.hourOptions.push({ value: i.toString(), label: i.toString() })
    }
    this.minuteOptions = []
    for (let i = 0; i < 60; i++) {
      this.minuteOptions.push({ value: i.toString(), label: i.toString() })
    }
  }

  componentDidMount = () => {
    if (this.props.country) {
      this.getStabilityProducts()
    }
    if (this.props.userType === PATIENT && this.state.selectedRole !== 'PATIENT') {
      this.handleSelectedRole({ target: { value: 'PATIENT' } })
    }
  }

  componentDidUpdate = prevProps => {
    if (this.props.country !== prevProps.country) {
      this.getStabilityProducts()
    }
    if (this.props.userType !== prevProps.userType &&
      this.props.userType === PATIENT &&
      this.state.selectedRole !== 'PATIENT') {
      this.handleSelectedRole({ target: { value: 'PATIENT' } })
    }
  }

  validate = (e, field) => {
    const fields = validateField(e, field, this.state.fields)
    this.setState({ fields })
  }

  clearFields = () => {
    const { fields } = this.state
    Object.keys(fields).forEach(function (key) {
      delete fields[key].value
    })
    this.setState({ fields })
  }

  getStabilityProducts = () => {
    const products = []
    api.getStabilityProducts(
      { country: this.props.country },
      response => {
        for (const i in response) {
          const product = {
            value: i,
            label: response[i].productName,
            content: response[i]
          }
          products.push(product)
        }
        products.push({
          value: 'OTHER',
          label: this.props.pageContent.content.module.stabilityTool
            .otherProductsLabel
        })
      },
      error => {
        // TODO: show an error state on the page, rather than crash the whole app
        throw error
      }
    )
    this.setState({ products })
  }

  handleSelectedRole = event => {
    this.clearFields()
    this.setState({
      selectedRole: event.target.value,
      response: null,
      selectedProduct: null
    })
  }

  handleSelectedTemperatueExcursionType = event => {
    this.setState({
      selectedTemperatueExcursionType: event.target.value,
      selectedRole: this.props.userType === PATIENT ? 'PATIENT' : null,
      response: null,
      selectedProduct: null
    })
  }

  handleSelectedProduct = selectedProductIndex => {
    this.clearFields()
    this.setState({ response: null })
    if (
      selectedProductIndex === 'OTHER' ||
      ((this.state.products[selectedProductIndex].label === 'Duopa' || this.state.products[selectedProductIndex].label === 'Duopa®') &&
        this.state.selectedRole === 'HCP') || (this.state.products[selectedProductIndex].label === 'Botox' &&
        this.state.selectedRole === 'PATIENT') || (this.state.products[selectedProductIndex].label === 'Botox Cosmetic' &&
        this.state.selectedRole === 'PATIENT') || (this.state.products[selectedProductIndex].label === 'Skyrizi 600 mg/ 10 mL Vial' &&
        this.state.selectedRole === 'PATIENT') || (this.state.products[selectedProductIndex].label === 'Juvederm Ultra XC' &&
        this.state.selectedRole === 'PATIENT')|| (this.state.products[selectedProductIndex].label === 'Juvederm Voluma XC' &&
        this.state.selectedRole === 'PATIENT')|| (this.state.products[selectedProductIndex].label === 'Juvederm Volux XC' &&
        this.state.selectedRole === 'PATIENT')|| (this.state.products[selectedProductIndex].label === 'Juvederm Vollure XC' &&
        this.state.selectedRole === 'PATIENT')|| (this.state.products[selectedProductIndex].label === 'Juvederm Volbella XC' &&
        this.state.selectedRole === 'PATIENT')|| (this.state.products[selectedProductIndex].label === 'Juvederm SkinVive' &&
        this.state.selectedRole === 'PATIENT')|| (this.state.products[selectedProductIndex].label === 'Juvederm Ultra Plus XC' &&
        this.state.selectedRole === 'PATIENT')
    ) {
      this.setState({
        selectedProduct: {
          case: 'OTHER',
          message: this.props.pageContent.content.module.stabilityTool
            .otherProducts
        }
      })
      return
    }

    const rec = this.state.products[selectedProductIndex].content
      .recommendedRange
    const content = this.props.pageContent.content.module.stabilityTool
    this.setState({
      selectedProduct: this.state.products[selectedProductIndex]
    })
    const ranges = []
    if (this.preferredTemp === 'F') {
      ranges.push({
        value: 'UNDER',
        label: `${content.below} ${rec.minRangeF} °F (${rec.minRangeC} °C)`
      })
      ranges.push({
        value: 'RECOMMENDED',
        label: `${content.within} ${rec.minRangeF} ${content.to} ${rec.maxRangeF} °F (${rec.minRangeC} to ${rec.maxRangeC} °C)`
      })
      ranges.push({
        value: 'OVER',
        label: `${content.above} ${rec.maxRangeF} °F (${rec.maxRangeC} °C)`
      })
    } else {
      ranges.push({
        value: 'UNDER',
        label: `${content.below} ${rec.minRangeC} °C (${rec.minRangeF} °F)`
      })
      ranges.push({
        value: 'RECOMMENDED',
        label: `${content.within} ${rec.minRangeC} ${content.to} ${rec.maxRangeC} °C (${rec.minRangeF} to ${rec.maxRangeF} °F)`
      })
      ranges.push({
        value: 'OVER',
        label: `${content.above} ${rec.maxRangeC} °C (${rec.maxRangeF} °F)`
      })
    }
    ranges.push({
      value: 'BOTH_UNDER_OVER',
      label: content.both
    })
    this.setState({ ranges })
  }

  handleResetResponse = () => {
    this.setState({ response: null })
  }

  handleCalculate = () => {
    if (this.state.fields.days.value === '0' &&
      this.state.fields.hours.value === '0' &&
      this.state.fields.minutes.value === '0') {
      this.setState({ response: { result: 'ZERO_TIME' } })
      return
    }

    // validate range
    const min =
      this.state.fields.tempIndicator.value === 'C'
        ? this.state.selectedProduct.content.recommendedRange.minRangeC
        : this.state.selectedProduct.content.recommendedRange.minRangeF
    const max =
      this.state.fields.tempIndicator.value === 'C'
        ? this.state.selectedProduct.content.recommendedRange.maxRangeC
        : this.state.selectedProduct.content.recommendedRange.maxRangeF
    switch (this.state.fields.tempRange.value) {
      case 'UNDER':
        if (this.state.fields.tempActual.value >= min) {
          this.setState({ response: { result: 'MISMATCH' } })
          return
        }
        break
      case 'OVER':
        if (this.state.fields.tempActual.value <= max) {
          this.setState({ response: { result: 'MISMATCH' } })
          return
        }
        break
      case 'RECOMMENDED':
        if (
          this.state.fields.tempActual.value < min ||
          this.state.fields.tempActual.value > max
        ) {
          this.setState({ response: { result: 'MISMATCH' } })
          return
        }
        break
      default:
        break
    }

    const request = {
      productCode: this.state.selectedProduct.content.productCode,
      country: this.props.country,
      temperatureThreshold: this.state.fields.tempRange.value,
      userType: this.state.selectedRole,
      temperature: this.state.fields.tempActual.value,
      scale: this.state.fields.tempIndicator.value,
      duration: {
        days: this.state.fields.days.value,
        hours: this.state.fields.hours.value,
        minutes: this.state.fields.minutes.value
      }
    }
    api.checkStability(
      request,
      response => {
        this.setState({ response })

        if (typeof ABVMetrics !== 'undefined') {
          const formmd = {
            frmType: 'stability tool',
            frmStage: 'final-complete',
            formattr: {
              role: request.userType,
              product: request.productCode,
              temp_range: request.temperatureThreshold,
              temp: `${request.temperature}° ${request.scale}`,
              duration: `${request.duration.days},${request.duration.hours},${request.duration.minutes}`
            },
            formOutput: response
          }

          ABVMetrics.sendFormAnalytics(formmd) // eslint-disable-line no-undef
        }
      },
      error => {
        throw error
      }
    )
  }

  getSelectedProductMessage = selected => {
    if (selected.case === 'OTHER') {
      return selected.message
    } else if (selected.content) {
      if(this.isHumiraSelectedByPatient() || this.isHumiraSelectedByPPH() || this.isHumiraCitrateFreeSelectedByPatient() || this.isHumiraCitrateFreeSelectedByPPH()){
        if (this.preferredTemp === 'F') {
          return `The recommended storage for ${selected.label} is ${selected.content.recommendedRange.minRangeF}°F  to ${selected.content.recommendedRange.maxRangeF}°F (${selected.content.recommendedRange.minRangeC}°C to ${selected.content.recommendedRange.maxRangeC}°C). Do not Freeze.`
        } else {
          return `The recommended storage for ${selected.label} is ${selected.content.recommendedRange.minRangeC}°C to ${selected.content.recommendedRange.maxRangeC}°C (${selected.content.recommendedRange.minRangeF}°F  to ${selected.content.recommendedRange.maxRangeF}°F). Do not Freeze.`
        }
      }else{
        if (this.preferredTemp === 'F') {
          return `The recommended storage for ${selected.label} is ${selected.content.recommendedRange.minRangeF}°F  to ${selected.content.recommendedRange.maxRangeF}°F (${selected.content.recommendedRange.minRangeC}°C to ${selected.content.recommendedRange.maxRangeC}°C).`
        } else {
          return `The recommended storage for ${selected.label} is ${selected.content.recommendedRange.minRangeC}°C to ${selected.content.recommendedRange.maxRangeC}°C (${selected.content.recommendedRange.minRangeF}°F  to ${selected.content.recommendedRange.maxRangeF}°F).`
        }

      }
    }
    return null
  }

  isBotoxSelected = () => {
    return (
      this.state.selectedProduct.label.includes('Botox')
    )
  }
  
  returnLupronSelectedStatus = () => {
    var result = 'Failed';
    var tempActual = this.state.fields.tempActual.value;
         var tempIndicator =  this.state.fields.tempIndicator.value;
         var tempRange1 = this.state.fields.tempRange.value;
         if(((tempIndicator=== 'C') && (tempActual <-10 ) ) ||
          ((tempIndicator=== 'F') && (tempActual < 14 ) )	) {
          
         result = 'Failed';
          
        }
         else if(((tempIndicator=== 'C') && (tempActual >= -10  && tempActual <= 1) ) ||
          ((tempIndicator=== 'F') && (tempActual >= 14  && tempActual <= 35) )	) {

            if(this.selectedMinutes() <= 96) {
              result = 'Passed';
            }else{
              result = 'Failed';
            }
          
        }
        else if(((tempIndicator=== 'C') && (tempActual >= 2  && tempActual <= 14) ) ||
          ((tempIndicator=== 'F') && (tempActual >= 36  && tempActual <= 58) )	) {

            if(this.selectedMinutes() <= 192) {
              result = 'Passed';
            }else{
              result = 'Failed';
            }
          
        }
        else if(((tempIndicator=== 'C') && (tempActual >= 15  && tempActual <= 25) ) ||
          ((tempIndicator=== 'F') && (tempActual >= 59  && tempActual <= 77) )	) {
              result = 'Passed';
    
            }
            else if(((tempIndicator=== 'C') && (tempActual >= 26  && tempActual <= 40) ) ||
            ((tempIndicator=== 'F') && (tempActual >= 78  && tempActual <= 104) )	) {
              if(this.selectedMinutes() <= 96) {
                result = 'Passed';
              }else{
                result = 'Failed';
              }
            } else if (((tempIndicator === 'C') && (tempActual > 40)) ||
              ((tempIndicator === 'F') && (tempActual > 104 ))) {
            result = 'Failed';
             }
           return result;
             }
          
        
  
  returnBotoxSelectedStatus = () => {
    var result = 'Failed';

         var tempActual = this.state.fields.tempActual.value;
         var tempIndicator =  this.state.fields.tempIndicator.value;
         var tempRange1 = this.state.fields.tempRange.value;
          if(((tempIndicator=== 'C') && (tempActual >= -20  && tempActual <= 8) ) ||
          ((tempIndicator=== 'F') && (tempActual >= -4  && tempActual <= 46) )	) {
          
         result = 'Passed';
          
        }else if(((tempIndicator=== 'C') && (tempActual >= 9  && tempActual <= 30) ) ||
          ((tempIndicator=== 'F') && (tempActual >= 47  && tempActual <= 86) )	) {
          if(this.selectedMinutes() <= 120) {
            result = 'Passed';
        
          }else{
          
            result = 'Failed';
          
          }
       
          
        }

      return result;


  }

  returnSkyriziPenPatientSelectedStatus = () => {
    var result = 'Failed';

    var tempActual = this.state.fields.tempActual.value ;
    var tempIndicator = this.state.fields.tempIndicator.value ;
    var userType=this.state.selectedRole;
    if (((tempIndicator=== 'C') && (tempActual < -5) ) ||
            ((tempIndicator=== 'F') && (tempActual <23))) {
            
             
            result = 'Failed'; 
          
          }
          else if(((tempIndicator=== 'C') && (tempActual >= -5  && tempActual <= 1) ) ||
            ((tempIndicator=== 'F') && (tempActual >= 23  && tempActual <= 35) )	) {
             if (this.selectedMinutes() <= 120) {
                 
                result = 'Passed';
             }else{
                 
                result = 'Failed';
             }           
            
          }else if(((tempIndicator=== 'C') && (tempActual >= 2 && tempActual <= 8) ) ||
            ((tempIndicator=== 'F') && (tempActual >= 36  && tempActual <= 46) )	) {
            
                 
                result = 'Passed';
                     
            
          }else if(((tempIndicator=== 'C') && (tempActual >= 9  && tempActual <= 25) ) ||
            ((tempIndicator=== 'F') && (tempActual >= 47  && tempActual <= 77) )	) {
              if (this.selectedMinutes() <= 24) {
                 
                result = 'Passed';
             }else{
                 
                result = 'Failed';
             }           
            
          }else if (((tempIndicator=== 'C') && (tempActual > 25) ) ||
            ((tempIndicator=== 'F') && (tempActual >77) )	) {
            
             
            result = 'Failed'; 
          
          }
    return result;
  }

  returnSkyriziPenPPHSelectedStatus = () => {
    var result = 'Failed';

    var tempActual = this.state.fields.tempActual.value ;
    var tempIndicator = this.state.fields.tempIndicator.value ;
    var userType=this.state.selectedRole;
      if (((tempIndicator=== 'C') && (tempActual < -5) ) ||
            ((tempIndicator=== 'F') && (tempActual <23))) {
            
             
            result = 'Failed'; 
          
          }
          else if(((tempIndicator=== 'C') && (tempActual >= -5  && tempActual <= 1) ) ||
            ((tempIndicator=== 'F') && (tempActual >= 23  && tempActual <= 35) )	) {
             if (this.selectedMinutes() <= 72) {
                 
                result = 'Passed';
             }else{
                 
                result = 'Failed';
             }           
            
          }else if(((tempIndicator=== 'C') && (tempActual >= 2 && tempActual <= 8) ) ||
            ((tempIndicator=== 'F') && (tempActual >= 36  && tempActual <= 46) )	) {
            
                 
                result = 'Passed';
                     
            
          }else if(((tempIndicator=== 'C') && (tempActual >= 9  && tempActual <= 25) ) ||
            ((tempIndicator=== 'F') && (tempActual >= 47  && tempActual <= 77) )	) {
             if (this.selectedMinutes() <= 24) {
                 
                result = 'Passed';
             }else{
                 
                result = 'Failed';
             }           
            
          }else if (((tempIndicator=== 'C') && (tempActual > 25) ) ||
            ((tempIndicator=== 'F') && (tempActual >77) )	) {
            
             
            result = 'Failed'; 
          
          }
    return result;
  }

  returnSkyriziSyringePatientSelectedStatus = () => {
    var result = 'Failed';

    var tempActual = this.state.fields.tempActual.value ;
    var tempIndicator = this.state.fields.tempIndicator.value ;
    var userType=this.state.selectedRole;
    if (((tempIndicator=== 'C') && (tempActual < -5) ) ||
            ((tempIndicator=== 'F') && (tempActual <23))) {
            
             
            result = 'Failed'; 
          
          }
          else if(((tempIndicator=== 'C') && (tempActual >= -5  && tempActual <= 1) ) ||
            ((tempIndicator=== 'F') && (tempActual >= 23  && tempActual <= 35) )	) {
             result = 'Failed';          
            
          }else if(((tempIndicator=== 'C') && (tempActual >= 2 && tempActual <= 8) ) ||
            ((tempIndicator=== 'F') && (tempActual >= 36  && tempActual <= 46) )	) {
            
                 
                result = 'Passed';
                     
            
          }else if(((tempIndicator=== 'C') && (tempActual >= 9  && tempActual <= 25) ) ||
            ((tempIndicator=== 'F') && (tempActual >= 47  && tempActual <= 77) )	) {
              if (this.selectedMinutes() <= 24) {
                 
                result = 'Passed';
             }else{
                 
                result = 'Failed';
             }           
            
          }else if (((tempIndicator=== 'C') && (tempActual > 25) ) ||
            ((tempIndicator=== 'F') && (tempActual >77) )	) {
            
             
            result = 'Failed'; 
          
          }
    return result;
  }

  returnSkyriziSyringePPHSelectedStatus = () => {
    var result = 'Failed';

    var tempActual = this.state.fields.tempActual.value ;
    var tempIndicator = this.state.fields.tempIndicator.value ;
    var userType=this.state.selectedRole;
      if (((tempIndicator=== 'C') && (tempActual < -5) ) ||
            ((tempIndicator=== 'F') && (tempActual <23))) {
            
             
            result = 'Failed'; 
          
          }
          else if(((tempIndicator=== 'C') && (tempActual >= -5  && tempActual <= 1) ) ||
            ((tempIndicator=== 'F') && (tempActual >= 23  && tempActual <= 35) )	) {
             result = 'Failed';         
            
          }else if(((tempIndicator=== 'C') && (tempActual >= 2 && tempActual <= 8) ) ||
            ((tempIndicator=== 'F') && (tempActual >= 36  && tempActual <= 46) )	) {
            
                 
                result = 'Passed';
                     
            
          }else if(((tempIndicator=== 'C') && (tempActual >= 9  && tempActual <= 25) ) ||
            ((tempIndicator=== 'F') && (tempActual >= 47  && tempActual <= 77) )	) {
             if (this.selectedMinutes() <= 24) {
                 
                result = 'Passed';
             }else{
                 
                result = 'Failed';
             }           
            
          }else if (((tempIndicator=== 'C') && (tempActual > 25) ) ||
            ((tempIndicator=== 'F') && (tempActual >77) )	) {
            
             
            result = 'Failed'; 
          
          }
    return result;
  }
  
  returnRinvoqTabletsPatientSelectedStatus = () => {
    var result = 'Failed';

    var tempActual = this.state.fields.tempActual.value ;
    var tempIndicator = this.state.fields.tempIndicator.value ;
    var userType=this.state.selectedRole;
    if (((tempIndicator=== 'C') && (tempActual < -20) ) ||
            ((tempIndicator=== 'F') && (tempActual <-4))) {
            
             
            result = 'Failed'; 
          
          }
          else if(((tempIndicator=== 'C') && (tempActual >= -20  && tempActual <= 1) ) ||
            ((tempIndicator=== 'F') && (tempActual >= -4  && tempActual <= 35) )	) {
             if (this.selectedMinutes() <= 72) {
                 
                result = 'Passed';
             }else{
                 
                result = 'Failed';
             }           
            
          }else if(((tempIndicator=== 'C') && (tempActual >= 2 && tempActual <= 30) ) ||
            ((tempIndicator=== 'F') && (tempActual >= 36  && tempActual <= 86) )	) {
            
                 
                result = 'Passed';
                     
            
          }else if(((tempIndicator=== 'C') && (tempActual >= 31  && tempActual <= 40) ) ||
            ((tempIndicator=== 'F') && (tempActual >= 87  && tempActual <= 104) )	) {
              if (this.selectedMinutes() <= 144) {
                 
                result = 'Passed';
             }else{
                 
                result = 'Failed';
             }           
            
          }else if(((tempIndicator=== 'C') && (tempActual >= 41  && tempActual <= 50) ) ||
            ((tempIndicator=== 'F') && (tempActual >= 105  && tempActual <= 122) )	) {
              if (this.selectedMinutes() <= 72) {
                 
                result = 'Passed';
             }else{
                 
                result = 'Failed';
             }           
            
          }else if (((tempIndicator=== 'C') && (tempActual > 50) ) ||
            ((tempIndicator=== 'F') && (tempActual >122) )	) {
            
             
            result = 'Failed'; 
          
          }
    return result;
  }

  returnRinvoqTabletsPPHSelectedStatus = () => {
    var result = 'Failed';

    var tempActual = this.state.fields.tempActual.value ;
    var tempIndicator = this.state.fields.tempIndicator.value ;
    var userType=this.state.selectedRole;
    if (((tempIndicator=== 'C') && (tempActual < -20) ) ||
            ((tempIndicator=== 'F') && (tempActual <-4))) {
            
             
            result = 'Failed'; 
          
          }
          else if(((tempIndicator=== 'C') && (tempActual >= -20  && tempActual <= 1) ) ||
            ((tempIndicator=== 'F') && (tempActual >= -4  && tempActual <= 35) )	) {
             if (this.selectedMinutes() <= 48) {
                 
                result = 'Passed';
             }else{
                 
                result = 'Failed';
             }           
            
          }else if(((tempIndicator=== 'C') && (tempActual >= 2 && tempActual <= 30) ) ||
            ((tempIndicator=== 'F') && (tempActual >= 36  && tempActual <= 86) )	) {
            
                 
                result = 'Passed';
                     
            
          }else if(((tempIndicator=== 'C') && (tempActual >= 31  && tempActual <= 40) ) ||
            ((tempIndicator=== 'F') && (tempActual >= 87  && tempActual <= 104) )	) {
              if (this.selectedMinutes() <= 96) {
                 
                result = 'Passed';
             }else{
                 
                result = 'Failed';
             }           
            
          }else if(((tempIndicator=== 'C') && (tempActual >= 41  && tempActual <= 50) ) ||
            ((tempIndicator=== 'F') && (tempActual >= 105  && tempActual <= 122) )	) {
              if (this.selectedMinutes() <= 48) {
                 
                result = 'Passed';
             }else{
                 
                result = 'Failed';
             }           
            
          }else if (((tempIndicator=== 'C') && (tempActual > 50) ) ||
            ((tempIndicator=== 'F') && (tempActual >122) )	) {
            
             
            result = 'Failed'; 
          
          }
    return result;
  }
  returnHumiraCitrateFreePatientSelectedStatus = () => {
   var result = 'Failed';

    var tempActual = this.state.fields.tempActual.value ;
    var tempIndicator = this.state.fields.tempIndicator.value ;
    var userType=this.state.selectedRole;
    if (((tempIndicator=== 'C') && (tempActual < -10) ) ||
            ((tempIndicator=== 'F') && (tempActual <14))) {
            
             
            result = 'Failed'; 
          
          }
          else if(((tempIndicator=== 'C') && (tempActual >= -10  && tempActual <= -1) ) ||
            ((tempIndicator=== 'F') && (tempActual >= 14  && tempActual <= 31) )	) {
             if (this.selectedMinutes() <= 120) {
                 
                result = 'Passed';
             }else{
                 
                result = 'Failed';
             }           
            
          }else if(((tempIndicator=== 'C') && (tempActual >= 0 && tempActual <= 8) ) ||
            ((tempIndicator=== 'F') && (tempActual >= 32  && tempActual <= 46) )	) {
            
                 
                result = 'Passed';
                     
            
          }else if(((tempIndicator=== 'C') && (tempActual >= 9  && tempActual <= 25) ) ||
            ((tempIndicator=== 'F') && (tempActual >= 47  && tempActual <= 77) )	) {
              if (this.selectedMinutes() <= 336) {
                 
                result = 'Passed';
             }else{
                 
                result = 'Failed';
             }           
            
          }else if(((tempIndicator=== 'C') && (tempActual >= 26  && tempActual <= 30) ) ||
            ((tempIndicator=== 'F') && (tempActual >= 78  && tempActual <= 86) )	) {
              if (this.selectedMinutes() <= 24) {
                 
                result = 'Passed';
             }else{
                 
                result = 'Failed';
             }           
            
          }else if (((tempIndicator=== 'C') && (tempActual > 30) ) ||
            ((tempIndicator=== 'F') && (tempActual >86) )	) {
            
             
            result = 'Failed'; 
          
          }
    return result;
  }

  returnHumiraCitrateFreePPHSelectedStatus = () => {
    var result = 'Failed';

    var tempActual = this.state.fields.tempActual.value ;
    var tempIndicator = this.state.fields.tempIndicator.value ;
    var userType=this.state.selectedRole;
    if (((tempIndicator=== 'C') && (tempActual < -10) ) ||
            ((tempIndicator=== 'F') && (tempActual <14))) {
            
             
            result = 'Failed'; 
          
          }
          else if(((tempIndicator=== 'C') && (tempActual >= -10  && tempActual <= -1) ) ||
            ((tempIndicator=== 'F') && (tempActual >= 14  && tempActual <= 31) )	) {
             if (this.selectedMinutes() <= 120) {
                 
                result = 'Passed';
             }else{
                 
                result = 'Failed';
             }           
            
          }else if(((tempIndicator=== 'C') && (tempActual >= 0 && tempActual <= 8) ) ||
            ((tempIndicator=== 'F') && (tempActual >= 32  && tempActual <= 46) )	) {
            
                 
                result = 'Passed';
                     
            
          }else if(((tempIndicator=== 'C') && (tempActual >= 9  && tempActual <= 15) ) ||
            ((tempIndicator=== 'F') && (tempActual >= 47  && tempActual <= 59) )	) {
              if (this.selectedMinutes() <= 120) {
                 
                result = 'Passed';
             }else{
                 
                result = 'Failed';
             }           
            
          }else if(((tempIndicator=== 'C') && (tempActual >= 16  && tempActual <= 25) ) ||
            ((tempIndicator=== 'F') && (tempActual >= 60  && tempActual <= 77) )	) {
              if (this.selectedMinutes() <= 48) {
                 
                result = 'Passed';
             }else{
                 
                result = 'Failed';
             }           
            
          }else if(((tempIndicator=== 'C') && (tempActual >= 26  && tempActual <= 30) ) ||
            ((tempIndicator=== 'F') && (tempActual >= 78  && tempActual <= 86) )	) {
              if (this.selectedMinutes() <= 12) {
                 
                result = 'Passed';
             }else{
                 
                result = 'Failed';
             }           
            
          }else if (((tempIndicator=== 'C') && (tempActual > 30) ) ||
            ((tempIndicator=== 'F') && (tempActual >86) )	) {
            
             
            result = 'Failed'; 
          
          }
    return result;
  }
  returnRinvoqLiquidPatientSelectedStatus = () => {
    var result = 'Failed';

    var tempActual = this.state.fields.tempActual.value ;
    var tempIndicator = this.state.fields.tempIndicator.value ;
    var userType=this.state.selectedRole;
    if (((tempIndicator=== 'C') && (tempActual < -20) ) ||
            ((tempIndicator=== 'F') && (tempActual <-4))) {
            
             
            result = 'Failed'; 
          
          }
          else if(((tempIndicator=== 'C') && (tempActual >= -20  && tempActual <= 1) ) ||
            ((tempIndicator=== 'F') && (tempActual >= -4  && tempActual <= 35) )	) {
             if (this.selectedMinutes() <= 72) {
                 
                result = 'Passed';
             }else{
                 
                result = 'Failed';
             }           
            
          }else if(((tempIndicator=== 'C') && (tempActual >= 2 && tempActual <= 30) ) ||
            ((tempIndicator=== 'F') && (tempActual >= 36  && tempActual <= 86) )	) {
            
                 
                result = 'Passed';
                     
            
          }else if(((tempIndicator=== 'C') && (tempActual >= 31  && tempActual <= 40) ) ||
            ((tempIndicator=== 'F') && (tempActual >= 87  && tempActual <= 104) )	) {
              if (this.selectedMinutes() <= 144) {
                 
                result = 'Passed';
             }else{
                 
                result = 'Failed';
             }           
            
          }else if(((tempIndicator=== 'C') && (tempActual >= 41  && tempActual <= 50) ) ||
            ((tempIndicator=== 'F') && (tempActual >= 105  && tempActual <= 122) )	) {
              if (this.selectedMinutes() <= 96) {
                 
                result = 'Passed';
             }else{
                 
                result = 'Failed';
             }           
            
          }else if (((tempIndicator=== 'C') && (tempActual > 50) ) ||
            ((tempIndicator=== 'F') && (tempActual >122) )	) {
            
             
            result = 'Failed'; 
          
          }
    return result;
  }

  returnRinvoqLiquidPPHSelectedStatus = () => {
    var result = 'Failed';

    var tempActual = this.state.fields.tempActual.value ;
    var tempIndicator = this.state.fields.tempIndicator.value ;
    var userType=this.state.selectedRole;
    if (((tempIndicator=== 'C') && (tempActual < -20) ) ||
            ((tempIndicator=== 'F') && (tempActual <-4))) {
            
             
            result = 'Failed'; 
          
          }
          else if(((tempIndicator=== 'C') && (tempActual >= -20  && tempActual <= 1) ) ||
            ((tempIndicator=== 'F') && (tempActual >= -4  && tempActual <= 35) )	) {
             if (this.selectedMinutes() <= 72) {
                 
                result = 'Passed';
             }else{
                 
                result = 'Failed';
             }           
            
          }else if(((tempIndicator=== 'C') && (tempActual >= 2 && tempActual <= 30) ) ||
            ((tempIndicator=== 'F') && (tempActual >= 36  && tempActual <= 86) )	) {
            
                 
                result = 'Passed';
                     
            
          }else if(((tempIndicator=== 'C') && (tempActual >= 31  && tempActual <= 40) ) ||
            ((tempIndicator=== 'F') && (tempActual >= 87  && tempActual <= 104) )	) {
              if (this.selectedMinutes() <= 144) {
                 
                result = 'Passed';
             }else{
                 
                result = 'Failed';
             }           
            
          }else if(((tempIndicator=== 'C') && (tempActual >= 41  && tempActual <= 50) ) ||
            ((tempIndicator=== 'F') && (tempActual >= 105  && tempActual <= 122) )	) {
              if (this.selectedMinutes() <= 72) {
                 
                result = 'Passed';
             }else{
                 
                result = 'Failed';
             }           
            
          }else if (((tempIndicator=== 'C') && (tempActual > 50) ) ||
            ((tempIndicator=== 'F') && (tempActual >122) )	) {
            
             
            result = 'Failed'; 
          
          }
    return result;
  }


  returnImbruvicaOralSuspenshionSelectedStatus = () => {
    var result = 'Failed';

    var tempActual = this.state.fields.tempActual.value ;
    var tempIndicator = this.state.fields.tempIndicator.value ;
    var userType=this.state.selectedRole;
    if (((tempIndicator === 'C') && (tempActual < 0)) ||
    ((tempIndicator === 'F') && (tempActual < 32))) {
      result = 'Failed';
    } else if (((tempIndicator === 'C') && (tempActual >= 2 && tempActual <= 25)) ||
          ((tempIndicator === 'F') && (tempActual >= 36 && tempActual <= 77))) {
      result = 'Passed';
    } else if (((tempIndicator === 'C') && (tempActual >= 0 && tempActual <= 1)) ||
         ((tempIndicator === 'F') && (tempActual >= 32 && tempActual <= 35))) {
      if (this.selectedMinutes() <= 48) {
        result = 'Passed';
      } else {
        result = 'Failed';
      }
    } else if (((tempIndicator === 'C') && (tempActual >= 26 && tempActual <= 40)) ||
    ((tempIndicator === 'F') && (tempActual >= 78 && tempActual <= 104))) {
   if (this.selectedMinutes() <= 240 && userType === 'PATIENT') {
     result = 'Passed';
   } else if (this.selectedMinutes() <= 120 && userType === 'HCP') {
     result = 'Passed';
   }
   else {
     result = 'Failed';
   }
 } else if (((tempIndicator === 'C') && (tempActual >= 41 && tempActual <= 50)) ||
         ((tempIndicator === 'F') && (tempActual >= 105 && tempActual <= 122))) {
      if (this.selectedMinutes() <= 48) {
        result = 'Passed';
      } else {
        result = 'Failed';
      }
    } else if (((tempIndicator === 'C') && (tempActual > 50)) ||
           ((tempIndicator === 'F') && (tempActual > 122 ))) {
      result = 'Failed';
    }
    return result;
  }
  
  returnImbruvicaTabletSelectedStatus = () => {
    var result = 'Failed';

    var tempActual = this.state.fields.tempActual.value ;
    var tempIndicator = this.state.fields.tempIndicator.value ;
    var userType=this.state.selectedRole;
    if (((tempIndicator === 'C') && (tempActual < -20)) ||
    ((tempIndicator === 'F') && (tempActual < -4))) {
      result = 'Failed';
    } else if (((tempIndicator === 'C') && (tempActual >= -20 && tempActual <= 19)) ||
          ((tempIndicator === 'F') && (tempActual >= -4 && tempActual <= 67))) {
      if (this.selectedMinutes() <= 48) {
        result = 'Passed';
      } else {
        result = 'Failed';
      }
    } else if (((tempIndicator === 'C') && (tempActual >= 20 && tempActual <= 30)) ||
    ((tempIndicator === 'F') && (tempActual >= 68 && tempActual <= 86))) {
      result = 'Passed';
    } else if (((tempIndicator === 'C') && (tempActual >= 31 && tempActual <= 40)) ||
    ((tempIndicator === 'F') && (tempActual >= 87 && tempActual <= 104))) {
   if (this.selectedMinutes() <= 120 && userType === 'PATIENT') {
     result = 'Passed';
   } else if (this.selectedMinutes() <= 240 && userType === 'HCP') {
     result = 'Passed';
   }
   else {
     result = 'Failed';
   }
 } else if (((tempIndicator === 'C') && (tempActual >= 41 && tempActual <= 60)) ||
         ((tempIndicator === 'F') && (tempActual >= 105 && tempActual <= 140))) {
      if (this.selectedMinutes() <= 48) {
        result = 'Passed';
      } else {
        result = 'Failed';
      }
    } else if (((tempIndicator === 'C') && (tempActual > 60)) ||
           ((tempIndicator === 'F') && (tempActual > 140))) {
      result = 'Failed';
    }
    return result;
  }

  returnImbruvicaSelectedStatus = () => {
    var result = 'Failed';

    var tempActual = this.state.fields.tempActual.value;
    var tempIndicator = this.state.fields.tempIndicator.value;
    var userType=this.state.selectedRole;
    if (((tempIndicator === 'C') && (tempActual < -70)) ||
    ((tempIndicator === 'F') && (tempActual <-94))) {
        result = 'Failed';
    } else if (((tempIndicator === 'C') && (tempActual >= 2 && tempActual <= 30)) ||
          ((tempIndicator === 'F') && (tempActual >= 36 && tempActual <= 86))) {
         result = 'Passed';
      
    } else if (((tempIndicator === 'C') && (tempActual >= -70 && tempActual <= -21)) ||
         ((tempIndicator === 'F') && (tempActual >= -94 && tempActual <= -6))) {
        if (this.selectedMinutes() <= 48) {
          result = 'Passed';
        } else {
          result = 'Failed';
        }
  }else if (((tempIndicator === 'C') && (tempActual >= -20 && tempActual <= 1)) ||
  ((tempIndicator === 'F') && (tempActual >= -4 && tempActual <= 35))) {
 if (this.selectedMinutes() <= 96) {
   result = 'Passed';
 } else {
   result = 'Failed';
 }
   }
   else if (((tempIndicator === 'C') && (tempActual >= 31 && tempActual <= 40)) ||
         ((tempIndicator === 'F') && (tempActual >= 87 && tempActual <= 104))) {
        if (this.selectedMinutes() <= 120 && userType === 'PATIENT') {
          result = 'Passed';
        } else if (this.selectedMinutes() <= 240 && userType === 'HCP') {
          result = 'Passed';
        }
        else {
          result = 'Failed';
        }
      } else if (((tempIndicator === 'C') && (tempActual >= 41 && tempActual <= 50)) ||
         ((tempIndicator === 'F') && (tempActual >= 105 && tempActual <= 122))) {
        if (this.selectedMinutes() <= 96) {
          result = 'Passed';
        } else {
          result = 'Failed';
        }
      } else if (((tempIndicator === 'C') && (tempActual > 50)) ||
           ((tempIndicator === 'F') && (tempActual > 122 ))) {
             result = 'Failed';
           }
          

    return result;
  }
  returnJuvedermSyringeAllStatus = () => {
    var result = 'Failed';

    var tempActual = this.state.fields.tempActual.value;
    var tempIndicator = this.state.fields.tempIndicator.value;

    if (((tempIndicator === 'C') && (tempActual < 2)) ||
          ((tempIndicator === 'F') && (tempActual < 36 ))) {
      result = 'Failed';
    } 
    else if (((tempIndicator === 'C') && (tempActual >= 2 && tempActual <= 25)) ||
          ((tempIndicator === 'F') && (tempActual >= 36 && tempActual <= 77))) {
      result = 'Passed';
    } else if (((tempIndicator === 'C') && (tempActual >= 26 && tempActual <= 30)) ||
         ((tempIndicator === 'F') && (tempActual >= 78 && tempActual <= 86))) {
      if (this.selectedMinutes() <= 1440) {
        result = 'Passed';
      } else {
        result = 'Failed';
      }
    } else if (((tempIndicator === 'C') && (tempActual >= 31 && tempActual <= 40)) ||
         ((tempIndicator === 'F') && (tempActual >= 87 && tempActual <= 104))) {
      if (this.selectedMinutes() <= 288) {
        result = 'Passed';
      } else {
        result = 'Failed';
      }
    } else if (((tempIndicator === 'C') && (tempActual >40 )) ||
      ((tempIndicator === 'F') && (tempActual >104 ))) {
      result = 'Failed';
    }

    return result;
  }
  returnJuvedermXCSelectedStatus = () => {
    var result = 'Failed';

    var tempActual = this.state.fields.tempActual.value;
    var tempIndicator = this.state.fields.tempIndicator.value;

    if (((tempIndicator === 'C') && (tempActual < 0)) ||
          ((tempIndicator === 'F') && (tempActual < 32 ))) {
      result = 'Failed';
    } else if (((tempIndicator === 'C') && (tempActual >= 0 && tempActual <= 1)) ||
          ((tempIndicator === 'F') && (tempActual >= 32 && tempActual <= 35))) {
      if (this.selectedMinutes() <= 48) {
        result = 'Passed';
      } else {
        result = 'Failed';
      }
    } else if (((tempIndicator === 'C') && (tempActual >= 2 && tempActual <= 25)) ||
          ((tempIndicator === 'F') && (tempActual >= 36 && tempActual <= 77))) {
      result = 'Passed';
    } else if (((tempIndicator === 'C') && (tempActual >= 26 && tempActual <= 30)) ||
         ((tempIndicator === 'F') && (tempActual >= 78 && tempActual <= 86))) {
      if (this.selectedMinutes() <= 1440) {
        result = 'Passed';
      } else {
        result = 'Failed';
      }
    } else if (((tempIndicator === 'C') && (tempActual >= 31 && tempActual <= 40)) ||
         ((tempIndicator === 'F') && (tempActual >= 87 && tempActual <= 104))) {
      if (this.selectedMinutes() <= 288) {
        result = 'Passed';
      } else {
        result = 'Failed';
      }
    } else if (((tempIndicator === 'C') && (tempActual >40 )) ||
      ((tempIndicator === 'F') && (tempActual >104 ))) {
      result = 'Failed';
    }

    return result;
  }

  selectedMinutes = () => {
    // part of check. for conditional Humira messaging
    const duration =
      parseInt(this.state.fields.days.value, 10) * 24 +
      parseInt(this.state.fields.hours.value, 10) +
      parseInt(this.state.fields.minutes.value, 10) / 60
    return duration;
  }
  

  isHumiraSelectedByPatient = () => {
    return (
      this.state.selectedProduct.label.includes('Humira 40 mg/ 0.8 mL') &&
      this.state.selectedRole === 'PATIENT'
    )
  }
  isHumiraSelectedByPPH= () => {
    return (
      this.state.selectedProduct.label.includes('Humira 40 mg/ 0.8 mL') &&
       this.state.selectedRole === 'HCP'
    )
  }
  
   
  
  isHumiraCitrateFreeSelectedByPatient = () => {
    return (
      this.state.selectedProduct.label.includes('Humira Citrate Free 40 mg/ 0.4 mL') &&
      (this.state.selectedRole === 'PATIENT')
    )
  }
  isHumiraCitrateFreeSelectedByPPH = () => {
    return (
      this.state.selectedProduct.label.includes('Humira Citrate Free 40 mg/ 0.4 mL') &&
      ( this.state.selectedRole === 'HCP')
    )
  }
  

  isRinvoqTabletsSelectedByPatient = () => {
    return (
      this.state.selectedProduct.label.includes('Rinvoq (15 mg, 30 mg, 45 mg tablets)') &&
      (this.state.selectedRole === 'PATIENT' )
    )
  }
  isRinvoqLiquidSelectedByPPH = () => {
    return (
      this.state.selectedProduct.label.includes('Rinvoq Liquid [Rinvoq LQ (1 mg/mL oral solution)]') &&
      ( this.state.selectedRole === 'HCP')
    )
  }
  isRinvoqLiquidSelectedByPatient = () => {
    return (
      this.state.selectedProduct.label.includes('Rinvoq Liquid [Rinvoq LQ (1 mg/mL oral solution)]') &&
      (this.state.selectedRole === 'PATIENT' )
    )
  }
  isRinvoqTabletsSelectedByPPH = () => {
    return (
      this.state.selectedProduct.label.includes('Rinvoq (15 mg, 30 mg, 45 mg tablets)') &&
      ( this.state.selectedRole === 'HCP')
    )
  }
  isDuopaSelected = () => {
    return(
    (this.state.selectedProduct.label.includes('Duopa') || this.state.selectedProduct.label.includes('Duopa®'))
    )
  }


  isSkyriziSelected = () => {
    return(
    (this.state.selectedProduct.label.includes('Skyrizi 600 mg/ 10 mL Vial') 
     || this.state.selectedProduct.label.includes('Skyrizi 360 mg / 2.4 mL Pre-Filled Cartridge with On-Body Delivery System')  || this.state.selectedProduct.label.includes('Skyrizi 180 mg/1.2 mL Pre-Filled Cartridge with On-Body Delivery System') 
      )&&
    (this.state.selectedRole === 'PATIENT' || this.state.selectedRole === 'HCP')
      
    )
  }
  isSkyriziOBISelected = () => {
    return(
    (this.state.selectedProduct.label.includes('Skyrizi 360 mg / 2.4 mL Pre-Filled Cartridge with On-Body Delivery System')  || this.state.selectedProduct.label.includes('Skyrizi 180 mg/1.2 mL Pre-Filled Cartridge with On-Body Delivery System') )&&
    (this.state.selectedRole === 'PATIENT' || this.state.selectedRole === 'HCP')
      
    )
  }
  
  isSkyriziPenSelectedByPatient = () => {
    return (
      this.state.selectedProduct.label.includes('Skyrizi 150 mg/mL Pen') &&
      this.state.selectedRole === 'PATIENT'
    )
  }
  isSkyriziPenSelectedByPPH= () => {
    return (
      this.state.selectedProduct.label.includes('Skyrizi 150 mg/mL Pen') &&
       this.state.selectedRole === 'HCP'
    )
  }
  isSkyriziSyringeSelectedByPatient = () => {
    return (
      this.state.selectedProduct.label.includes('Skyrizi 150 mg/mL Syringe') &&
      this.state.selectedRole === 'PATIENT'
    )
  }
  isSkyriziSyringeSelectedByPPH= () => {
    return (
      this.state.selectedProduct.label.includes('Skyrizi 150 mg/mL Syringe') &&
       this.state.selectedRole === 'HCP'
    )
  }
  
  isImbruvicaSelected = () => {
    return (
      this.state.selectedProduct.label.includes('Imbruvica 70 & 140mg Capsules') &&
      (this.state.selectedRole === 'PATIENT' || this.state.selectedRole === 'HCP')
    )
  }

  isImbruvicaOralSuspensionSelected = () => {
    return (
      this.state.selectedProduct.label.includes('Imbruvica 70mg/mL Oral Suspension') &&
      (this.state.selectedRole === 'PATIENT' || this.state.selectedRole === 'HCP')
    )
  }
  isImbruvicaOralSuspensionSelectedByPatient = () => {
    return (
      this.state.selectedProduct.label.includes('Imbruvica 70mg/mL Oral Suspension') &&
      (this.state.selectedRole === 'PATIENT')
    )
  }
  isImbruvicaOralSuspensionSelectedByPPH = () => {
    return (
      this.state.selectedProduct.label.includes('Imbruvica 70mg/mL Oral Suspension') &&
      (this.state.selectedRole === 'HCP')
    )
  }

  isImbruvicaTabletsSelected = () => {
    return (
      this.state.selectedProduct.label.includes('Imbruvica 140mg, 280mg, 420mg Tablets') &&
      (this.state.selectedRole === 'PATIENT' || this.state.selectedRole === 'HCP')
    )
  }
  
  isJuvedermXCAndJuvedermVolumaXCSelected = () => {
    return (
      (this.state.selectedProduct.label.includes('Juvederm Ultra XC') ||
      this.state.selectedProduct.label.includes('Juvederm Voluma XC')) &&
      (this.state.selectedRole === 'PATIENT' || this.state.selectedRole === 'HCP')
    )
  }

  isJuvedermSyringeAll = () => {
    return (
      (this.state.selectedProduct.label.includes('Juvederm Ultra Plus XC') ||
      this.state.selectedProduct.label.includes('Juvederm Volux XC') ||
      this.state.selectedProduct.label.includes('Juvederm Vollure XC') ||
      this.state.selectedProduct.label.includes('Juvederm Volbella XC') ||
      this.state.selectedProduct.label.includes('Juvederm SkinVive')) &&
      (this.state.selectedRole === 'PATIENT' || this.state.selectedRole === 'HCP')
    )
  }

  isVenetoclaxSelected = () => {
    return (
      this.state.selectedProduct.label.includes('Venetoclax') &&
      (this.state.selectedRole === 'PATIENT' || this.state.selectedRole === 'HCP')
    )
  }

  isLuprondepotSelected = () => {
    return (
      this.state.selectedProduct.label.includes('Lupron Depot') &&
      (this.state.selectedRole === 'PATIENT' || this.state.selectedRole === 'HCP')
    )
  }
  
  isWithinFreezingTempRange = () => {
    if (this.state.fields.tempIndicator.value === 'C') {
      return (
       ( this.state.fields.tempActual.value >= -10  &&
        this.state.fields.tempActual.value <= 14) || 
         ( this.state.fields.tempActual.value >= 26  &&
        this.state.fields.tempActual.value <= 40)
      )
    } else if (this.state.fields.tempIndicator.value === 'F') {
      return (
        (this.state.fields.tempActual.value >= -14 &&
        this.state.fields.tempActual.value <= 58) || 
        (this.state.fields.tempActual.value >= 78 &&
        this.state.fields.tempActual.value <= 104)
      )
    }
  }
 
  isWithinTempRange = () => {
    if (this.state.fields.tempIndicator.value === 'C') {
      return (
        this.state.fields.tempActual.value >= 9 &&
        this.state.fields.tempActual.value <= 25
      )
    } else if (this.state.fields.tempIndicator.value === 'F') {
      return (
        this.state.fields.tempActual.value >= 47 &&
        this.state.fields.tempActual.value <= 77
      )
    }
  }

  isLowerBound = () => {
    // part of check for conditional Humira messaging
    const duration =
      parseInt(this.state.fields.days.value, 10) * 24 +
      parseInt(this.state.fields.hours.value, 10) +
      parseInt(this.state.fields.minutes.value, 10) / 60
    return duration <= 96
  }


  //Added for Humira PPH 
  isWithinTempRangePPH = () => {
    if (this.state.fields.tempIndicator.value === 'C') {
      return (
        this.state.fields.tempActual.value >= 9 &&
        this.state.fields.tempActual.value <= 25
      )
    } else if (this.state.fields.tempIndicator.value === 'F') {
      return (
        this.state.fields.tempActual.value >= 47 &&
        this.state.fields.tempActual.value <= 77
      )
    }
  }

  isLowerBoundPPH = () => {
    // part of check for conditional Humira messaging
    const duration =
      parseInt(this.state.fields.days.value, 10) * 24 +
      parseInt(this.state.fields.hours.value, 10) +
      parseInt(this.state.fields.minutes.value, 10) / 60
    return duration <= 96
  }

  //Added for Humira Patient 
  isWithinTempRangePatient = () => {
    if (this.state.fields.tempIndicator.value === 'C') {
      return (
        this.state.fields.tempActual.value >= 9 &&
        this.state.fields.tempActual.value <= 25
      )
    } else if (this.state.fields.tempIndicator.value === 'F') {
      return (
        this.state.fields.tempActual.value >= 47 &&
        this.state.fields.tempActual.value <= 77
      )
    }
  }

  isLowerBoundPatient = () => {
    // part of check for conditional Humira messaging
    const duration =
      parseInt(this.state.fields.days.value, 10) * 24 +
      parseInt(this.state.fields.hours.value, 10) +
      parseInt(this.state.fields.minutes.value, 10) / 60
    return duration <= 96
  }

  // Resets the form Reset not clearing response options dropdown.
  handleResetForm = () => {
    this.setState({ selectedProduct: null })
    this.handleResetResponse()
    this.clearFields()
  }

  getStabilityCheckStatus = () => {

    try {
      if (this.isLuprondepotSelected()) {
        if (
          this.state.response.result === 'ZERO_TIME' ||
          this.state.response.result === 'MISMATCH' ||
          this.state.fields.tempRange.value === 'BOTH_UNDER_OVER') {
          return 'Failed'
      }
          return this.returnLupronSelectedStatus();
        
        } }catch (e) {}
    try {
    if (this.isBotoxSelected()) {
          if (
            this.state.response.result === 'ZERO_TIME' ||
            this.state.response.result === 'MISMATCH' ||
            this.state.fields.tempRange.value === 'BOTH_UNDER_OVER') {
            return 'Failed'
        }
          return this.returnBotoxSelectedStatus();
        
        } }catch(e) {}
    
    try {
    if (this.isImbruvicaSelected()) {
        if (
          this.state.response.result === 'ZERO_TIME' ||
          this.state.response.result === 'MISMATCH') {
          return 'Failed'
      }
        return this.returnImbruvicaSelectedStatus();
      
      } }catch (e) {}

      try {
        if (this.isImbruvicaTabletsSelected()) {
            if (
              this.state.response.result === 'ZERO_TIME' ||
              this.state.response.result === 'MISMATCH') {
              return 'Failed'
          }
            return this.returnImbruvicaTabletSelectedStatus();
          
          } }catch (e) {}
      try {
        if (this.isImbruvicaOralSuspensionSelected()) {
            if (
              this.state.response.result === 'ZERO_TIME' ||
              this.state.response.result === 'MISMATCH') {
              return 'Failed'
          }
            return this.returnImbruvicaOralSuspenshionSelectedStatus();
          
          } }catch (e) {}
      try {
        if (this.isSkyriziPenSelectedByPatient()) {
            if (
              this.state.response.result === 'ZERO_TIME' ||
              this.state.response.result === 'MISMATCH') {
              return 'Failed'
          }
            return this.returnSkyriziPenPatientSelectedStatus();
          
          } }catch (e) {}
      try {
        if (this.isSkyriziPenSelectedByPPH()) {
            if (
              this.state.response.result === 'ZERO_TIME' ||
              this.state.response.result === 'MISMATCH') {
              return 'Failed'
          }
            return this.returnSkyriziPenPPHSelectedStatus();
          
          } }catch (e) {}
      try {
        if (this.isSkyriziSyringeSelectedByPatient()) {
            if (
              this.state.response.result === 'ZERO_TIME' ||
              this.state.response.result === 'MISMATCH') {
              return 'Failed'
          }
            return this.returnSkyriziSyringePatientSelectedStatus();
          
          } }catch (e) {}
      try {
        if (this.isSkyriziSyringeSelectedByPPH()) {
            if (
              this.state.response.result === 'ZERO_TIME' ||
              this.state.response.result === 'MISMATCH') {
              return 'Failed'
          }
            return this.returnSkyriziSyringePPHSelectedStatus();
          
          } }catch (e) {}
      try {
        if (this.isRinvoqTabletsSelectedByPatient()) {
            if (
              this.state.response.result === 'ZERO_TIME' ||
              this.state.response.result === 'MISMATCH') {
              return 'Failed'
          }
            return this.returnRinvoqTabletsPatientSelectedStatus();
          
          } }catch (e) {}
      try {
        if (this.isRinvoqTabletsSelectedByPPH()) {
            if (
              this.state.response.result === 'ZERO_TIME' ||
              this.state.response.result === 'MISMATCH') {
              return 'Failed'
          }
            return this.returnRinvoqTabletsPPHSelectedStatus();
          
          } }catch (e) {}
      try {
        if (this.isHumiraCitrateFreeSelectedByPatient()) {
            if (
              this.state.response.result === 'ZERO_TIME' ||
              this.state.response.result === 'MISMATCH') {
              return 'Failed'
          }
            return this.returnHumiraCitrateFreePatientSelectedStatus();
          
          } }catch (e) {}
      try {
        if (this.isHumiraCitrateFreeSelectedByPPH()) {
            if (
              this.state.response.result === 'ZERO_TIME' ||
              this.state.response.result === 'MISMATCH') {
              return 'Failed'
          }
            return this.returnHumiraCitrateFreePPHSelectedStatus();
          
          } }catch (e) {}

      try {
        if (this.isRinvoqLiquidSelectedByPatient()) {
            if (
              this.state.response.result === 'ZERO_TIME' ||
              this.state.response.result === 'MISMATCH') {
              return 'Failed'
          }
            return this.returnRinvoqLiquidPatientSelectedStatus();
          
          } }catch (e) {}
      try {
        if (this.isRinvoqLiquidSelectedByPPH()) {
            if (
              this.state.response.result === 'ZERO_TIME' ||
              this.state.response.result === 'MISMATCH') {
              return 'Failed'
          }
            return this.returnRinvoqLiquidPPHSelectedStatus();
          
          } }catch (e) {}    
      
      try {
        if (this.isJuvedermSyringeAll() ) {
              if (
                this.state.response.result === 'ZERO_TIME' ||
                this.state.response.result === 'MISMATCH')  {
                return 'Failed'
              }
              return this.returnJuvedermSyringeAllStatus();
          } }catch(e) {}
      try {
       if (this.isJuvedermXCAndJuvedermVolumaXCSelected()) {
            if (
            this.state.response.result === 'ZERO_TIME' ||
            this.state.response.result === 'MISMATCH')  {
            return 'Failed'
          }
          return this.returnJuvedermXCSelectedStatus();
      } }catch(e) {}

    if (!this.state.response || !this.state.response.result) {
      return 'Failed'
    }

    if (this.state.response.result === 'CUSTOMER_SERVICE' ||
      this.state.response.result === 'ZERO_TIME' ||
      this.state.response.result === 'MISMATCH') {
      return 'Failed'
    }

    if (this.state.response.result === 'UNABLE_TO_ASSESS') { return 'UnableToAssess' }
    return 'Passed'
  }

  getResultRelatedClass = classType => {
    const status = this.getStabilityCheckStatus()

    switch (classType) {
      case 'ANSWER_BOX':
        switch (status) {
          case 'Passed':
            return 'stability-success'
          case 'Failed':
            return 'stability-error'
          case 'UnableToAssess':
            return 'stability-unableToAssess'
          default:
            break
        }
        break
      case 'ANSWER_COLOR':
        switch (status) {
          case 'Passed':
            return 'stability-color-good'
          case 'Failed':
            return 'stability-color-bad'
          case 'UnableToAssess':
            return 'stability-color-unableToAssess'
          default:
            break
        }
        break
      case 'ANSWER_ICON':
        switch (status) {
          case 'Passed':
            return 'fa-check-circle'
          case 'Failed':
            return 'fa-times-circle'
          case 'UnableToAssess':
            return 'fa-question-circle'
          default:
            break
        }
        break
      default:
        break
    }

    return ''
  }

  areDurationFieldsVisible = () => {
    return this.state.fields.tempRange.value &&
      this.state.fields.tempActual.value &&
      (!this.state.fields.tempActual.errors ||
        this.state.fields.tempActual.errors.length === 0) &&
      this.state.fields.tempIndicator.value &&
      this.state.fields.tempRange.value !== 'BOTH_UNDER_OVER' &&
      this.state.selectedProduct !== null &&
      this.state.selectedProduct.case !== 'OTHER'
  }

  isCalculateFieldEnabled = () => {
    return this.areDurationFieldsVisible()
  }

  renderActualTemp = () => {
    return (
      [
        <div className='col-lg-2' key='tempActual'>
          <InputGroup
            type='number'
            field={this.state.fields.tempActual}
            validate={this.validate}
            onChange={this.handleResetResponse}
          />
        </div>,
        <div className='col-lg-1' key='tempIndicator'>
          <Select
            searchable
            clearable={false}
            disabled={false}
            options={this.tempOptions}
            field={this.state.fields.tempIndicator}
            deleteRemoves={false}
            backspaceRemoves={false}
            validate={this.validate}
            onChange={this.handleResetResponse}
          />
        </div>
      ])
  }

  renderActualTempMobile = () => {
    return (
      <table style={{ marginLeft: '10px', marginRight: '10px', width: '100%' }}>
        <tbody>
          <tr>
            <td>
              <InputGroup
                type='number'
                field={this.state.fields.tempActual}
                validate={this.validate}
                onChange={this.handleResetResponse}
              />
            </td>
            <td style={{ paddingLeft: '20px', verticalAlign: 'top' }}>
              <Select
                minWidth='80px'
                searchable
                clearable={false}
                disabled={false}
                options={this.tempOptions}
                field={this.state.fields.tempIndicator}
                deleteRemoves={false}
                backspaceRemoves={false}
                validate={this.validate}
                onChange={this.handleResetResponse}
              />
            </td>
          </tr>
        </tbody>
      </table>
    )
  }

  renderDuration = () => {
    return (
      <div className='row'>
        <div className='col-lg-2'>
          <Select
            searchable
            clearable={false}
            disabled={false}
            options={this.dayOptions}
            field={this.state.fields.days}
            deleteRemoves={false}
            backspaceRemoves={false}
            validate={this.validate}
            onChange={this.handleResetResponse}
          />
          {/* <InputGroup
                            type="number"
                            field={this.state.fields.days}
                            validate={this.validate}
                            onChange={this.handleResetResponse}
                          /> */}
        </div>
        <div className='col-lg-2'>
          <Select
            searchable
            clearable={false}
            disabled={false}
            options={this.hourOptions}
            field={this.state.fields.hours}
            deleteRemoves={false}
            backspaceRemoves={false}
            validate={this.validate}
            onChange={this.handleResetResponse}
          />
          {/* <InputGroup
                            type="number"
                            field={this.state.fields.hours}
                            validate={this.validate}
                            onChange={this.handleResetResponse}
                          /> */}
        </div>
        <div className='col-lg-2'>
          <Select
            searchable
            clearable={false}
            disabled={false}
            options={this.minuteOptions}
            field={this.state.fields.minutes}
            deleteRemoves={false}
            backspaceRemoves={false}
            validate={this.validate}
            onChange={this.handleResetResponse}
          />
          {/* <InputGroup
                            type="number"
                            field={this.state.fields.minutes}
                            validate={this.validate}
                            onChange={this.handleReset}
                          /> */}
        </div>
      </div>)
  }

  renderDurationMobile = () => {
    return (
      <table style={{ marginRight: '10px', width: '100%' }}>
        <tbody>
          <tr>
            <td>
              <Select
                searchable
                clearable={false}
                disabled={false}
                options={this.dayOptions}
                field={this.state.fields.days}
                deleteRemoves={false}
                backspaceRemoves={false}
                validate={this.validate}
                onChange={this.handleResetResponse}
              />
            </td>
            <td style={{ paddingLeft: '20px', verticalAlign: 'top' }}>
              <Select
                searchable
                clearable={false}
                disabled={false}
                options={this.hourOptions}
                field={this.state.fields.hours}
                deleteRemoves={false}
                backspaceRemoves={false}
                validate={this.validate}
                onChange={this.handleResetResponse}
              />
            </td>
            <td style={{ paddingLeft: '20px', verticalAlign: 'top' }}>
              <Select
                searchable
                clearable={false}
                disabled={false}
                options={this.minuteOptions}
                field={this.state.fields.minutes}
                deleteRemoves={false}
                backspaceRemoves={false}
                validate={this.validate}
                onChange={this.handleResetResponse}
              />
            </td>
          </tr>
        </tbody>
      </table>)
  }

  render() {
    // Added this code to redirect to NoAccessTET temporarily
   // window.location.href = "/noaccesstet";
    // TODO: Ideally, setState should not be called in a render method
    if (!this.state.fields.days.value) {
      const { fields } = this.state
      if (!fields.days.value) {
        fields.days.value = '0'
      }

      if (!fields.hours.value) {
        fields.hours.value = '0'
      }

      if (!fields.minutes.value) {
        fields.minutes.value = '0'
      }
      this.setState({ fields })
    }

    const content = this.props.userType !== PATIENT ? this.props.pageContent.content.module.stabilityTool : this.props.pageContent.content.module.patientStabilityTool

    return (
      
      <div className='page-container'>
        <div className='page-content'>
          <HeroImage title={content.title} imageDesktop={imgHeaderStabilityTool} imageMobile={imgHeaderStabilityToolMobile} />
          <div id='stability-tool' className='container stability-container'>
            <div className='row'>
              <div className='col-12'>
                {
                  this.props.userType && this.props.userType !== PATIENT
                    ? <StabilityHeader content={content} />
                    : <PatientStabilityHeader content={content} />
                }
                {
                  this.props.userType !== PATIENT && 
                  <StabilityStep
                  title={content.TETExposedQuestion}
                  content={
                    <div className='row'>
                      <div className='col-12'>
                        <label className='custom-control custom-radio'>
                          <input
                            id='radio-one'
                            className='custom-control-input'
                            type='radio'
                            value='ONE'
                            name='temperatueExcursionType'
                            onChange={this.handleSelectedTemperatueExcursionType}
                            checked={this.state.selectedTemperatueExcursionType === 'ONE'}
                            
                          />
                          <span className='custom-control-indicator' />
                          <span className='custom-control-description'>
                          {content.oneTemperatureExcursion}
                          </span>
                        </label>
                        <label className='custom-control custom-radio'>
                          <input
                            id='radio-multiple'
                            className='custom-control-input'
                            type='radio'
                            value='MULTIPLE'
                            name='temperatueExcursionType'
                             
                            onChange={this.handleSelectedTemperatueExcursionType}
                            checked={this.state.selectedTemperatueExcursionType === 'MULTIPLE'}
                          />
                          <span className='custom-control-indicator' />
                          <span className='custom-control-description'>
                          {content.MultipleTemperatureExcursions}
                          </span>
                        </label>
                      </div>
                    </div>
                  }
                />
                }
                {
                  this.props.userType !== PATIENT && this.state.selectedTemperatueExcursionType === 'MULTIPLE' && (
                    <div className='stability-rec col-6'>
                    <table style={{ margin: '10px' }}>
                    <tbody>
                      <tr>
                        <td style={{verticalAlign: 'top'}}>
                          <span
                            style={{
                              color: '#51C0EF',
                              fontSize: '28px',
                              padding: '0px 10px 0px 0px'
                            }}
                            className='fa fa-info-circle'
                          />
                        </td>
                        <td>
                          <p><b>
                          {content.MultipleTETContent}
                          </b></p>
                          <button
                      className={`btn btn-info btn-lg-wide submit-button btn-icon btn-rounded m-r-10`}
                      value={null}
                      onClick={this.handleSelectedTemperatueExcursionType}
                      style={{marginTop: '5px'}}
                    >
                      {content.MultipleTETAgree}
                    </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  </div>
                  ) 
                }
                {
                  this.props.userType === PATIENT && 
                  <StabilityStep
                  title={content.TETExposedQuestion}
                  content={
                    <div className='row'>
                      <div className='col-12'>
                        <label className='custom-control custom-radio'>
                          <input
                            id='radio-one'
                            className='custom-control-input'
                            type='radio'
                            value='ONE'
                            name='temperatueExcursionType'
                            onChange={this.handleSelectedTemperatueExcursionType}
                            checked={this.state.selectedTemperatueExcursionType === 'ONE'}
                            
                          />
                          <span className='custom-control-indicator' />
                          <span className='custom-control-description'>
                          {content.oneTemperatureExcursion}
                          </span>
                        </label>
                        <label className='custom-control custom-radio'>
                          <input
                            id='radio-multiple'
                            className='custom-control-input'
                            type='radio'
                            value='MULTIPLE'
                            name='temperatueExcursionType'
                             
                            onChange={this.handleSelectedTemperatueExcursionType}
                            checked={this.state.selectedTemperatueExcursionType === 'MULTIPLE'}
                          />
                          <span className='custom-control-indicator' />
                          <span className='custom-control-description'>
                          {content.MultipleTemperatureExcursions}
                          </span>
                        </label>
                      </div>
                    </div>
                  }
                />
                }
                {
                  this.props.userType === PATIENT && this.state.selectedTemperatueExcursionType === 'MULTIPLE' && (
                    <div className='stability-rec col-6'>
                    <table style={{ margin: '10px' }}>
                    <tbody>
                      <tr>
                        <td style={{verticalAlign: 'top'}}>
                          <span
                            style={{
                              color: '#51C0EF',
                              fontSize: '28px',
                              padding: '0px 10px 0px 0px'
                            }}
                            className='fa fa-info-circle'
                          />
                        </td>
                        <td>
                          <p><b>
                          {content.MultipleTETContent}
                          </b></p>
                          <button
                      className={`btn btn-info btn-lg-wide submit-button btn-icon btn-rounded m-r-10`}
                      value={null}
                      onClick={this.handleSelectedTemperatueExcursionType}
                      style={{marginTop: '5px'}}
                    >
                      {content.MultipleTETAgree}
                    </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  </div>
                  ) 
                }
                {
                  this.props.userType && this.props.userType !== PATIENT && this.state.selectedTemperatueExcursionType === 'ONE' ? (
                    <StabilityStep
                      title={`${content.userQuestion}*`}
                      content={
                        <div className='row'>
                          <div className='col-12'>
                            <label className='custom-control custom-radio'>
                              <input
                                id='radio-hcp'
                                className='custom-control-input'
                                type='radio'
                                value='HCP'
                                name='userType'
                                onChange={this.handleSelectedRole}
                                checked={this.state.selectedRole === 'HCP'}
                                
                              />
                              <span className='custom-control-indicator' />
                              <span className='custom-control-description'>
                                {content.pph}
                              </span>
                            </label>
                            <label className='custom-control custom-radio'>
                              <input
                                id='radio-patient'
                                className='custom-control-input'
                                type='radio'
                                value='PATIENT'
                                name='userType'
                                 
                                onChange={this.handleSelectedRole}
                                checked={this.state.selectedRole === 'PATIENT'}
                              />
                              <span className='custom-control-indicator' />
                              <span className='custom-control-description'>
                                {content.hcp}
                              </span>
                            </label>
                          </div>
                        </div>
                      }
                    />
                  ) : null
                }
                {this.state.selectedRole && this.state.selectedTemperatueExcursionType === 'ONE' ? (
                  <StabilityStep
                    title={content.productName}
                    content={
                      <div className='row'>
                        <div className='col-lg-5'>
                          <Select
                           
                            searchable
                            clearable={false}
                            options={this.state.products}
                            field={this.state.fields.productName}
                            deleteRemoves={false}
                            backspaceRemoves={false}
                            validate={this.validate}
                            onChange={this.handleSelectedProduct}
                          />
                        </div>
                        <div
                          className='col-lg-1'
                          style={{ paddingTop: (isMobileDevice() ? '10px' : '') }}
                        />
                        <div
                          className='col-lg-6 stability-rec'
                          style={{
                            margin: (isMobileDevice() ? '10px' : ''),
                            display: (this.state.selectedProduct ? '' : 'none')
                          }}
                        >
                          <table style={{ margin: '8px 0px 8px 0px' }}>
                            <tbody>
                              <tr>
                                <td>
                                  <span
                                    style={{
                                      color: '#51C0EF',
                                      fontSize: '28px',
                                      padding: '0px 10px 0px 0px'
                                    }}
                                    className='fa fa-info-circle'
                                  />
                                </td>
                                <td>
                                  <b>
                                    {this.state.selectedProduct
                                      ? this.getSelectedProductMessage(
                                        this.state.selectedProduct
                                      )
                                      : ''}
                                  </b>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    }
                  />
                ) : null}
                {this.state.selectedProduct && this.state.selectedProduct.case !== 'OTHER' && this.state.selectedTemperatueExcursionType === 'ONE'
                  ? (
                    <StabilityStep
                      title={content.tempQuestion}
                      noPadding={true}
                      content={
                        <React.Fragment>
                          <div className='row stability-step'>
                            <div className='col-lg-5'>
                              <Select
                                searchable
                                clearable={false}
                                disabled={false}
                                options={this.state.ranges}
                                field={this.state.fields.tempRange}
                                deleteRemoves={false}
                                backspaceRemoves={false}
                                validate={this.validate}
                                onChange={this.handleResetResponse}
                              />
                            </div>
                            <div
                              className='col-lg-1'
                              style={{ paddingTop: (isMobileDevice() ? '10px' : '') }}
                            />
                            {this.state.fields.tempRange.value === 'BOTH_UNDER_OVER' ? (
                              <div
                                className='col-lg-6 stability-error'
                                style={{
                                  margin: (isMobileDevice() ? '10px' : '')
                                }}
                              >
                                <table style={{ margin: '8px 0px 8px 0px' }}>
                                  <tbody>
                                    <tr>
                                      <td>
                                        <span
                                          style={{
                                            color: 'red',
                                            fontSize: '28px',
                                            padding: '0px 10px 0px 0px'
                                          }}
                                          className='fa fa-times-circle'
                                        />
                                      </td>
                                      <td>
                                        <Answer
                                          userType={this.props.userType}
                                          response={{ result: 'CUSTOMER_SERVICE' }}
                                          messages={{ bad: content.customerService, badPatient: content.haveQuestions }}
                                          pleaseCall={content.pleaseCall}
                                          selectedProduct={this.state.selectedProduct}
                                          tempIndicator={this.state.fields.tempIndicator.value}
                                          tempActual={this.state.fields.tempActual.value}
                                          tempRangeValue={this.state.fields.tempRange.value}
                                          selectedRole={this.state.selectedRole}
                                          selectedMinutes={this.selectedMinutes}
                                          isBotoxSelected = {this.isBotoxSelected}
                                          isLuprondepotSelected={this.isLuprondepotSelected}
                                          isImbruvicaSelected = {this.isImbruvicaSelected}
                                          isSkyriziSelected= {this.isSkyriziSelected}
                                          isSkyriziOBISelected={this.isSkyriziOBISelected}
                                          isDuopaSelected={this.isDuopaSelected}
                                         
                                          isHumiraCitrateFreeSelectedByPatient={this.isHumiraCitrateFreeSelectedByPatient}
                                          isHumiraCitrateFreeSelectedByPPH={this.isHumiraCitrateFreeSelectedByPPH}
                                          isImbruvicaTabletsSelected= {this.isImbruvicaTabletsSelected}
                                          isRinvoqTabletsSelectedByPatient={this.isRinvoqTabletsSelectedByPatient}
                                          isRinvoqTabletsSelectedByPPH={this.isRinvoqTabletsSelectedByPPH}
                                          isRinvoqLiquidSelectedByPatient={this.isRinvoqLiquidSelectedByPatient}
                                          isRinvoqLiquidSelectedByPPH={this.isRinvoqLiquidSelectedByPPH}
                                          isJuvedermXCAndJuvedermVolumaXCSelected = {this.isJuvedermXCAndJuvedermVolumaXCSelected}
                                          isJuvedermSyringeAll = {this.isJuvedermSyringeAll}
                                          isWithinTempRange={this.isWithinTempRange}
                                          isWithinTempRangePPH={this.isWithinTempRangePPH}
                                          isWithinTempRangePatient={this.isWithinTempRangePatient}
                                          isImbruvicaOralSuspensionSelected = {this.isImbruvicaOralSuspensionSelected}
                                          isImbruvicaOralSuspensionSelectedByPatient={this.isImbruvicaOralSuspensionSelectedByPatient}
                                          isImbruvicaOralSuspensionSelectedByPPH={this.isImbruvicaOralSuspensionSelectedByPPH}
                                          isLowerBound={this.isLowerBound}
                                          isLowerBoundPPH={this.isLowerBoundPPH}
                                          isLowerBoundPatient={this.isLowerBoundPatient}
                                          isHumiraSelectedByPatient={this.isHumiraSelectedByPatient}
                                          isHumiraSelectedByPPH={this.isHumiraSelectedByPPH}
                                          isSkyriziPenSelectedByPatient={this.isSkyriziPenSelectedByPatient}
                                          isSkyriziPenSelectedByPPH={this.isSkyriziPenSelectedByPPH}
                                          isSkyriziSyringeSelectedByPatient={this.isSkyriziSyringeSelectedByPatient}
                                          isSkyriziSyringeSelectedByPPH={this.isSkyriziSyringeSelectedByPPH}
                                          content={content}
                                          preferredTemp={this.preferredTemp}
                                        />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            ) : null}
                          </div>
                          {
                            this.state.selectedTemperatueExcursionType === 'ONE' &&
                            this.state.fields.tempRange.value !== 'BOTH_UNDER_OVER' &&
                            this.state.fields.tempRange.value &&
                            !isMobileDevice() &&
                            <StabilityStep
                              title={content.temperature}
                              message={content.tempHelper}
                              showTooltipOnFirstTitle={true}
                              content={
                                <div className='row'>
                                  {this.renderActualTemp()}
                                </div>
                              }
                            />
                          }
                        </React.Fragment>
                      }
                    />
                  ) : null}

                {/* For mobile - show actual temp as a step in a new row */}
                {isMobileDevice() &&
                  this.state.selectedProduct &&
                  this.state.selectedProduct.case !== 'OTHER' &&
                  this.state.fields.tempRange.value !== 'BOTH_UNDER_OVER' &&
                  this.state.fields.tempRange.value
                  ? (
                    <StabilityStep
                      title={content.temperature}
                      message={content.tempHelper}
                      content={
                        <div className='row'>
                          {this.renderActualTempMobile()}
                        </div>
                      }
                    />
                  ) : null}
                {
                this.state.selectedTemperatueExcursionType === 'ONE' &&
                this.areDurationFieldsVisible() ? (
                  <StabilityStep
                    title={`${content.durationQuestion}*`}
                    content={isMobileDevice() ? this.renderDurationMobile() : this.renderDuration()}
                  />
                ) : null}
                {this.state.selectedTemperatueExcursionType === 'ONE' && (
                <div className='row'>
                  <div className='col-lg-6 submit-reset-panel'>
                    <button
                      className={`btn ${this.isCalculateFieldEnabled() ? 'btn-info' : 'btn-info-no-hover'} btn-lg-wide submit-button btn-icon btn-rounded m-r-10`}
                      disabled={!this.isCalculateFieldEnabled()}
                      onClick={this.handleCalculate}
                      style={{}}
                    >
                      {content.calculate}
                    </button>
                    <button
                      type='button'
                      onClick={this.handleResetForm}
                      className='btn btn-primary btn-outline hover btn-lg btn-icon reset-button btn-rounded'
                    >
                      <span>{content.reset}</span>
                    </button>
                  </div>
                  <div
                    className={`col-lg-6 ${this.getResultRelatedClass('ANSWER_BOX')}`}
                    style={{
                      margin: (isMobileDevice() ? '10px' : ''),
                      display: (this.state.response ? '' : 'none')
                    }}
                  >
                    <table style={{ margin: '8px 0px 8px 0px' }}>
                      <tbody>
                        <tr>
                          <td>
                            <span
                              style={{
                                fontSize: '28px',
                                padding: '0px 10px 0px 0px',
                                color: (this.getStabilityCheckStatus() === 'UnableToAssess' ? 'gold' : '')
                              }}
                              className={`${this.getResultRelatedClass('ANSWER_COLOR')} fa ${this.getResultRelatedClass('ANSWER_ICON')}`}
                            />
                          </td>
                          <td>
                            <Answer
                              userType={this.props.userType}
                              response={this.state.response}
                              messages={{
                                recommended: content.recommended,
                                contingent: content.contingent,
                                // AS
                                // eslint-disable-next-line spellcheck/spell-checker
                                contingentLupron: content.contingentLupron,
                                contingentLupronHCP: content.contingentLupronHCP,
                                bad: content.customerService, 
                                badPatient: content.haveQuestions,
                                unableToAssess: content.unableToAssess,
                                mismatch: content.mismatch,
                                zeroTime: content.zeroTime
                              }}
                              pleaseCall={content.pleaseCall}
                              selectedProduct={this.state.selectedProduct}
                              tempIndicator={this.state.fields.tempIndicator.value}
                              tempActual={this.state.fields.tempActual.value}
                              selectedRole={this.state.selectedRole}
                              tempRangeValue={this.state.fields.tempRange.value}
                              selectedMinutes={this.selectedMinutes}
                              isBotoxSelected = {this.isBotoxSelected}
                              
                              isHumiraCitrateFreeSelectedByPatient={this.isHumiraCitrateFreeSelectedByPatient}
                              isHumiraCitrateFreeSelectedByPPH={this.isHumiraCitrateFreeSelectedByPPH}
                              isHumiraSelectedByPatient={this.isHumiraSelectedByPatient}
                              isHumiraSelectedByPPH={this.isHumiraSelectedByPPH}
                              isSkyriziPenSelectedByPatient={this.isSkyriziPenSelectedByPatient}
                              isSkyriziPenSelectedByPPH={this.isSkyriziPenSelectedByPPH}
                              isSkyriziSyringeSelectedByPatient={this.isSkyriziSyringeSelectedByPatient}
                              isSkyriziSyringeSelectedByPPH={this.isSkyriziSyringeSelectedByPPH}
                              isSkyriziSelected={this.isSkyriziSelected}
                              isDuopaSelected={this.isDuopaSelected}
                              isSkyriziOBISelected={this.isSkyriziOBISelected}
                              isRinvoqTabletsSelectedByPatient={this.isRinvoqTabletsSelectedByPatient}
                              isRinvoqTabletsSelectedByPPH={this.isRinvoqTabletsSelectedByPPH}
                              isRinvoqLiquidSelectedByPatient={this.isRinvoqLiquidSelectedByPatient}
                              isRinvoqLiquidSelectedByPPH={this.isRinvoqLiquidSelectedByPPH}
                              isLuprondepotSelected={this.isLuprondepotSelected}
                              isVenetoclaxSelected={this.isVenetoclaxSelected}
                              isImbruvicaSelected={this.isImbruvicaSelected}
                              isImbruvicaTabletsSelected= {this.isImbruvicaTabletsSelected}
                              isJuvedermXCAndJuvedermVolumaXCSelected={this.isJuvedermXCAndJuvedermVolumaXCSelected}
                              isJuvedermSyringeAll = {this.isJuvedermSyringeAll}
                              isImbruvicaOralSuspensionSelected = {this.isImbruvicaOralSuspensionSelected}
                              isImbruvicaOralSuspensionSelectedByPatient={this.isImbruvicaOralSuspensionSelectedByPatient}
                              isImbruvicaOralSuspensionSelectedByPPH={this.isImbruvicaOralSuspensionSelectedByPPH}
                              isWithinTempRange={this.isWithinTempRange}
                              isWithinTempRangePPH={this.isWithinTempRangePPH}
                              isWithinTempRangePatient={this.isWithinTempRangePatient}
                              isWithinFreezingTempRange={this.isWithinFreezingTempRange}
                              isLowerBound={this.isLowerBound}
                              isLowerBoundPPH={this.isLowerBoundPPH}
                              isLowerBoundPatient={this.isLowerBoundPatient}
                              content={content}
                              preferredTemp={this.preferredTemp}
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                )}
                <br />
                {
                  this.props.userType && this.props.userType !== PATIENT ? (
                    <div className='row'>
                      <div className='col-12'>
                        <div>
                          {content.caveatStart}
                          <a href='tel:8446633742' className='anchor-link'>(844) 663-3742</a>
                          {content.caveatMiddle}
                          <a href='tel:8446633742' className='anchor-link'>(844) 663-3742</a>
                          {content.caveatEnd}
                          <Link
                            data-tag='track-link'
                            className='anchor-link'
                            data-analytics-text='Submit Inquiry'
                            to='/submit-inquiry'>
                            {content.inquiry}
                          </Link>.
                        </div>
                      </div>
                    </div>)
                    : <div className='row'>
                      <div className='col-12'>
                        <div>
                          {content.caveatStart}
                          <Link
                            to='/products'
                            className='anchor-link'
                            data-tag='track-link'
                            data-analytics-text='Browse Products'
                          >
                            {content.productLabelLink}
                          </Link>.

                          <div style={{ marginTop: '1rem' }}>{content.caveatMiddle}
                            <a
                              href='tel:8446633742'
                              className='anchor-link'
                            >
                              (844) 663-3742
                            </a>.
                          </div>
                          <div style={{ marginTop: '1rem' }}>{content.caveatEnd}
                          </div>
                        </div>
                      </div>
                    </div>
                }

                <br />
                <div className='row'>
                  <div className='col-12'>
                    <div>{content.footer}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    )
  }
}

function StabilityHeader(props) {
  return (
    <div>
      <div className='row'>
        <div className='col-lg-10'>
          <p className='text-left subtitle'>{props.content.subTitle}
          </p>
        </div>
        <div className='col-lg-2'>
          <p className='text-right required-indic'>
            <strong>*{props.content.required}</strong>
          </p>
        </div>
      </div>
    </div>
  )
}

function PatientStabilityHeader (props) {
  return (
    <React.Fragment>
      <div>
        <div className='row'>
          <div className='col-lg-10'>
            <div className='row title'>
              <strong className='col-12'>{props.content.header}</strong>
            </div>
            <p className='text-left subtitle'>{props.content.subTitle}</p>
            <p className='text-left subtitle'><strong>{props.content.subTitle2}</strong></p>
            <ol>
              <li className='subtitle'>{props.content.subTitle7}  </li>
              <li className='subtitle column-overflow'>{props.content.subTitle3} <a href='tel:8446633742' className='anchor-link'>(844) 663-3742</a>. </li>
              <li className='subtitle'>{props.content.subTitle4}  </li>
              <li className='subtitle'>{props.content.subTitle5} </li>
            </ol>
            <p className='text-left subtitle'>{props.content.subTitle6}</p>
          </div>
          <div className='col-lg-2'>
            <p className='text-right required-indic'>
              <strong>*{props.content.required}</strong>
            </p>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

function Title(props) {
  return typeof props.name === 'string' ? (
    <div className='row title'>
      <strong className='col-12'>
        {props.name}
        {
          props.showTooltipOnFirstTitle &&
          <React.Fragment>
            {' '}
            <span id='temp-helper' className='fa fa-question-circle' />
            <UncontrolledTooltip
              placement='top'
              target='temp-helper'
              className='tooltip-primary'
            >
              {props.message}
            </UncontrolledTooltip>
          </React.Fragment>
        }
      </strong>
    </div>
  ) : (
    <div className='row title'>
      <strong className='col-lg-6'>{props.name[0]}</strong>
      <strong className='col-lg-6'>
        {props.name[1]}{' '}
        <span id='temp-helper' className='fa fa-question-circle' />
        <UncontrolledTooltip
          placement='top'
          target='temp-helper'
          className='tooltip-primary'
        >
          {props.message}
        </UncontrolledTooltip>
      </strong>
    </div>
  )
}

function StabilityStep(props) {
  return (
    <div className={props.noPadding ? '' : 'stability-step'}>
      <Title name={props.title} message={props.message} showTooltipOnFirstTitle={props.showTooltipOnFirstTitle} />
      {props.content}
    </div>
  )
}

function Answer(props) {
  if (!props.response || !props.selectedProduct) {
    return null
  }
  const rec = props.selectedProduct.content.recommendedRange
  let recRangeMessage
  if (props.preferredTemp === 'F') {
    recRangeMessage = ` ${rec.minRangeF} °F to ${rec.maxRangeF} °F (${rec.minRangeC} °C to ${rec.maxRangeC} °C ). `
  } else {
    recRangeMessage = ` ${rec.minRangeC} °C to ${rec.maxRangeC} °C (${rec.minRangeF} °F to ${rec.maxRangeF} °F). `
  }
  let message =
    props.pleaseCall + ' ' + props.content.phoneNumber + '.'
  let highlightClass = 'stability-color-good'
  switch (props.response.result) {
    case 'CUSTOMER_SERVICE':
    if (props.userType !== PATIENT) {



      if (props.isSkyriziSelected() || props.isDuopaSelected() ||  props.isImbruvicaOralSuspensionSelected() || props.isImbruvicaTabletsSelected() || props.isImbruvicaSelected()) {
        
        if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
          message = props.messages.bad 
          message = message + '\n\n'+ props.content.patientAdditionalQuestions + '\n\n' + props.content.haveQuestions
        }else{
          message = props.messages.bad + '\n\n' + message
        }
      }else{ 
        message = props.messages.bad + '\n\n' +  message
      }
      highlightClass = 'stability-color-bad'
      // resultIcon = ""; /* "fa-times-circle"; */
    } else{
      message = props.messages.bad + '\n \n' + message + '\n \n' + props.messages.badPatient
      highlightClass = 'stability-color-bad'
      // resultIcon = ""; /* "fa-times-circle"; */
    }

    
    if(props.isLuprondepotSelected()){
      message = props.content.notRecommendedLupron
      highlightClass = 'stability-color-bad' 
    if (((props.tempIndicator=== 'C') && (props.tempActual < -10) ) ||
      ((props.tempIndicator=== 'F') && (props.tempActual <14) )	){
       message = props.content.notRecommendedLupron
       highlightClass = 'stability-color-bad' 
      }

    else if (((props.tempIndicator=== 'C') && (props.tempActual >= -10  && props.tempActual <= 1) ) ||
      ((props.tempIndicator=== 'F') && (props.tempActual >= 14  && props.tempActual <= 35) )	){
       if(props.tempRangeValue !== 'BOTH_UNDER_OVER' && props.selectedMinutes() <= 96)
       {
        message = props.content.recommendedLupron 
         highlightClass = 'stability-color-good' 
       }
       else
       {
        message = props.content.notRecommendedLupron 
         highlightClass = 'stability-color-bad' 
       }
      }
      else if (((props.tempIndicator=== 'C') && (props.tempActual >= 2  && props.tempActual <= 14) ) ||
    ((props.tempIndicator=== 'F') && (props.tempActual >= 36 && props.tempActual <= 58) )	){
      if(props.tempRangeValue !== 'BOTH_UNDER_OVER' && props.selectedMinutes() <= 192)
     {
      message = props.content.recommendedLupron 
       highlightClass = 'stability-color-good' 
     }
     else
       {
        message = props.content.notRecommendedLupron 
         highlightClass = 'stability-color-bad' 
       }
    }
  
  else if (((props.tempIndicator=== 'C') && (props.tempActual >= 15  && props.tempActual <= 25) ) ||
((props.tempIndicator=== 'F') && (props.tempActual >= 59 && props.tempActual <= 77) )	){
 if(props.tempRangeValue !== 'BOTH_UNDER_OVER' )
 {
  message = props.content.recommendedLupron 
   highlightClass = 'stability-color-good' 
 }
}
else if (((props.tempIndicator=== 'C') && (props.tempActual >= 26  && props.tempActual <= 40) ) ||
((props.tempIndicator=== 'F') && (props.tempActual >= 78 && props.tempActual <= 104) )	){
  if(props.tempRangeValue !== 'BOTH_UNDER_OVER' && props.selectedMinutes() <= 96)
 {
  message = props.content.recommendedLupron 
   highlightClass = 'stability-color-good' 
 }
 else
       {
        message = props.content.notRecommendedLupron 
         highlightClass = 'stability-color-bad' 
       }
} else{
  message = props.content.notRecommendedLupron 
  highlightClass = 'stability-color-bad' 
}

if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
              
                message = message + '\n\n' +props.content.patientAdditionalQuestions+ '\n\n' + props.content.haveQuestions
              }else{
                message = message + '\n\n' + props.content.pphHaveQuestions
                
              }
  
}

    if(props.isBotoxSelected()) {
        
        highlightClass = 'stability-bad'
        message = props.content.notRecommendedBotoxInjection
        if (((props.tempIndicator=== 'C') && (props.tempActual <= -21) ) ||
			   ((props.tempIndicator=== 'F') && (props.tempActual <=- 5) )	){
		  	  message = props.content.botoxbelowMinus20 
	  		  highlightClass = 'stability-color-bad' 
		}   else if (((props.tempIndicator=== 'C') && (props.tempActual >= -20  && props.tempActual <= 8) ) ||
			   ((props.tempIndicator=== 'F') && (props.tempActual >= -4  && props.tempActual <= 46) )	){
          if(props.tempRangeValue !== 'BOTH_UNDER_OVER')
          {
           message = props.content.recommendedBotoxInjection 
		    	  highlightClass = 'stability-color-good' 
          }
		}   else if(((props.tempIndicator=== 'C') && (props.tempActual >= 9  && props.tempActual <= 30) ) ||
			 ((props.tempIndicator=== 'F') && (props.tempActual >= 47  && props.tempActual <= 86) )	){
		    if(props.selectedMinutes() <= 120 && props.tempRangeValue !== 'BOTH_UNDER_OVER'){
				message = props.content.recommendedBotoxInjection 
				highlightClass = 'stability-color-good'
			}
    }   else if (((props.tempIndicator === 'C') && (props.tempActual > 30)) ||
    ((props.tempIndicator === 'F') && (props.tempActual > 86))) {
        message = props.content.notRecommendedBotoxInjection
        highlightClass = 'stability-color-bad'
      } else{
				message = props.content.botoxBetween9_30Unstable 
				highlightClass = 'stability-color-bad' 
		}
				
  }
  if (props.isJuvedermSyringeAll()) {
    highlightClass = 'stability-bad'
    message = props.content.notRecommendedJuvedermUltraXC
    if (((props.tempIndicator === 'C') && (props.tempActual < 2)) ||
  ((props.tempIndicator === 'F') && (props.tempActual < 36))) {
      message = props.content.notRecommendedJuvedermUltraXC 
      highlightClass = 'stability-color-bad'
    } else if (((props.tempIndicator === 'C') && (props.tempActual >= 26 && props.tempActual <= 30)) ||
    ((props.tempIndicator === 'F') && (props.tempActual >= 78 && props.tempActual <= 86))) {
      if (props.selectedMinutes() <= 1440 && props.tempRangeValue !== 'BOTH_UNDER_OVER') {
        message = props.content.recommendedJuvedermUltraXC
        highlightClass = 'stability-color-good'
      } else {
        message = props.content.notRecommendedJuvedermUltraXC
        highlightClass = 'stability-color-bad'
      }
    } else if (((props.tempIndicator === 'C') && (props.tempActual >= 31 && props.tempActual <= 40)) ||
    ((props.tempIndicator === 'F') && (props.tempActual >= 87 && props.tempActual <= 104))) {
      if (props.selectedMinutes() <= 288 && props.tempRangeValue !== 'BOTH_UNDER_OVER') {
        message = props.content.recommendedJuvedermUltraXC 
        highlightClass = 'stability-color-good'
      } else {
        message = props.content.notRecommendedJuvedermUltraXC
        highlightClass = 'stability-color-bad'
      }
    } else if (((props.tempIndicator === 'C') && (props.tempActual > 40)) ||
  ((props.tempIndicator === 'F') && (props.tempActual > 104))) {
      message = props.content.notRecommendedJuvedermUltraXC
      highlightClass = 'stability-color-bad'
    }
  }
  if (props.isJuvedermXCAndJuvedermVolumaXCSelected()) {
        highlightClass = 'stability-bad'
        message = props.content.notRecommendedJuvedermUltraXC 
    if (((props.tempIndicator === 'C') && (props.tempActual < 0)) ||
      ((props.tempIndicator === 'F') && (props.tempActual < -32))) {
          message = props.content.notRecommendedJuvedermUltraXC 
          highlightClass = 'stability-color-bad'
    } else if (((props.tempIndicator === 'C') && (props.tempActual >= 0 && props.tempActual <= 1)) ||
        ((props.tempIndicator === 'F') && (props.tempActual >= 32 && props.tempActual <= 35))) {
          if (props.selectedMinutes() <= 48 && props.tempRangeValue !== 'BOTH_UNDER_OVER') {
            message = props.content.recommendedJuvedermUltraXC 
            highlightClass = 'stability-color-good'
          } else {
            message = props.content.notRecommendedJuvedermUltraXC
            highlightClass = 'stability-color-bad'
          }
    } else if (((props.tempIndicator === 'C') && (props.tempActual >= 26 && props.tempActual <= 30)) ||
        ((props.tempIndicator === 'F') && (props.tempActual >= 78 && props.tempActual <= 86))) {
          if (props.selectedMinutes() <= 1440 && props.tempRangeValue !== 'BOTH_UNDER_OVER')  {
            message = props.content.recommendedJuvedermUltraXC
            highlightClass = 'stability-color-good'
          } else {
            message = props.content.notRecommendedJuvedermUltraXC
            highlightClass = 'stability-color-bad'
          }
    } else if (((props.tempIndicator === 'C') && (props.tempActual >= 31 && props.tempActual <= 40)) ||
        ((props.tempIndicator === 'F') && (props.tempActual >= 87 && props.tempActual <= 104))) {
          if (props.selectedMinutes() <= 288 && props.tempRangeValue !== 'BOTH_UNDER_OVER') {
            message = props.content.recommendedJuvedermUltraXC 
            highlightClass = 'stability-color-good'
          } else {
            message = props.content.notRecommendedJuvedermUltraXC
            highlightClass = 'stability-color-bad'
          }
    } else if (((props.tempIndicator === 'C') && (props.tempActual > 40)) ||
      ((props.tempIndicator === 'F') && (props.tempActual > 104))) {
          message = props.content.notRecommendedJuvedermUltraXC
          highlightClass = 'stability-color-bad'
        }
      }
  if (props.isImbruvicaSelected()) {

        highlightClass = 'stability-bad'
        message = props.content.notRecommendedImbruvicaInjection 
        if (((props.tempIndicator === 'C') && (props.tempActual < -70)) ||
      ((props.tempIndicator === 'F') && (props.tempActual < -94))) {

          if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
            message = props.content.notRecommendedImbruvicaInjectionPatient 
          }else{
              message = props.content.notRecommendedImbruvicaInjection 
          }
          
          highlightClass = 'stability-color-bad'
    
        } else if (((props.tempIndicator === 'C') && (props.tempActual >= -70 && props.tempActual <= -21)) ||
        ((props.tempIndicator === 'F') && (props.tempActual >= -94 && props.tempActual <= -6))) {
          if (props.selectedMinutes() <= 48 && props.tempRangeValue !== 'BOTH_UNDER_OVER') {
            if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
              message = props.content.recommendedImbruvicaInjectionPatient
            }else{
              message = props.content.recommendedImbruvicaInjection
            }
             
            highlightClass = 'stability-color-good'
          } else {
            if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
              message = props.content.notRecommendedImbruvicaInjectionPatient
            }else{
              message = props.content.notRecommendedImbruvicaInjection
            }
            
            highlightClass = 'stability-color-bad'
          }
         } else if (((props.tempIndicator === 'C') && (props.tempActual >= -20 && props.tempActual <= 1)) ||
          ((props.tempIndicator === 'F') && (props.tempActual >= -4 && props.tempActual <= 35))) {
            if (props.selectedMinutes() <= 96 && props.tempRangeValue !== 'BOTH_UNDER_OVER') {
              if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
                message = props.content.recommendedImbruvicaInjectionPatient
              }else{
                message = props.content.recommendedImbruvicaInjection
              }
               
              highlightClass = 'stability-color-good'
            } else {
              if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
                message = props.content.notRecommendedImbruvicaInjectionPatient
              }else{
                message = props.content.notRecommendedImbruvicaInjection
              }
              
              highlightClass = 'stability-color-bad'
            }
        } else if (((props.tempIndicator === 'C') && (props.tempActual >= 2 && props.tempActual <= 30)) ||
        ((props.tempIndicator === 'F') && (props.tempActual >= 36 && props.tempActual <= 86))) {
            if(props.tempRangeValue !== 'BOTH_UNDER_OVER') {
              if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
                message = props.content.recommendedImbruvicaInjectionPatient
              }else{
                message = props.content.recommendedImbruvicaInjection
              }
           
              highlightClass = 'stability-color-good'
            }
        } else if (((props.tempIndicator === 'C') && (props.tempActual >= 31 && props.tempActual <= 40)) ||
        ((props.tempIndicator === 'F') && (props.tempActual >= 87 && props.tempActual <= 104))) {
          if (props.selectedMinutes() <= 120 && props.tempRangeValue !== 'BOTH_UNDER_OVER' && (props.selectedRole === 'PATIENT'  || props.userType === PATIENT)) {
            message = props.content.recommendedImbruvicaInjectionPatient
            highlightClass = 'stability-color-good'
          } else if (props.selectedMinutes() <= 240 && props.tempRangeValue !== 'BOTH_UNDER_OVER' && props.selectedRole === 'HCP') {
            message = props.content.recommendedImbruvicaInjection
            highlightClass = 'stability-color-good'
          } 
          else {
            if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
              message = props.content.notRecommendedImbruvicaInjectionPatient
            }else{
              message = props.content.notRecommendedImbruvicaInjection
            }
            
            highlightClass = 'stability-color-bad'
          }
        } else if (((props.tempIndicator === 'C') && (props.tempActual >= 41 && props.tempActual <= 50)) ||
        ((props.tempIndicator === 'F') && (props.tempActual >= 105 && props.tempActual <= 122))) {
          if (props.selectedMinutes() <= 96 && props.tempRangeValue !== 'BOTH_UNDER_OVER') {

            if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
              message = props.content.recommendedImbruvicaInjectionPatient
            }else{
              message = props.content.recommendedImbruvicaInjection
            }
            highlightClass = 'stability-color-good'
          } else {
            if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
              message = props.content.notRecommendedImbruvicaInjectionPatient
            }else{
              message = props.content.notRecommendedImbruvicaInjection
            }
            highlightClass = 'stability-color-bad'
          }
        } else if (((props.tempIndicator === 'C') && (props.tempActual > 50)) ||
      ((props.tempIndicator === 'F') && (props.tempActual > 120))) {

           if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
              message = props.content.notRecommendedImbruvicaInjectionPatient
            }else{
              message = props.content.notRecommendedImbruvicaInjection
            }
          highlightClass = 'stability-color-bad'
        }

        if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
          message = message + '\n\n' + props.content.haveQuestions
        }
      }
  if (props.isImbruvicaOralSuspensionSelected()) {

        highlightClass = 'stability-bad'
        message = props.content.notRecommendedImbruvicaOralPatient
        if (((props.tempIndicator === 'C') && (props.tempActual < 0)) ||
      ((props.tempIndicator === 'F') && (props.tempActual < 32))) {
        if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
            message = props.content.notRecommendedImbruvicaOralPatient
        }else{
             message = props.content.notRecommendedImbruvicaOral 
        }
         
          highlightClass = 'stability-color-bad'
    
        } else if (((props.tempIndicator === 'C') && (props.tempActual >= 0 && props.tempActual <= 1)) ||
        ((props.tempIndicator === 'F') && (props.tempActual >= 32 && props.tempActual <= 35))) {
          if (props.selectedMinutes() <= 48 && props.tempRangeValue !== 'BOTH_UNDER_OVER' && (props.selectedRole === 'PATIENT'  || props.userType === PATIENT)) {
            message = props.content.recommendedImbruvicaOralPatient 
            highlightClass = 'stability-color-good'
          } else if (props.selectedMinutes() <= 48 && props.tempRangeValue !== 'BOTH_UNDER_OVER' &&  props.selectedRole === 'HCP'){
            message = props.content.recommendedImbruvicaOralPPH
            highlightClass = 'stability-color-good'
          } else {
            if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
              message = props.content.notRecommendedImbruvicaOralPatient
            }else{
            message = props.content.notRecommendedImbruvicaOral
            }
            highlightClass = 'stability-color-bad'
          }
         } else if (((props.tempIndicator === 'C') && (props.tempActual >= 2 && props.tempActual <= 25)) ||
        ((props.tempIndicator === 'F') && (props.tempActual >= 36 && props.tempActual <= 77))) {
            if(props.tempRangeValue !== 'BOTH_UNDER_OVER' && (props.selectedRole === 'PATIENT'  || props.userType === PATIENT)) {
          message = props.content.recommendedImbruvicaOralPatient
          highlightClass = 'stability-color-good'
            }
            else if (props.tempRangeValue !== 'BOTH_UNDER_OVER' && props.selectedRole === 'HCP'){
              message = props.content.recommendedImbruvicaOralPPH
             highlightClass = 'stability-color-good'
            }
        } else if (((props.tempIndicator === 'C') && (props.tempActual >= 26 && props.tempActual <= 40)) ||
        ((props.tempIndicator === 'F') && (props.tempActual >= 78 && props.tempActual <= 104))) {
          if (props.selectedMinutes() <= 240 && props.tempRangeValue !== 'BOTH_UNDER_OVER' && (props.selectedRole === 'PATIENT'  || props.userType === PATIENT)) {
            message = props.content.recommendedImbruvicaOralPatient
            highlightClass = 'stability-color-good'
          } else if (props.selectedMinutes() <= 120 && props.tempRangeValue !== 'BOTH_UNDER_OVER' && props.selectedRole === 'HCP') {
            message = props.content.recommendedImbruvicaOralPPH
            highlightClass = 'stability-color-good'
          } 
          else {
            if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
              message = props.content.notRecommendedImbruvicaOralPatient
            }else{
              message = props.content.notRecommendedImbruvicaOral
            }
            
            highlightClass = 'stability-color-bad'
          }
        } else if (((props.tempIndicator === 'C') && (props.tempActual >= 41 && props.tempActual <= 50)) ||
        ((props.tempIndicator === 'F') && (props.tempActual >= 105 && props.tempActual <= 122))) {
          if (props.selectedMinutes() <= 48 && props.tempRangeValue !== 'BOTH_UNDER_OVER' && (props.selectedRole === 'PATIENT'  || props.userType === PATIENT)) {
            message = props.content.recommendedImbruvicaOralPatient
            highlightClass = 'stability-color-good'
          }  else if (props.selectedMinutes() <= 48 && props.tempRangeValue !== 'BOTH_UNDER_OVER' && props.selectedRole === 'HCP') {
            message = props.content.recommendedImbruvicaOralPPH
            highlightClass = 'stability-color-good'
          } 
          else {
            if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
              message = props.content.notRecommendedImbruvicaOralPatient 
            }else{
              message = props.content.notRecommendedImbruvicaOral 
            }
            
            highlightClass = 'stability-color-bad'
          }
        } else if (((props.tempIndicator === 'C') && (props.tempActual > 50)) ||
      ((props.tempIndicator === 'F') && (props.tempActual > 120))) {

        if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
          message = props.content.notRecommendedImbruvicaOralPatient
        }else{
          message = props.content.notRecommendedImbruvicaOral
        }
          
          highlightClass = 'stability-color-bad'
        }

        if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
          message = message + '\n\n' + props.content.haveQuestions
        }
      }
      if (props.isImbruvicaTabletsSelected()) {

        highlightClass = 'stability-bad'
        message = props.content.notRecommendedImbruvicaInjection
        if (((props.tempIndicator === 'C') && (props.tempActual < -20)) ||
      ((props.tempIndicator === 'F') && (props.tempActual < -4))) {
        if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
           message = props.content.notRecommendedImbruvicaInjectionPatient 
        }else{
            message = props.content.notRecommendedImbruvicaInjection 
        }
         
          highlightClass = 'stability-color-bad'
    
        } else if (((props.tempIndicator === 'C') && (props.tempActual >= -20 && props.tempActual <= 19)) ||
        ((props.tempIndicator === 'F') && (props.tempActual >= -4 && props.tempActual <= 67))) {
          if (props.selectedMinutes() <= 48 && props.tempRangeValue !== 'BOTH_UNDER_OVER') {
            if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
              message = props.content.recommendedImbruvicaInjectionPatient
            }else{
               message = props.content.recommendedImbruvicaInjection
            }
           
            highlightClass = 'stability-color-good'
          } else {
            if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
              message = props.content.notRecommendedImbruvicaInjectionPatient
            }else{
              message = props.content.notRecommendedImbruvicaInjection
            }
            
            highlightClass = 'stability-color-bad'
          }
         } else if (((props.tempIndicator === 'C') && (props.tempActual >= 20 && props.tempActual <= 30)) ||
        ((props.tempIndicator === 'F') && (props.tempActual >= 68 && props.tempActual <= 86))) {
            if(props.tempRangeValue !== 'BOTH_UNDER_OVER') {
            if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
              message = props.content.recommendedImbruvicaInjectionPatient
            }else{
               message = props.content.recommendedImbruvicaInjection
            }
          highlightClass = 'stability-color-good'
            }
        } else if (((props.tempIndicator === 'C') && (props.tempActual >= 31 && props.tempActual <= 40)) ||
        ((props.tempIndicator === 'F') && (props.tempActual >= 87 && props.tempActual <= 104))) {
          if (props.selectedMinutes() <= 120 && props.tempRangeValue !== 'BOTH_UNDER_OVER' && props.selectedRole === 'PATIENT') {
            if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
              message = props.content.recommendedImbruvicaInjectionPatient
            }else{
               message = props.content.recommendedImbruvicaInjection
            }
            highlightClass = 'stability-color-good'
          } else if (props.selectedMinutes() <= 240 && props.tempRangeValue !== 'BOTH_UNDER_OVER' && props.selectedRole === 'HCP') {
            if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
              message = props.content.recommendedImbruvicaInjectionPatient
            }else{
               message = props.content.recommendedImbruvicaInjection
            }
            highlightClass = 'stability-color-good'
          } 
          else {
           if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
              message = props.content.notRecommendedImbruvicaInjectionPatient
            }else{
              message = props.content.notRecommendedImbruvicaInjection
            }
            highlightClass = 'stability-color-bad'
          }
        } else if (((props.tempIndicator === 'C') && (props.tempActual >= 41 && props.tempActual <= 60)) ||
        ((props.tempIndicator === 'F') && (props.tempActual >= 105 && props.tempActual <= 140))) {
          if (props.selectedMinutes() <= 48 && props.tempRangeValue !== 'BOTH_UNDER_OVER') {
            if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
              message = props.content.recommendedImbruvicaInjectionPatient
            }else{
               message = props.content.recommendedImbruvicaInjection
            }
            highlightClass = 'stability-color-good'
          } else {
            if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
              message = props.content.notRecommendedImbruvicaInjectionPatient
            }else{
              message = props.content.notRecommendedImbruvicaInjection
            }
            highlightClass = 'stability-color-bad'
          }
        } else if (((props.tempIndicator === 'C') && (props.tempActual > 60)) ||
      ((props.tempIndicator === 'F') && (props.tempActual > 140))) {

         if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
              message = props.content.notRecommendedImbruvicaInjectionPatient
            }else{
              message = props.content.notRecommendedImbruvicaInjection
            }
          highlightClass = 'stability-color-bad'
        }


        if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
          message = message + '\n\n' + props.content.haveQuestions
        }
      }
      if (props.isHumiraSelectedByPatient()) {
          

           /*New logic for Humira 40mg/0.8mL Patient starts here */
            message = props.messages.bad
            highlightClass = 'stability-bad'
            
            if (((props.tempIndicator=== 'C') && (props.tempActual < -10) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <14))) {
            
            message = props.content.humira40mgNostability 
            highlightClass = 'stability-color-bad' 
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -10  && props.tempActual <= -1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 14  && props.tempActual <= 31) )	) {
             if (props.selectedMinutes() <= 10) {
                message = props.content.humira40mgreturntToFridge 
                highlightClass = 'stability-color-good'
             }else{
                message = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 0 && props.tempActual <= 8) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 32  && props.tempActual <= 46) )	) {
            
                message = props.content.humira40mgreturntToFridge 
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 9  && props.tempActual <= 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 47  && props.tempActual <= 77) )	) {
             if (props.selectedMinutes() <= 96) {
                message = props.content.humira40mgreturntToFridge + props.content.humira40mgMayAlso 
                highlightClass = 'stability-color-good'
             }else if (props.selectedMinutes() > 96 && props.selectedMinutes() <= 336) {
                message = props.content.humira40mgMay 
                highlightClass = 'stability-color-good'
             }else{
                message = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 26  && props.tempActual <= 30) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 78  && props.tempActual <= 86) )	) {
             if (props.selectedMinutes() <= 24) {
                message = props.content.humira40mgreturntToFridge  
                highlightClass = 'stability-color-good'
             }else{
                message = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 30) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >86) )	) {
            
            message = props.content.humira40mgNostability 
            highlightClass = 'stability-color-bad' 
          
          }

          if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
              
                message = message + '\n\n' +props.content.patientAdditionalQuestions+ '\n\n' + props.content.haveQuestions
              }else{
                message = message + '\n\n' + props.content.pphHaveQuestions
                
              }

          /*New logic for Humira 40mg/0.8mL Patient ends here */



        }

        if (props.isHumiraSelectedByPPH()) {
          

           /*New logic for Humira 40mg/0.8mL PPH starts here */
            message = props.messages.bad
            highlightClass = 'stability-bad'
            
            if (((props.tempIndicator=== 'C') && (props.tempActual < -10) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <14))) {
            
            message = props.content.humira40mgNostability 
            highlightClass = 'stability-color-bad' 
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -10  && props.tempActual <= -1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 14  && props.tempActual <= 31) )	) {
             if (props.selectedMinutes() <= 10) {
                message = props.content.humira40mgreturntToFridge 
                highlightClass = 'stability-color-good'
             }else{
                message = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 0 && props.tempActual <= 8) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 32  && props.tempActual <= 46) )	) {
            
                message = props.content.humira40mgreturntToFridge 
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 9  && props.tempActual <= 10) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 47  && props.tempActual <= 50) )	) {
             if (props.selectedMinutes() <= 120) {
                message = props.content.humira40mgreturntToFridge
                highlightClass = 'stability-color-good'
             }else{
                message = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 11  && props.tempActual <= 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 51  && props.tempActual <= 77) )	) {
             if (props.selectedMinutes() <= 48) {
                message = props.content.humira40mgreturntToFridge
                highlightClass = 'stability-color-good'
             }else{
                message = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >77) )	) {
            
            message = props.content.humira40mgNostability 
            highlightClass = 'stability-color-bad' 
          
          }

          if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
              
                message = message + '\n\n' +props.content.patientAdditionalQuestions+ '\n\n' + props.content.haveQuestions
              }else{
                message = message + '\n\n' + props.content.pphHaveQuestions
                
              }
          /*New logic for Humira 40mg/0.8mL PPH ends here */



        }



        if (props.isHumiraCitrateFreeSelectedByPatient()) {
          

           /*New logic for Humira 40mg/0.8mL Patient starts here */
            message = props.messages.bad
            highlightClass = 'stability-bad'
            
            if (((props.tempIndicator=== 'C') && (props.tempActual < -10) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <14))) {
            
            message = props.content.humira40mgNostability 
            highlightClass = 'stability-color-bad' 
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -10  && props.tempActual <= -1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 14  && props.tempActual <= 31) )	) {
             if (props.selectedMinutes() <= 120) {
                message = props.content.humira40mgreturntToFridge 
                highlightClass = 'stability-color-good'
             }else{
                message = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 0 && props.tempActual <= 8) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 32  && props.tempActual <= 46) )	) {
            
                message = props.content.humira40mgreturntToFridge 
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 9  && props.tempActual <= 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 47  && props.tempActual <= 77) )	) {
             if (props.selectedMinutes() <= 96) {
                message = props.content.humira40mgreturntToFridge + props.content.humira40mgMayAlso 
                highlightClass = 'stability-color-good'
             }else if (props.selectedMinutes() > 96 && props.selectedMinutes() <= 336) {
                message = props.content.humira40mgMay 
                highlightClass = 'stability-color-good'
             }else{
                message = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 26  && props.tempActual <= 30) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 78  && props.tempActual <= 86) )	) {
             if (props.selectedMinutes() <= 24) {
                message = props.content.humira40mgreturntToFridge  
                highlightClass = 'stability-color-good'
             }else{
                message = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 30) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >86) )	) {
            
            message = props.content.humira40mgNostability 
            highlightClass = 'stability-color-bad' 
          
          }

          if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
              
                message = message + '\n\n' +props.content.patientAdditionalQuestions+ '\n\n' + props.content.haveQuestions
              }else{
                message = message + '\n\n' + props.content.pphHaveQuestions
                
              }

          /*New logic for Humira 40mg/0.8mL Patient ends here */



        }

        if (props.isHumiraCitrateFreeSelectedByPPH()) {
          

           /*New logic for Humira 40mg/0.8mL PPH starts here */
            message = props.messages.bad
            highlightClass = 'stability-bad'
            
            if (((props.tempIndicator=== 'C') && (props.tempActual < -10) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <14))) {
            
            message = props.content.humira40mgNostability 
            highlightClass = 'stability-color-bad' 
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -10  && props.tempActual <= -1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 14  && props.tempActual <= 31) )	) {
             if (props.selectedMinutes() <= 120) {
                message = props.content.humira40mgreturntToFridge 
                highlightClass = 'stability-color-good'
             }else{
                message = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 0 && props.tempActual <= 8) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 32  && props.tempActual <= 46) )	) {
            
                message = props.content.humira40mgreturntToFridge 
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 9  && props.tempActual <= 15) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 47  && props.tempActual <= 59) )	) {
             if (props.selectedMinutes() <= 120) {
                message = props.content.humira40mgreturntToFridge
                highlightClass = 'stability-color-good'
             }else{
                message = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 16  && props.tempActual <= 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 60  && props.tempActual <= 77) )	) {
             if (props.selectedMinutes() <= 48) {
                message = props.content.humira40mgreturntToFridge
                highlightClass = 'stability-color-good'
             }else{
                message = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 26  && props.tempActual <= 30) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 78  && props.tempActual <= 86) )	) {
             if (props.selectedMinutes() <= 12) {
                message = props.content.humira40mgreturntToFridge
                highlightClass = 'stability-color-good'
             }else{
                message = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 30) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >86) )	) {
            
            message = props.content.humira40mgNostability 
            highlightClass = 'stability-color-bad' 
          
          }

          if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
              
                message = message + '\n\n' +props.content.patientAdditionalQuestions+ '\n\n' + props.content.haveQuestions
              }else{
                message = message + '\n\n' + props.content.pphHaveQuestions
                
              }
          /*New logic for Humira 40mg/0.8mL PPH ends here */



        }



        if (props.isSkyriziPenSelectedByPatient()) {
          

           /*New logic for Skyrizi Pen Patient starts here */
            message = props.messages.bad
            highlightClass = 'stability-bad'
            
            if (((props.tempIndicator=== 'C') && (props.tempActual < -5) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <23))) {
            
            message = props.content.noStabilityStd 
            highlightClass = 'stability-color-bad' 
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -5  && props.tempActual <= 1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 23  && props.tempActual <= 35) )	) {
             if (props.selectedMinutes() <= 120) {
                message = props.content.skyriziPenStable 
                highlightClass = 'stability-color-good'
             }else{
                message = props.content.noStabilityStd 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 2 && props.tempActual <= 8) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 36  && props.tempActual <= 46) )	) {
            
                message = props.content.skyriziPenStable 
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 9  && props.tempActual <= 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 47  && props.tempActual <= 77) )	) {
              if (props.selectedMinutes() <= 24) {
                message = props.content.skyriziPenStable 
                highlightClass = 'stability-color-good'
             }else{
                message = props.content.noStabilityStd 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >77) )	) {
            
            message = props.content.noStabilityStd 
            highlightClass = 'stability-color-bad' 
          
          }

          if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
              
                message = message + '\n\n' +props.content.patientAdditionalQuestions+ '\n\n' + props.content.haveQuestions
              }else{
                message = message + '\n\n' + props.content.pphHaveQuestions
                
              }

          /*New logic for Skyrizi Pen Patient ends here */



        }

        if (props.isSkyriziPenSelectedByPPH()) {
          

           /*New logic for Skyrizi Pen PPH starts here */
            message = props.messages.bad
            highlightClass = 'stability-bad'
            
            if (((props.tempIndicator=== 'C') && (props.tempActual < -5) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <23))) {
            
            message = props.content.noStabilityStd 
            highlightClass = 'stability-color-bad' 
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -5  && props.tempActual <= 1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 23  && props.tempActual <= 35) )	) {
             if (props.selectedMinutes() <= 72) {
                message = props.content.skyriziPenStable 
                highlightClass = 'stability-color-good'
             }else{
                message = props.content.noStabilityStd 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 2 && props.tempActual <= 8) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 36  && props.tempActual <= 46) )	) {
            
                message = props.content.skyriziPenStable 
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 9  && props.tempActual <= 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 47  && props.tempActual <= 77) )	) {
             if (props.selectedMinutes() <= 24) {
                message = props.content.skyriziPenStable 
                highlightClass = 'stability-color-good'
             }else{
                message = props.content.noStabilityStd 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >77) )	) {
            
            message = props.content.noStabilityStd 
            highlightClass = 'stability-color-bad' 
          
          }

          if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
              
                message = message + '\n\n' +props.content.patientAdditionalQuestions+ '\n\n' + props.content.haveQuestions
              }else{
                message = message + '\n\n' + props.content.pphHaveQuestions
                
              }
          /*New logic for Skyrizi Pen PPH ends here */



        }
        if (props.isSkyriziSyringeSelectedByPatient()) {
          

           /*New logic for Skyrizi Pen Patient starts here */
            message = props.messages.bad
            highlightClass = 'stability-bad'
            
            if (((props.tempIndicator=== 'C') && (props.tempActual < -5) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <23))) {
            
            message = props.content.noStabilityStd 
            highlightClass = 'stability-color-bad' 
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -5  && props.tempActual <= 1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 23  && props.tempActual <= 35) )	) {
             message = props.content.noStabilityStd 
            highlightClass = 'stability-color-bad'          
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 2 && props.tempActual <= 8) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 36  && props.tempActual <= 46) )	) {
            
                message = props.content.skyriziPenStable 
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 9  && props.tempActual <= 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 47  && props.tempActual <= 77) )	) {
              if (props.selectedMinutes() <= 24) {
                message = props.content.skyriziPenStable 
                highlightClass = 'stability-color-good'
             }else{
                message = props.content.noStabilityStd 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >77) )	) {
            
            message = props.content.noStabilityStd 
            highlightClass = 'stability-color-bad' 
          
          }

          if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
              
                message = message + '\n\n' +props.content.patientAdditionalQuestions+ '\n\n' + props.content.haveQuestions
              }else{
                message = message + '\n\n' + props.content.pphHaveQuestions
                
              }

          /*New logic for Skyrizi Pen Patient ends here */



        }

        if (props.isSkyriziSyringeSelectedByPPH()) {
          

           /*New logic for Skyrizi Pen PPH starts here */
            message = props.messages.bad
            highlightClass = 'stability-bad'
            
            if (((props.tempIndicator=== 'C') && (props.tempActual < -5) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <23))) {
            
            message = props.content.noStabilityStd 
            highlightClass = 'stability-color-bad' 
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -5  && props.tempActual <= 1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 23  && props.tempActual <= 35) )	) {
             message = props.content.noStabilityStd 
            highlightClass = 'stability-color-bad'           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 2 && props.tempActual <= 8) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 36  && props.tempActual <= 46) )	) {
            
                message = props.content.skyriziPenStable 
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 9  && props.tempActual <= 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 47  && props.tempActual <= 77) )	) {
             if (props.selectedMinutes() <= 24) {
                message = props.content.skyriziPenStable 
                highlightClass = 'stability-color-good'
             }else{
                message = props.content.noStabilityStd 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >77) )	) {
            
            message = props.content.noStabilityStd 
            highlightClass = 'stability-color-bad' 
          
          }

          if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
              
                message = message + '\n\n' +props.content.patientAdditionalQuestions+ '\n\n' + props.content.haveQuestions
              }else{
                message = message + '\n\n' + props.content.pphHaveQuestions
                
              }
          /*New logic for Skyrizi Pen PPH ends here */



        }
        if (props.isRinvoqTabletsSelectedByPatient()) {
         

           /*New logic for Rinvoq (15 mg, 30 mg, 45 mg tablets) Patient starts here */
            message = props.messages.bad
            if (((props.tempIndicator=== 'C') && (props.tempActual < -20) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <-4))) {
            
             highlightClass = 'stability-color-bad'
           message= props.content.noStabilityStd 
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -20  && props.tempActual <= 1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= -4  && props.tempActual <= 35) )	) {
             if (props.selectedMinutes() <= 72) {
                 
                message= props.content.rinvoqTabletStable
                highlightClass = 'stability-color-good'

             }else{
                 
               message= props.content.noStabilityStd
              highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 2 && props.tempActual <= 30) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 36  && props.tempActual <= 86) )	) {
            
                 
                message= props.content.rinvoqTabletStable
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 31  && props.tempActual <= 40) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 87  && props.tempActual <= 104) )	) {
              if (props.selectedMinutes() <= 144) {
                 
                message= props.content.rinvoqTabletStable
                highlightClass = 'stability-color-good'
             }else{
                 
               message= props.content.noStabilityStd
               highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 41  && props.tempActual <= 50) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 105  && props.tempActual <= 122) )	) {
              if (props.selectedMinutes() <= 72) {
                 
                message= props.content.rinvoqTabletStable
                highlightClass = 'stability-color-good'
             }else{
                 
               message= props.content.noStabilityStd
               highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 50) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >122) )	) {
            
             
           message= props.content.noStabilityStd 
           highlightClass = 'stability-color-bad'
          
          }
          if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
              
                message = message + '\n\n' +props.content.patientAdditionalQuestions+ '\n\n' + props.content.haveQuestions
              }else{
                message = message + '\n\n' + props.content.pphHaveQuestions
                
              }

          /*New logic for Rinvoq (15 mg, 30 mg, 45 mg tablets) Patient starts here */



        }else if (props.isRinvoqTabletsSelectedByPPH()) {
         

           /*New logic for Rinvoq (15 mg, 30 mg, 45 mg tablets) PPH starts here */
            message = props.messages.bad
            if (((props.tempIndicator=== 'C') && (props.tempActual < -20) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <-4))) {
            
             
           message= props.content.noStabilityStd 
           highlightClass = 'stability-color-bad'
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -20  && props.tempActual <= 1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= -4  && props.tempActual <= 35) )	) {
             if (props.selectedMinutes() <= 48) {
                 
                message= props.content.rinvoqTabletStable
                highlightClass = 'stability-color-good'
             }else{
                 
               message= props.content.noStabilityStd
               highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 2 && props.tempActual <= 30) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 36  && props.tempActual <= 86) )	) {
            
                 
                message= props.content.rinvoqTabletStable
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 31  && props.tempActual <= 40) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 87  && props.tempActual <= 104) )	) {
              if (props.selectedMinutes() <= 96) {
                 
                message= props.content.rinvoqTabletStable
                highlightClass = 'stability-color-good'
             }else{
                 
               message= props.content.noStabilityStd
               highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 41  && props.tempActual <= 50) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 105  && props.tempActual <= 122) )	) {
              if (props.selectedMinutes() <= 48) {
                 
                message= props.content.rinvoqTabletStable
                highlightClass = 'stability-color-good'
             }else{
                 
               message= props.content.noStabilityStd
               highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 50) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >122) )	) {
            
             
           message= props.content.noStabilityStd 
           highlightClass = 'stability-color-bad'
          
          }
          if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
              
                message = message + '\n\n' +props.content.patientAdditionalQuestions+ '\n\n' + props.content.haveQuestions
              }else{
                message = message + '\n\n' + props.content.pphHaveQuestions
                
              }

          /*New logic for Rinvoq (15 mg, 30 mg, 45 mg tablets) PPH Ends here */



        }
        if (props.isRinvoqLiquidSelectedByPatient()) {
         

           /*New logic for Rinvoq Liquid [Rinvoq LQ (1 mg/mL oral solution)] Patient starts here */
            message = props.messages.bad
            if (((props.tempIndicator=== 'C') && (props.tempActual < -20) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <-4))) {
            
             highlightClass = 'stability-color-bad'
           message= props.content.noStabilityStd 
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -20  && props.tempActual <= 1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= -4  && props.tempActual <= 35) )	) {
             if (props.selectedMinutes() <= 72) {
                 
                message= props.content.rinvoqLiquidStable
                highlightClass = 'stability-color-good'

             }else{
                 
               message= props.content.noStabilityStd
              highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 2 && props.tempActual <= 30) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 36  && props.tempActual <= 86) )	) {
            
                 
                message= props.content.rinvoqLiquidStable
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 31  && props.tempActual <= 40) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 87  && props.tempActual <= 104) )	) {
              if (props.selectedMinutes() <= 144) {
                 
                message= props.content.rinvoqLiquidStable
                highlightClass = 'stability-color-good'
             }else{
                 
               message= props.content.noStabilityStd
               highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 41  && props.tempActual <= 50) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 105  && props.tempActual <= 122) )	) {
              if (props.selectedMinutes() <= 96) {
                 
                message= props.content.rinvoqLiquidStable
                highlightClass = 'stability-color-good'
             }else{
                 
               message= props.content.noStabilityStd
               highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 50) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >122) )	) {
            
             
           message= props.content.noStabilityStd 
           highlightClass = 'stability-color-bad'
          
          }
          if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
              
                message = message + '\n\n' +props.content.patientAdditionalQuestions+ '\n\n' + props.content.haveQuestions
              }else{
                message = message + '\n\n' + props.content.pphHaveQuestions
                
              }

          /*New logic for Rinvoq Liquid [Rinvoq LQ (1 mg/mL oral solution)] Patient starts here */



        }else if (props.isRinvoqLiquidSelectedByPPH()) {
         

           /*New logic for Rinvoq Liquid [Rinvoq LQ (1 mg/mL oral solution)] PPH starts here */
            message = props.messages.bad
            if (((props.tempIndicator=== 'C') && (props.tempActual < -20) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <-4))) {
            
             
           message= props.content.noStabilityStd 
           highlightClass = 'stability-color-bad'
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -20  && props.tempActual <= 1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= -4  && props.tempActual <= 35) )	) {
             if (props.selectedMinutes() <= 72) {
                 
                message= props.content.rinvoqLiquidStable
                highlightClass = 'stability-color-good'
             }else{
                 
               message= props.content.noStabilityStd
               highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 2 && props.tempActual <= 30) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 36  && props.tempActual <= 86) )	) {
            
                 
                message= props.content.rinvoqLiquidStable
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 31  && props.tempActual <= 40) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 87  && props.tempActual <= 104) )	) {
              if (props.selectedMinutes() <= 144) {
                 
                message= props.content.rinvoqLiquidStable
                highlightClass = 'stability-color-good'
             }else{
                 
               message= props.content.noStabilityStd
               highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 41  && props.tempActual <= 50) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 105  && props.tempActual <= 122) )	) {
              if (props.selectedMinutes() <= 72) {
                 
                message= props.content.rinvoqLiquidStable
                highlightClass = 'stability-color-good'
             }else{
                 
               message= props.content.noStabilityStd
               highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 50) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >122) )	) {
            
             
           message= props.content.noStabilityStd 
           highlightClass = 'stability-color-bad'
          
          }
          if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
              
                message = message + '\n\n' +props.content.patientAdditionalQuestions+ '\n\n' + props.content.haveQuestions
              }else{
                message = message + '\n\n' + props.content.pphHaveQuestions
                
              }

          /*New logic for Rinvoq Liquid [Rinvoq LQ (1 mg/mL oral solution)] PPH Ends here */



        }  
      break
    case 'UNABLE_TO_ASSESS':
      message = props.messages.unableToAssess
      highlightClass = 'stability-color-unableToAssess'
      // resultIcon = ""; /* "fa-times-circle"; */
      break
    case 'RECOMMENDED':
      if (props.userType !== PATIENT) {
        let recommendedmessage = props.messages.recommended + recRangeMessage
         if (props.isVenetoclaxSelected()) {
          recommendedmessage = props.content.venetoclaxReturnToContainer + recRangeMessage
        } else if (props.isLuprondepotSelected()) {
          recommendedmessage = props.content.recommendedLupron
        } 

         if (props.isSkyriziOBISelected() && props.selectedRole === 'PATIENT') {
          
            recommendedmessage = props.content.safeToUsePatient + ' ' + props.content.returnToFridgePatient + recRangeMessage 
          
        }
         if (props.isDuopaSelected() && props.selectedRole === 'PATIENT') {
          recommendedmessage = props.content.safeToUsePatient + ' ' + props.content.returnToFridgePatient + recRangeMessage 
        }
        
        

        message = recommendedmessage 
      } else  {
         if (props.isVenetoclaxSelected()) {
          message = props.content.safeToUsePatient + ' ' + props.content.venetoclaxReturnToContainer + recRangeMessage + ' ' + message + '\n \n' + props.content.haveQuestions
        } else if (props.isLuprondepotSelected()) {
          message = props.content.recommendedLupron
        }else if (props.isSkyriziSelected()) {
          if(props.isSkyriziOBISelected())
            message = props.content.safeToUsePatient + ' ' + props.content.returnToFridgePatient + recRangeMessage 
          else
            message = props.content.safeToUsePatient + ' ' + props.content.continueToStorePatient + recRangeMessage 
        }else if (props.isDuopaSelected()) {
          message = props.content.safeToUsePatient + ' ' + props.content.returnToFridgePatient + recRangeMessage 
        }
         
         else {
          message = props.content.safeToUsePatient + ' ' + props.content.continueToStorePatient + recRangeMessage + ' ' + message + '\n \n' + props.content.haveQuestions
        }
      }

       if (props.isRinvoqTabletsSelectedByPatient()) {
         

           /*New logic for Rinvoq (15 mg, 30 mg, 45 mg tablets) Patient starts here */
            message = props.messages.bad
            if (((props.tempIndicator=== 'C') && (props.tempActual < -20) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <-4))) {
            
             
           message= props.content.noStabilityStd 
           highlightClass = 'stability-bad'
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -20  && props.tempActual <= 1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= -4  && props.tempActual <= 35) )	) {
             if (props.selectedMinutes() <= 72) {
                 
                message= props.content.rinvoqTabletStable
                highlightClass = 'stability-color-good'
             }else{
                 
               message= props.content.noStabilityStd
               highlightClass = 'stability-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 2 && props.tempActual <= 30) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 36  && props.tempActual <= 86) )	) {
            
                 
                message= props.content.rinvoqTabletStable
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 31  && props.tempActual <= 40) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 87  && props.tempActual <= 104) )	) {
              if (props.selectedMinutes() <= 144) {
                 
                message= props.content.rinvoqTabletStable
                highlightClass = 'stability-color-good'
             }else{
                 
               message= props.content.noStabilityStd
               highlightClass = 'stability-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 41  && props.tempActual <= 50) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 105  && props.tempActual <= 122) )	) {
              if (props.selectedMinutes() <= 72) {
                 
                message= props.content.rinvoqTabletStable
                highlightClass = 'stability-color-good'
             }else{
                 
               message= props.content.noStabilityStd
               highlightClass = 'stability-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 50) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >122) )	) {
            
             
           message= props.content.noStabilityStd 
           highlightClass = 'stability-bad'
          
          }

          /*New logic for Rinvoq (15 mg, 30 mg, 45 mg tablets) Patient starts here */



        }
        
        if (props.isRinvoqTabletsSelectedByPPH()) {
         

           /*New logic for Rinvoq (15 mg, 30 mg, 45 mg tablets) PPH starts here */
            message = props.messages.bad
            if (((props.tempIndicator=== 'C') && (props.tempActual < -20) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <-4))) {
            
             
           message= props.content.noStabilityStd 
           highlightClass = 'stability-bad'
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -20  && props.tempActual <= 1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= -4  && props.tempActual <= 35) )	) {
             if (props.selectedMinutes() <= 48) {
                 
                message= props.content.rinvoqTabletStable
                highlightClass = 'stability-color-good'
             }else{
                 
               message= props.content.noStabilityStd
               highlightClass = 'stability-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 2 && props.tempActual <= 30) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 36  && props.tempActual <= 86) )	) {
            
                 
                message= props.content.rinvoqTabletStable
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 31  && props.tempActual <= 40) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 87  && props.tempActual <= 104) )	) {
              if (props.selectedMinutes() <= 96) {
                 
                message= props.content.rinvoqTabletStable
                highlightClass = 'stability-color-good'
             }else{
                 
               message= props.content.noStabilityStd
               highlightClass = 'stability-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 41  && props.tempActual <= 50) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 105  && props.tempActual <= 122) )	) {
              if (props.selectedMinutes() <= 48) {
                 
                message= props.content.rinvoqTabletStable
                highlightClass = 'stability-color-good'
             }else{
                 
               message= props.content.noStabilityStd
               highlightClass = 'stability-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 50) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >122) )	) {
            
             
           message= props.content.noStabilityStd 
           highlightClass = 'stability-bad'
          
          }

          /*New logic for Rinvoq (15 mg, 30 mg, 45 mg tablets) PPH Ends here */



        }

        if (props.isRinvoqLiquidSelectedByPatient()) {
         

           /*New logic for Rinvoq (15 mg, 30 mg, 45 mg tablets) Patient starts here */
            message = props.messages.bad
            if (((props.tempIndicator=== 'C') && (props.tempActual < -20) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <-4))) {
            
             
           message= props.content.noStabilityStd 
           highlightClass = 'stability-bad'
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -20  && props.tempActual <= 1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= -4  && props.tempActual <= 35) )	) {
             if (props.selectedMinutes() <= 72) {
                 
                message= props.content.rinvoqLiquidStable
                highlightClass = 'stability-color-good'
             }else{
                 
               message= props.content.noStabilityStd
               highlightClass = 'stability-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 2 && props.tempActual <= 30) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 36  && props.tempActual <= 86) )	) {
            
                 
                message= props.content.rinvoqLiquidStable
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 31  && props.tempActual <= 40) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 87  && props.tempActual <= 104) )	) {
              if (props.selectedMinutes() <= 144) {
                 
                message= props.content.rinvoqLiquidStable
                highlightClass = 'stability-color-good'
             }else{
                 
               message= props.content.noStabilityStd
               highlightClass = 'stability-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 41  && props.tempActual <= 50) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 105  && props.tempActual <= 122) )	) {
              if (props.selectedMinutes() <= 96) {
                 
                message= props.content.rinvoqLiquidStable
                highlightClass = 'stability-color-good'
             }else{
                 
               message= props.content.noStabilityStd
               highlightClass = 'stability-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 50) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >122) )	) {
            
             
           message= props.content.noStabilityStd 
           highlightClass = 'stability-bad'
          
          }

          /*New logic for Rinvoq (15 mg, 30 mg, 45 mg tablets) Patient starts here */



        }
        
        if (props.isRinvoqLiquidSelectedByPPH()) {
         

           /*New logic for Rinvoq (15 mg, 30 mg, 45 mg tablets) PPH starts here */
            message = props.messages.bad
            if (((props.tempIndicator=== 'C') && (props.tempActual < -20) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <-4))) {
            
             
           message= props.content.noStabilityStd 
           highlightClass = 'stability-bad'
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -20  && props.tempActual <= 1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= -4  && props.tempActual <= 35) )	) {
             if (props.selectedMinutes() <= 72) {
                 
                message= props.content.rinvoqLiquidStable
                highlightClass = 'stability-color-good'
             }else{
                 
               message= props.content.noStabilityStd
               highlightClass = 'stability-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 2 && props.tempActual <= 30) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 36  && props.tempActual <= 86) )	) {
            
                 
                message= props.content.rinvoqLiquidStable
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 31  && props.tempActual <= 40) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 87  && props.tempActual <= 104) )	) {
              if (props.selectedMinutes() <= 144) {
                 
                message= props.content.rinvoqLiquidStable
                highlightClass = 'stability-color-good'
             }else{
                 
               message= props.content.noStabilityStd
               highlightClass = 'stability-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 41  && props.tempActual <= 50) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 105  && props.tempActual <= 122) )	) {
              if (props.selectedMinutes() <= 72) {
                 
                message= props.content.rinvoqLiquidStable
                highlightClass = 'stability-color-good'
             }else{
                 
               message= props.content.noStabilityStd
               highlightClass = 'stability-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 50) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >122) )	) {
            
             
           message= props.content.noStabilityStd 
           highlightClass = 'stability-bad'
          
          }

          /*New logic for Rinvoq (15 mg, 30 mg, 45 mg tablets) PPH Ends here */



        } 
      if (props.isImbruvicaTabletsSelected()) {
        message = props.messages.bad
        highlightClass = 'stability-bad'

        if (((props.tempIndicator === 'C') && (props.tempActual >= 20 && props.tempActual <= 25)) ||
        ((props.tempIndicator === 'F') && (props.tempActual >= 68 && props.tempActual <= 77))) {

          if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
              message = props.content.recommendedImbruvicaInjectionPatient
            }else{
               message = props.content.recommendedImbruvicaInjection
            }
          highlightClass = 'stability-color-good'}
          if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
          message = message + '\n\n' + props.content.haveQuestions
        }
      }
      if (props.isImbruvicaOralSuspensionSelected()) {
        message = props.messages.bad
        highlightClass = 'stability-bad'

        if (((props.tempIndicator === 'C') && (props.tempActual >= 2 && props.tempActual <= 25)) ||
        ((props.tempIndicator === 'F') && (props.tempActual >= 36 && props.tempActual <= 77))) {
          if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
            message = props.content.recommendedImbruvicaOralPatient
            highlightClass = 'stability-color-good'
          }
          else
          {message = props.content.recommendedImbruvicaOralPPH
          highlightClass = 'stability-color-good'}

      }

      if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
          message = message + '\n\n' + props.content.haveQuestions
        }
    }if (props.isJuvedermSyringeAll()) {
        message = props.messages.bad
        highlightClass = 'stability-bad'

        if (((props.tempIndicator === 'C') && (props.tempActual >= 2 && props.tempActual <= 25)) ||
        ((props.tempIndicator === 'F') && (props.tempActual >= 36 && props.tempActual <= 77))) {

          message = props.content.recommendedJuvedermUltraXC
          highlightClass = 'stability-color-good'}

      

      } 
      if (props.isBotoxSelected()) {
          message = props.messages.bad
          highlightClass = 'stability-bad'
          
          if(((props.tempIndicator=== 'C') && (props.tempActual >= 2  && props.tempActual <= 8)) ||
          ((props.tempIndicator=== 'F') && (props.tempActual >= 36 && props.tempActual <= 46))) {
          
          message = props.content.recommendedBotoxInjection 
          highlightClass = 'stability-color-good'
          
        }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 9  && props.tempActual <= 30) ) ||
          ((props.tempIndicator=== 'F') && (props.tempActual >= 47  && props.tempActual <= 86) )	) {
          if(props.selectedMinutes() <= 120) {
            message = props.content.recommendedBotoxInjection 
            highlightClass = 'stability-color-good'
          }else{  
            message = props.content.botoxBetween9_30Unstable 
            highlightClass = 'stability-color-bad' 
          }   
        }
      }
      if (props.isJuvedermXCAndJuvedermVolumaXCSelected()) {
        message = props.content.notRecommendedJuvedermXC
        highlightClass = 'stability-bad'

        if (((props.tempIndicator === 'C') && (props.tempActual >= 0 && props.tempActual <= 1)) ||
        ((props.tempIndicator === 'F') && (props.tempActual >= 32 && props.tempActual <= 35))) {
          if (props.selectedMinutes() <= 48) {
            message = props.content.recommendedJuvedermUltraXC
            highlightClass = 'stability-color-good'
          } else {
            message = props.content.notRecommendedJuvedermXC
            highlightClass = 'stability-color-bad'
          }
        } else if (((props.tempIndicator === 'C') && (props.tempActual >= 2 && props.tempActual <= 25)) ||
        ((props.tempIndicator === 'F') && (props.tempActual >= 36 && props.tempActual <= 77))) {
          message = props.content.recommendedJuvedermUltraXC
          highlightClass = 'stability-color-good'
        } else if (((props.tempIndicator === 'C') && (props.tempActual >= 26 && props.tempActual <= 30)) ||
        ((props.tempIndicator === 'F') && (props.tempActual >= 78 && props.tempActual <= 86))) {
          if (props.selectedMinutes() <= 60) {
            message = props.content.recommendedJuvedermUltraXC
            highlightClass = 'stability-color-good'
          } else {
            message = props.content.notRecommendedJuvedermUltraXC
            highlightClass = 'stability-color-bad'
          }
        } else if (((props.tempIndicator === 'C') && (props.tempActual >= 31 && props.tempActual <= 40)) ||
        ((props.tempIndicator === 'F') && (props.tempActual >= 87 && props.tempActual <= 104))) {
          if (props.selectedMinutes() <= 12) {
            message = props.content.recommendedJuvedermXC
            highlightClass = 'stability-color-good'
          } else {
            message = props.content.notRecommendedJuvedermUltraXC
            highlightClass = 'stability-color-bad'
          }
        } 
      }
      if (props.isImbruvicaSelected()) {
        message = props.messages.bad
        highlightClass = 'stability-bad'

         if (((props.tempIndicator === 'C') && (props.tempActual >= 2 && props.tempActual <= 30)) ||
        ((props.tempIndicator === 'F') && (props.tempActual >= 36 && props.tempActual <= 86))) {
          if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
            message = props.content.recommendedImbruvicaInjectionPatient
          }else{
            message = props.content.recommendedImbruvicaInjection
          }

         
          highlightClass = 'stability-color-good'
        
        }
        if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
          message = message + '\n\n' + props.content.haveQuestions
        } 

      }
       if (props.isHumiraSelectedByPatient()) {
          

           /*New logic for Humira 40mg/0.8mL Patient starts here */
            message = props.messages.bad
            highlightClass = 'stability-bad'
            
            if (((props.tempIndicator=== 'C') && (props.tempActual < -10) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <14))) {
            
            message = props.content.humira40mgNostability 
            highlightClass = 'stability-color-bad' 
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -10  && props.tempActual <= -1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 14  && props.tempActual <= 31) )	) {
             if (props.selectedMinutes() <= 10) {
                message = props.content.humira40mgreturntToFridge 
                highlightClass = 'stability-color-good'
             }else{
                message = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 0 && props.tempActual <= 8) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 32  && props.tempActual <= 46) )	) {
            
                message = props.content.humira40mgreturntToFridge 
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 9  && props.tempActual <= 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 47  && props.tempActual <= 77) )	) {
             if (props.selectedMinutes() <= 96) {
                message = props.content.humira40mgreturntToFridge + props.content.humira40mgMayAlso 
                highlightClass = 'stability-color-good'
             }else if (props.selectedMinutes() > 96 && props.selectedMinutes() <= 336) {
                message = props.content.humira40mgMay 
                highlightClass = 'stability-color-good'
             }else{
                message = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 26  && props.tempActual <= 30) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 78  && props.tempActual <= 86) )	) {
             if (props.selectedMinutes() <= 24) {
                message = props.content.humira40mgreturntToFridge  
                highlightClass = 'stability-color-good'
             }else{
                message = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 30) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >86) )	) {
            
            message = props.content.humira40mgNostability 
            highlightClass = 'stability-color-bad' 
          
          }

          /*New logic for Humira 40mg/0.8mL Patient ends here */



        }

        if (props.isHumiraSelectedByPPH()) {
          

           /*New logic for Humira 40mg/0.8mL PPH starts here */
            message = props.messages.bad
            highlightClass = 'stability-bad'
            
            if (((props.tempIndicator=== 'C') && (props.tempActual < -10) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <14))) {
            
            message = props.content.humira40mgNostability 
            highlightClass = 'stability-color-bad' 
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -10  && props.tempActual <= -1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 14  && props.tempActual <= 31) )	) {
             if (props.selectedMinutes() <= 10) {
                message = props.content.humira40mgreturntToFridge 
                highlightClass = 'stability-color-good'
             }else{
                message = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 0 && props.tempActual <= 8) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 32  && props.tempActual <= 46) )	) {
            
                message = props.content.humira40mgreturntToFridge 
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 9  && props.tempActual <= 10) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 47  && props.tempActual <= 50) )	) {
             if (props.selectedMinutes() <= 120) {
                message = props.content.humira40mgreturntToFridge
                highlightClass = 'stability-color-good'
             }else{
                message = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 11  && props.tempActual <= 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 51  && props.tempActual <= 77) )	) {
             if (props.selectedMinutes() <= 48) {
                message = props.content.humira40mgreturntToFridge
                highlightClass = 'stability-color-good'
             }else{
                message = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >77) )	) {
            
            message = props.content.humira40mgNostability 
            highlightClass = 'stability-color-bad' 
          
          }

          /*New logic for Humira 40mg/0.8mL PPH ends here */



        }
        if (props.isHumiraCitrateFreeSelectedByPatient()) {
          

           /*New logic for Humira 40mg/0.8mL Patient starts here */
            message = props.messages.bad
            highlightClass = 'stability-bad'
            
            if (((props.tempIndicator=== 'C') && (props.tempActual < -10) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <14))) {
            
            message = props.content.humira40mgNostability 
            highlightClass = 'stability-color-bad' 
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -10  && props.tempActual <= -1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 14  && props.tempActual <= 31) )	) {
             if (props.selectedMinutes() <= 120) {
                message = props.content.humira40mgreturntToFridge 
                highlightClass = 'stability-color-good'
             }else{
                message = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 0 && props.tempActual <= 8) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 32  && props.tempActual <= 46) )	) {
            
                message = props.content.humira40mgreturntToFridge 
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 9  && props.tempActual <= 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 47  && props.tempActual <= 77) )	) {
             if (props.selectedMinutes() <= 96) {
                message = props.content.humira40mgreturntToFridge + props.content.humira40mgMayAlso 
                highlightClass = 'stability-color-good'
             }else if (props.selectedMinutes() > 96 && props.selectedMinutes() <= 336) {
                message = props.content.humira40mgMay 
                highlightClass = 'stability-color-good'
             }else{
                message = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 26  && props.tempActual <= 30) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 78  && props.tempActual <= 86) )	) {
             if (props.selectedMinutes() <= 24) {
                message = props.content.humira40mgreturntToFridge  
                highlightClass = 'stability-color-good'
             }else{
                message = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 30) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >86) )	) {
            
            message = props.content.humira40mgNostability 
            highlightClass = 'stability-color-bad' 
          
          }

          /*New logic for Humira 40mg/0.8mL Patient ends here */



        }

        if (props.isHumiraCitrateFreeSelectedByPPH()) {
          

           /*New logic for Humira 40mg/0.8mL PPH starts here */
            message = props.messages.bad
            highlightClass = 'stability-bad'
            
            if (((props.tempIndicator=== 'C') && (props.tempActual < -10) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <14))) {
            
            message = props.content.humira40mgNostability 
            highlightClass = 'stability-color-bad' 
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -10  && props.tempActual <= -1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 14  && props.tempActual <= 31) )	) {
             if (props.selectedMinutes() <= 120) {
                message = props.content.humira40mgreturntToFridge 
                highlightClass = 'stability-color-good'
             }else{
                message = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 0 && props.tempActual <= 8) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 32  && props.tempActual <= 46) )	) {
            
                message = props.content.humira40mgreturntToFridge 
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 9  && props.tempActual <= 15) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 47  && props.tempActual <= 59) )	) {
             if (props.selectedMinutes() <= 120) {
                message = props.content.humira40mgreturntToFridge
                highlightClass = 'stability-color-good'
             }else{
                message = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 16  && props.tempActual <= 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 60  && props.tempActual <= 77) )	) {
             if (props.selectedMinutes() <= 48) {
                message = props.content.humira40mgreturntToFridge
                highlightClass = 'stability-color-good'
             }else{
                message = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 26  && props.tempActual <= 30) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 78  && props.tempActual <= 86) )	) {
             if (props.selectedMinutes() <= 12) {
                message = props.content.humira40mgreturntToFridge
                highlightClass = 'stability-color-good'
             }else{
                message = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 30) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >77) )	) {
            
            message = props.content.humira40mgNostability 
            highlightClass = 'stability-color-bad' 
          
          }

          /*New logic for Humira 40mg/0.8mL PPH ends here */



        }

        if (props.isSkyriziPenSelectedByPatient()) {
          

           /*New logic for Skyrizi Pen Patient starts here */
            message = props.messages.bad
            highlightClass = 'stability-bad'
            
            if (((props.tempIndicator=== 'C') && (props.tempActual < -5) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <23))) {
            
            message = props.content.noStabilityStd 
            highlightClass = 'stability-color-bad' 
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -5  && props.tempActual <= 1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 23  && props.tempActual <= 35) )	) {
             if (props.selectedMinutes() <= 120) {
                message = props.content.skyriziPenStable 
                highlightClass = 'stability-color-good'
             }else{
                message = props.content.noStabilityStd 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 2 && props.tempActual <= 8) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 36  && props.tempActual <= 46) )	) {
            
                message = props.content.skyriziPenStable 
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 9  && props.tempActual <= 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 47  && props.tempActual <= 77) )	) {
              if (props.selectedMinutes() <= 24) {
                message = props.content.skyriziPenStable 
                highlightClass = 'stability-color-good'
             }else{
                message = props.content.noStabilityStd 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >77) )	) {
            
            message = props.content.noStabilityStd 
            highlightClass = 'stability-color-bad' 
          
          }

          

          /*New logic for Skyrizi Pen Patient ends here */



        }

        if (props.isSkyriziPenSelectedByPPH()) {
          

           /*New logic for Skyrizi Pen PPH starts here */
            message = props.messages.bad
            highlightClass = 'stability-bad'
            
            if (((props.tempIndicator=== 'C') && (props.tempActual < -5) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <23))) {
            
            message = props.content.noStabilityStd 
            highlightClass = 'stability-color-bad' 
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -5  && props.tempActual <= 1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 23  && props.tempActual <= 35) )	) {
             if (props.selectedMinutes() <= 72) {
                message = props.content.skyriziPenStable 
                highlightClass = 'stability-color-good'
             }else{
                message = props.content.noStabilityStd 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 2 && props.tempActual <= 8) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 36  && props.tempActual <= 46) )	) {
            
                message = props.content.skyriziPenStable 
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 9  && props.tempActual <= 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 47  && props.tempActual <= 77) )	) {
             if (props.selectedMinutes() <= 24) {
                message = props.content.skyriziPenStable 
                highlightClass = 'stability-color-good'
             }else{
                message = props.content.noStabilityStd 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >77) )	) {
            
            message = props.content.noStabilityStd 
            highlightClass = 'stability-color-bad' 
          
          }

          /*New logic for Skyrizi Pen PPH ends here */



        }
        if (props.isSkyriziSyringeSelectedByPatient()) {
          

           /*New logic for Skyrizi Pen Patient starts here */
            message = props.messages.bad
            highlightClass = 'stability-bad'
            
            if (((props.tempIndicator=== 'C') && (props.tempActual < -5) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <23))) {
            
            message = props.content.noStabilityStd 
            highlightClass = 'stability-color-bad' 
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -5  && props.tempActual <= 1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 23  && props.tempActual <= 35) )	) {
             message = props.content.noStabilityStd 
            highlightClass = 'stability-color-bad'           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 2 && props.tempActual <= 8) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 36  && props.tempActual <= 46) )	) {
            
                message = props.content.skyriziPenStable 
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 9  && props.tempActual <= 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 47  && props.tempActual <= 77) )	) {
              if (props.selectedMinutes() <= 24) {
                message = props.content.skyriziPenStable 
                highlightClass = 'stability-color-good'
             }else{
                message = props.content.noStabilityStd 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >77) )	) {
            
            message = props.content.noStabilityStd 
            highlightClass = 'stability-color-bad' 
          
          }

          

          /*New logic for Skyrizi Pen Patient ends here */



        }

        if (props.isSkyriziSyringeSelectedByPPH()) {
          

           /*New logic for Skyrizi Pen PPH starts here */
            message = props.messages.bad
            highlightClass = 'stability-bad'
            
            if (((props.tempIndicator=== 'C') && (props.tempActual < -5) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <23))) {
            
            message = props.content.noStabilityStd 
            highlightClass = 'stability-color-bad' 
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -5  && props.tempActual <= 1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 23  && props.tempActual <= 35) )	) {
             message = props.content.noStabilityStd 
            highlightClass = 'stability-color-bad'

            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 2 && props.tempActual <= 8) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 36  && props.tempActual <= 46) )	) {
            
                message = props.content.skyriziPenStable 
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 9  && props.tempActual <= 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 47  && props.tempActual <= 77) )	) {
             if (props.selectedMinutes() <= 24) {
                message = props.content.skyriziPenStable 
                highlightClass = 'stability-color-good'
             }else{
                message = props.content.noStabilityStd 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >77) )	) {
            
            message = props.content.noStabilityStd 
            highlightClass = 'stability-color-bad' 
          
          }

          /*New logic for Skyrizi Pen PPH ends here */



        }
        if(props.isLuprondepotSelected()){
              message = props.content.notRecommendedLupron
              highlightClass = 'stability-color-bad' 
            if (((props.tempIndicator=== 'C') && (props.tempActual < -10) ) ||
              ((props.tempIndicator=== 'F') && (props.tempActual <14) )	){
              message = props.content.notRecommendedLupron
              highlightClass = 'stability-color-bad' 
              }

            else if (((props.tempIndicator=== 'C') && (props.tempActual >= -10  && props.tempActual <= 1) ) ||
              ((props.tempIndicator=== 'F') && (props.tempActual >= 14  && props.tempActual <= 35) )	){
              if(props.tempRangeValue !== 'BOTH_UNDER_OVER' && props.selectedMinutes() <= 96)
              {
                message = props.content.recommendedLupron 
                highlightClass = 'stability-color-good' 
              }
              else
              {
                message = props.content.notRecommendedLupron 
                highlightClass = 'stability-color-bad' 
              }
              }
              else if (((props.tempIndicator=== 'C') && (props.tempActual >= 2  && props.tempActual <= 14) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 36 && props.tempActual <= 58) )	){
              if(props.tempRangeValue !== 'BOTH_UNDER_OVER' && props.selectedMinutes() <= 192)
            {
              message = props.content.recommendedLupron 
              highlightClass = 'stability-color-good' 
            }
            else
              {
                message = props.content.notRecommendedLupron 
                highlightClass = 'stability-color-bad' 
              }
            }
          
          else if (((props.tempIndicator=== 'C') && (props.tempActual >= 15  && props.tempActual <= 25) ) ||
        ((props.tempIndicator=== 'F') && (props.tempActual >= 59 && props.tempActual <= 77) )	){
        if(props.tempRangeValue !== 'BOTH_UNDER_OVER' )
        {
          message = props.content.recommendedLupron 
          highlightClass = 'stability-color-good' 
        }
        }
        else if (((props.tempIndicator=== 'C') && (props.tempActual >= 26  && props.tempActual <= 40) ) ||
        ((props.tempIndicator=== 'F') && (props.tempActual >= 78 && props.tempActual <= 104) )	){
          if(props.tempRangeValue !== 'BOTH_UNDER_OVER' && props.selectedMinutes() <= 96)
        {
          message = props.content.recommendedLupron 
          highlightClass = 'stability-color-good' 
        }
        else
              {
                message = props.content.notRecommendedLupron 
                highlightClass = 'stability-color-bad' 
              }
        } else{
          message = props.content.notRecommendedLupron 
          highlightClass = 'stability-color-bad' 
        }


          
        }
       if (props.isSkyriziSelected() || props.isDuopaSelected() || props.isHumiraCitrateFreeSelectedByPatient() || props.isHumiraCitrateFreeSelectedByPPH() || props.isHumiraSelectedByPatient() || props.isHumiraSelectedByPPH() 
       || props.isSkyriziPenSelectedByPatient() || props.isSkyriziPenSelectedByPPH() || props.isSkyriziSyringeSelectedByPatient() || props.isSkyriziSyringeSelectedByPPH()
       || props.isLuprondepotSelected() || props.isRinvoqTabletsSelectedByPatient() || props.isRinvoqTabletsSelectedByPPH() || props.isRinvoqLiquidSelectedByPatient() || props.isRinvoqLiquidSelectedByPPH()) {
        
        
           if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
              
                message = message + '\n\n' +props.content.patientAdditionalQuestions+ '\n\n' + props.content.haveQuestions
              }else{
                message = message + '\n\n' + props.content.pphHaveQuestions
                
              }
        
        }
      /*if (props.isSkyriziSelected()) {
        
        if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
          message = message + " "+ props.content.patientAdditionalQuestions + props.content.haveQuestions
        }
      } */

      
      break
    case 'CONTINGENT': {
      if (props.userType !== PATIENT) {
        let contingentMessage = props.messages.contingent + recRangeMessage
        let contingentMessageLupron = props.messages.contingentLupronHCP // AS
        // conditional messaging for Humira
        if (props.isHumiraSelectedByPPH()) {
          

           /*New logic for Humira 40mg/0.8mL PPH starts here */
            contingentMessage = props.messages.bad
            highlightClass = 'stability-bad'
            
            if (((props.tempIndicator=== 'C') && (props.tempActual < -10) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <14))) {
            
            contingentMessage = props.content.humira40mgNostability 
            highlightClass = 'stability-color-bad' 
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -10  && props.tempActual <= -1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 14  && props.tempActual <= 31) )	) {
             if (props.selectedMinutes() <= 10) {
                contingentMessage = props.content.humira40mgreturntToFridge 
                highlightClass = 'stability-color-good'
             }else{
                contingentMessage = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 0 && props.tempActual <= 8) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 32  && props.tempActual <= 46) )	) {
            
                contingentMessage = props.content.humira40mgreturntToFridge 
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 9  && props.tempActual <= 10) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 47  && props.tempActual <= 50) )	) {
             if (props.selectedMinutes() <= 120) {
                contingentMessage = props.content.humira40mgreturntToFridge
                highlightClass = 'stability-color-good'
             }else{
                contingentMessage = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 11  && props.tempActual <= 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 51  && props.tempActual <= 77) )	) {
             if (props.selectedMinutes() <= 48) {
                contingentMessage = props.content.humira40mgreturntToFridge
                highlightClass = 'stability-color-good'
             }else{
                contingentMessage = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >77) )	) {
            
            contingentMessage = props.content.humira40mgNostability 
            highlightClass = 'stability-color-bad' 
          
          }

         
          /*New logic for Humira 40mg/0.8mL PPH ends here */



        }else if (props.isHumiraSelectedByPatient()) {
          /*if (props.isWithinTempRangePatient()) {
            if (props.isLowerBoundPatient()) {
              contingentMessage =
                contingentMessage + props.content.humiraReturnToFridge + ' '
            } else {
              contingentMessage = props.content.humiraUseSoon + ' '
            }
          }*/

           /*New logic for Humira 40mg/0.8mL Patient starts here */
            contingentMessage = props.messages.bad
            highlightClass = 'stability-bad'
            
            if (((props.tempIndicator=== 'C') && (props.tempActual < -10) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <14))) {
            
            contingentMessage = props.content.humira40mgNostability 
            highlightClass = 'stability-color-bad' 
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -10  && props.tempActual <= -1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 14  && props.tempActual <= 31) )	) {
             if (props.selectedMinutes() <= 120) {
                contingentMessage = props.content.humira40mgreturntToFridge 
                highlightClass = 'stability-color-good'
             }else{
                contingentMessage = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 0 && props.tempActual <= 8) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 32  && props.tempActual <= 46) )	) {
            
                contingentMessage = props.content.humira40mgreturntToFridge 
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 9  && props.tempActual <= 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 47  && props.tempActual <= 77) )	) {
             if (props.selectedMinutes() <= 96) {
                contingentMessage = props.content.humira40mgreturntToFridge + props.content.humira40mgMayAlso 
                highlightClass = 'stability-color-good'
             }else if (props.selectedMinutes() > 96 && props.selectedMinutes() <= 336) {
                contingentMessage = props.content.humira40mgMay 
                highlightClass = 'stability-color-good'
             }else{
                contingentMessage = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 26  && props.tempActual <= 30) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 78  && props.tempActual <= 86) )	) {
             if (props.selectedMinutes() <= 24) {
                contingentMessage = props.content.humira40mgreturntToFridge  
                highlightClass = 'stability-color-good'
             }else{
                contingentMessage = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 30) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >86) )	) {
            
            contingentMessage = props.content.humira40mgNostability 
            highlightClass = 'stability-color-bad' 
          
          }

          /*New logic for Humira 40mg/0.8mL Patient ends here */



        }else if (props.isHumiraCitrateFreeSelectedByPPH()) {
          

           /*New logic for Humira 40mg/0.8mL PPH starts here */
            contingentMessage = props.messages.bad
            highlightClass = 'stability-bad'
            
            if (((props.tempIndicator=== 'C') && (props.tempActual < -10) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <14))) {
            
            contingentMessage = props.content.humira40mgNostability 
            highlightClass = 'stability-color-bad' 
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -10  && props.tempActual <= -1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 14  && props.tempActual <= 31) )	) {
             if (props.selectedMinutes() <= 120) {
                contingentMessage = props.content.humira40mgreturntToFridge 
                highlightClass = 'stability-color-good'
             }else{
                contingentMessage = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 0 && props.tempActual <= 8) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 32  && props.tempActual <= 46) )	) {
            
                contingentMessage = props.content.humira40mgreturntToFridge 
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 9  && props.tempActual <= 15) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 47  && props.tempActual <= 59) )	) {
             if (props.selectedMinutes() <= 120) {
                contingentMessage = props.content.humira40mgreturntToFridge
                highlightClass = 'stability-color-good'
             }else{
                contingentMessage = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 16  && props.tempActual <= 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 60  && props.tempActual <= 77) )	) {
             if (props.selectedMinutes() <= 48) {
                contingentMessage = props.content.humira40mgreturntToFridge
                highlightClass = 'stability-color-good'
             }else{
                contingentMessage = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 26  && props.tempActual <= 30) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 78  && props.tempActual <= 86) )	) {
             if (props.selectedMinutes() <= 12) {
                contingentMessage = props.content.humira40mgreturntToFridge
                highlightClass = 'stability-color-good'
             }else{
                contingentMessage = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 30) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >86) )	) {
            
            contingentMessage = props.content.humira40mgNostability 
            highlightClass = 'stability-color-bad' 
          
          }

         
          /*New logic for Humira 40mg/0.8mL PPH ends here */



        }else if (props.isHumiraCitrateFreeSelectedByPatient()) {
          /*if (props.isWithinTempRangePatient()) {
            if (props.isLowerBoundPatient()) {
              contingentMessage =
                contingentMessage + props.content.humiraReturnToFridge + ' '
            } else {
              contingentMessage = props.content.humiraUseSoon + ' '
            }
          }*/

           /*New logic for Humira 40mg/0.8mL Patient starts here */
            contingentMessage = props.messages.bad
            highlightClass = 'stability-bad'
            
            if (((props.tempIndicator=== 'C') && (props.tempActual < -10) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <14))) {
            
            contingentMessage = props.content.humira40mgNostability 
            highlightClass = 'stability-color-bad' 
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -10  && props.tempActual <= -1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 14  && props.tempActual <= 31) )	) {
             if (props.selectedMinutes() <= 120) {
                contingentMessage = props.content.humira40mgreturntToFridge 
                highlightClass = 'stability-color-good'
             }else{
                contingentMessage = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 0 && props.tempActual <= 8) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 32  && props.tempActual <= 46) )	) {
            
                contingentMessage = props.content.humira40mgreturntToFridge 
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 9  && props.tempActual <= 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 47  && props.tempActual <= 77) )	) {
             if (props.selectedMinutes() <= 96) {
                contingentMessage = props.content.humira40mgreturntToFridge + props.content.humira40mgMayAlso 
                highlightClass = 'stability-color-good'
             }else if (props.selectedMinutes() > 96 && props.selectedMinutes() <= 336) {
                contingentMessage = props.content.humira40mgMay 
                highlightClass = 'stability-color-good'
             }else{
                contingentMessage = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 26  && props.tempActual <= 30) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 78  && props.tempActual <= 86) )	) {
             if (props.selectedMinutes() <= 24) {
                contingentMessage = props.content.humira40mgreturntToFridge  
                highlightClass = 'stability-color-good'
             }else{
                contingentMessage = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 30) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >86) )	) {
            
            contingentMessage = props.content.humira40mgNostability 
            highlightClass = 'stability-color-bad' 
          
          }

          /*New logic for Humira 40mg/0.8mL Patient ends here */



        }else if (props.isRinvoqTabletsSelectedByPatient()) {
         

           /*New logic for Rinvoq (15 mg, 30 mg, 45 mg tablets) Patient starts here */
            contingentMessage = props.messages.bad
            if (((props.tempIndicator=== 'C') && (props.tempActual < -20) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <-4))) {
            
             
           contingentMessage = props.content.noStabilityStd 
           highlightClass = 'stability-color-bad'
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -20  && props.tempActual <= 1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= -4  && props.tempActual <= 35) )	) {
             if (props.selectedMinutes() <= 72) {
                 
                contingentMessage = props.content.rinvoqTabletStable
                highlightClass = 'stability-color-good'
             }else{
                 
               contingentMessage = props.content.noStabilityStd
               highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 2 && props.tempActual <= 30) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 36  && props.tempActual <= 86) )	) {
            
                 
                contingentMessage = props.content.rinvoqTabletStable
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 31  && props.tempActual <= 40) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 87  && props.tempActual <= 104) )	) {
              if (props.selectedMinutes() <= 144) {
                 
                contingentMessage = props.content.rinvoqTabletStable
                highlightClass = 'stability-color-good'
             }else{
                 
               contingentMessage = props.content.noStabilityStd
               highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 41  && props.tempActual <= 50) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 105  && props.tempActual <= 122) )	) {
              if (props.selectedMinutes() <= 72) {
                 
                contingentMessage = props.content.rinvoqTabletStable
                highlightClass = 'stability-color-good'
             }else{
                 
               contingentMessage = props.content.noStabilityStd
               highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 50) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >122) )	) {
            
             
           contingentMessage = props.content.noStabilityStd 
           highlightClass = 'stability-color-bad'
          
          }

          /*New logic for Rinvoq (15 mg, 30 mg, 45 mg tablets) Patient starts here */



        }else if (props.isRinvoqTabletsSelectedByPPH()) {
         

           /*New logic for Rinvoq (15 mg, 30 mg, 45 mg tablets) PPH starts here */
            contingentMessage = props.messages.bad
            if (((props.tempIndicator=== 'C') && (props.tempActual < -20) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <-4))) {
            
             
           contingentMessage = props.content.noStabilityStd 
           highlightClass = 'stability-color-bad'
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -20  && props.tempActual <= 1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= -4  && props.tempActual <= 35) )	) {
             if (props.selectedMinutes() <= 48) {
                 
                contingentMessage = props.content.rinvoqTabletStable
                highlightClass = 'stability-color-good'
             }else{
                 
               contingentMessage = props.content.noStabilityStd
               highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 2 && props.tempActual <= 30) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 36  && props.tempActual <= 86) )	) {
            
                 
                contingentMessage = props.content.rinvoqTabletStable
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 31  && props.tempActual <= 40) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 87  && props.tempActual <= 104) )	) {
              if (props.selectedMinutes() <= 96) {
                 
                contingentMessage = props.content.rinvoqTabletStable
                highlightClass = 'stability-color-good'
             }else{
                 
               contingentMessage = props.content.noStabilityStd
               highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 41  && props.tempActual <= 50) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 105  && props.tempActual <= 122) )	) {
              if (props.selectedMinutes() <= 48) {
                 
                contingentMessage = props.content.rinvoqTabletStable
                highlightClass = 'stability-color-good'
             }else{
                 
               contingentMessage = props.content.noStabilityStd
               highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 50) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >122) )	) {
            
             
           contingentMessage = props.content.noStabilityStd 
           highlightClass = 'stability-color-bad'
          
          }

          /*New logic for Rinvoq (15 mg, 30 mg, 45 mg tablets) PPH Ends here */



        }else if (props.isRinvoqLiquidSelectedByPatient()) {
         

           /*New logic for Rinvoq (15 mg, 30 mg, 45 mg tablets) Patient starts here */
            contingentMessage = props.messages.bad
            if (((props.tempIndicator=== 'C') && (props.tempActual < -20) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <-4))) {
            
             
           contingentMessage = props.content.noStabilityStd 
           highlightClass = 'stability-color-bad'
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -20  && props.tempActual <= 1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= -4  && props.tempActual <= 35) )	) {
             if (props.selectedMinutes() <= 72) {
                 
                contingentMessage = props.content.rinvoqLiquidStable
                highlightClass = 'stability-color-good'
             }else{
                 
               contingentMessage = props.content.noStabilityStd
               highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 2 && props.tempActual <= 30) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 36  && props.tempActual <= 86) )	) {
            
                 
                contingentMessage = props.content.rinvoqLiquidStable
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 31  && props.tempActual <= 40) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 87  && props.tempActual <= 104) )	) {
              if (props.selectedMinutes() <= 144) {
                 
                contingentMessage = props.content.rinvoqLiquidStable
                highlightClass = 'stability-color-good'
             }else{
                 
               contingentMessage = props.content.noStabilityStd
               highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 41  && props.tempActual <= 50) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 105  && props.tempActual <= 122) )	) {
              if (props.selectedMinutes() <= 96) {
                 
                contingentMessage = props.content.rinvoqLiquidStable
                highlightClass = 'stability-color-good'
             }else{
                 
               contingentMessage = props.content.noStabilityStd
               highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 50) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >122) )	) {
            
             
           contingentMessage = props.content.noStabilityStd 
           highlightClass = 'stability-color-bad'
          
          }

          /*New logic for Rinvoq (15 mg, 30 mg, 45 mg tablets) Patient starts here */



        }else if (props.isRinvoqLiquidSelectedByPPH()) {
         

           /*New logic for Rinvoq (15 mg, 30 mg, 45 mg tablets) PPH starts here */
            contingentMessage = props.messages.bad
            if (((props.tempIndicator=== 'C') && (props.tempActual < -20) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <-4))) {
            
             
           contingentMessage = props.content.noStabilityStd 
           highlightClass = 'stability-color-bad'
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -20  && props.tempActual <= 1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= -4  && props.tempActual <= 35) )	) {
             if (props.selectedMinutes() <= 72) {
                 
                contingentMessage = props.content.rinvoqLiquidStable
                highlightClass = 'stability-color-good'
             }else{
                 
               contingentMessage = props.content.noStabilityStd
               highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 2 && props.tempActual <= 30) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 36  && props.tempActual <= 86) )	) {
            
                 
                contingentMessage = props.content.rinvoqLiquidStable
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 31  && props.tempActual <= 40) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 87  && props.tempActual <= 104) )	) {
              if (props.selectedMinutes() <= 144) {
                 
                contingentMessage = props.content.rinvoqLiquidStable
                highlightClass = 'stability-color-good'
             }else{
                 
               contingentMessage = props.content.noStabilityStd
               highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 41  && props.tempActual <= 50) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 105  && props.tempActual <= 122) )	) {
              if (props.selectedMinutes() <= 72) {
                 
                contingentMessage = props.content.rinvoqLiquidStable
                highlightClass = 'stability-color-good'
             }else{
                 
               contingentMessage = props.content.noStabilityStd
               highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 50) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >122) )	) {
            
             
           contingentMessage = props.content.noStabilityStd 
           highlightClass = 'stability-color-bad'
          
          }

          /*New logic for Rinvoq (15 mg, 30 mg, 45 mg tablets) PPH Ends here */



        }   else if (props.isVenetoclaxSelected()) {
          contingentMessage = props.content.venetoclaxReturnToContainer + recRangeMessage
        } else if(props.isLuprondepotSelected()){
              contingentMessage = props.content.notRecommendedLupron
              highlightClass = 'stability-color-bad' 
            if (((props.tempIndicator=== 'C') && (props.tempActual < -10) ) ||
              ((props.tempIndicator=== 'F') && (props.tempActual <14) )	){
              contingentMessage = props.content.notRecommendedLupron
              highlightClass = 'stability-color-bad' 
              }

            else if (((props.tempIndicator=== 'C') && (props.tempActual >= -10  && props.tempActual <= 1) ) ||
              ((props.tempIndicator=== 'F') && (props.tempActual >= 14  && props.tempActual <= 35) )	){
              if(props.tempRangeValue !== 'BOTH_UNDER_OVER' && props.selectedMinutes() <= 96)
              {
                contingentMessage = props.content.recommendedLupron 
                highlightClass = 'stability-color-good' 
              }
              else
              {
                contingentMessage = props.content.notRecommendedLupron 
                highlightClass = 'stability-color-bad' 
              }
              }
              else if (((props.tempIndicator=== 'C') && (props.tempActual >= 2  && props.tempActual <= 14) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 36 && props.tempActual <= 58) )	){
              if(props.tempRangeValue !== 'BOTH_UNDER_OVER' && props.selectedMinutes() <= 192)
            {
              contingentMessage = props.content.recommendedLupron 
              highlightClass = 'stability-color-good' 
            }
            else
              {
                contingentMessage = props.content.notRecommendedLupron 
                highlightClass = 'stability-color-bad' 
              }
            }
          
          else if (((props.tempIndicator=== 'C') && (props.tempActual >= 15  && props.tempActual <= 25) ) ||
        ((props.tempIndicator=== 'F') && (props.tempActual >= 59 && props.tempActual <= 77) )	){
        if(props.tempRangeValue !== 'BOTH_UNDER_OVER' )
        {
          contingentMessage = props.content.recommendedLupron 
          highlightClass = 'stability-color-good' 
        }
        }
        else if (((props.tempIndicator=== 'C') && (props.tempActual >= 26  && props.tempActual <= 40) ) ||
        ((props.tempIndicator=== 'F') && (props.tempActual >= 78 && props.tempActual <= 104) )	){
          if(props.tempRangeValue !== 'BOTH_UNDER_OVER' && props.selectedMinutes() <= 96)
        {
          contingentMessage = props.content.recommendedLupron 
          highlightClass = 'stability-color-good' 
        }
        else
              {
                contingentMessage = props.content.notRecommendedLupron 
                highlightClass = 'stability-color-bad' 
              }
        } else{
          contingentMessage = props.content.notRecommendedLupron 
          highlightClass = 'stability-color-bad' 
        }


          
        }else if (props.isSkyriziPenSelectedByPatient()) {
          

           /*New logic for Skyrizi Pen Patient starts here */
            contingentMessage = props.messages.bad
            highlightClass = 'stability-bad'
            
            if (((props.tempIndicator=== 'C') && (props.tempActual < -5) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <23))) {
            
            contingentMessage = props.content.noStabilityStd 
            highlightClass = 'stability-color-bad' 
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -5  && props.tempActual <= 1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 23  && props.tempActual <= 35) )	) {
             if (props.selectedMinutes() <= 120) {
                contingentMessage = props.content.skyriziPenStable 
                highlightClass = 'stability-color-good'
             }else{
                contingentMessage = props.content.noStabilityStd 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 2 && props.tempActual <= 8) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 36  && props.tempActual <= 46) )	) {
            
                contingentMessage = props.content.skyriziPenStable 
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 9  && props.tempActual <= 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 47  && props.tempActual <= 77) )	) {
              if (props.selectedMinutes() <= 24) {
                contingentMessage = props.content.skyriziPenStable 
                highlightClass = 'stability-color-good'
             }else{
                contingentMessage = props.content.noStabilityStd 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >77) )	) {
            
            contingentMessage = props.content.noStabilityStd 
            highlightClass = 'stability-color-bad' 
          
          }

          

          /*New logic for Skyrizi Pen Patient ends here */



        }else if (props.isSkyriziPenSelectedByPPH()) {
          

           /*New logic for Skyrizi Pen PPH starts here */
            contingentMessage = props.messages.bad
            highlightClass = 'stability-bad'
            
            if (((props.tempIndicator=== 'C') && (props.tempActual < -5) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <23))) {
            
            contingentMessage = props.content.noStabilityStd 
            highlightClass = 'stability-color-bad' 
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -5  && props.tempActual <= 1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 23  && props.tempActual <= 35) )	) {
             if (props.selectedMinutes() <= 72) {
                contingentMessage = props.content.skyriziPenStable 
                highlightClass = 'stability-color-good'
             }else{
                contingentMessage = props.content.noStabilityStd 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 2 && props.tempActual <= 8) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 36  && props.tempActual <= 46) )	) {
            
                contingentMessage = props.content.skyriziPenStable 
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 9  && props.tempActual <= 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 47  && props.tempActual <= 77) )	) {
             if (props.selectedMinutes() <= 24) {
                contingentMessage = props.content.skyriziPenStable 
                highlightClass = 'stability-color-good'
             }else{
                contingentMessage = props.content.noStabilityStd 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >77) )	) {
            
            contingentMessage = props.content.noStabilityStd 
            highlightClass = 'stability-color-bad' 
          
          }

         
          /*New logic for Skyrizi Pen PPH ends here */



        }else if (props.isSkyriziSyringeSelectedByPatient()) {
          

           /*New logic for Skyrizi Pen Patient starts here */
            contingentMessage = props.messages.bad
            highlightClass = 'stability-bad'
            
            if (((props.tempIndicator=== 'C') && (props.tempActual < -5) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <23))) {
            
            contingentMessage = props.content.noStabilityStd 
            highlightClass = 'stability-color-bad' 
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -5  && props.tempActual <= 1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 23  && props.tempActual <= 35) )	) {
             contingentMessage = props.content.noStabilityStd 
            highlightClass = 'stability-color-bad'          
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 2 && props.tempActual <= 8) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 36  && props.tempActual <= 46) )	) {
            
                contingentMessage = props.content.skyriziPenStable 
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 9  && props.tempActual <= 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 47  && props.tempActual <= 77) )	) {
              if (props.selectedMinutes() <= 24) {
                contingentMessage = props.content.skyriziPenStable 
                highlightClass = 'stability-color-good'
             }else{
                contingentMessage = props.content.noStabilityStd 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >77) )	) {
            
            contingentMessage = props.content.noStabilityStd 
            highlightClass = 'stability-color-bad' 
          
          }

          

          /*New logic for Skyrizi Pen Patient ends here */



        }else if (props.isSkyriziSyringeSelectedByPPH()) {
          

           /*New logic for Skyrizi Pen PPH starts here */
            contingentMessage = props.messages.bad
            highlightClass = 'stability-bad'
            
            if (((props.tempIndicator=== 'C') && (props.tempActual < -5) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <23))) {
            
            contingentMessage = props.content.noStabilityStd 
            highlightClass = 'stability-color-bad' 
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -5  && props.tempActual <= 1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 23  && props.tempActual <= 35) )	) {
             contingentMessage = props.content.noStabilityStd 
            highlightClass = 'stability-color-bad'           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 2 && props.tempActual <= 8) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 36  && props.tempActual <= 46) )	) {
            
                contingentMessage = props.content.skyriziPenStable 
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 9  && props.tempActual <= 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 47  && props.tempActual <= 77) )	) {
             if (props.selectedMinutes() <= 24) {
                contingentMessage = props.content.skyriziPenStable 
                highlightClass = 'stability-color-good'
             }else{
                contingentMessage = props.content.noStabilityStd 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >77) )	) {
            
            contingentMessage = props.content.noStabilityStd 
            highlightClass = 'stability-color-bad' 
          
          }

         
          /*New logic for Skyrizi Pen PPH ends here */



        }
        
       // message = contingentMessage

       if (props.isSkyriziSelected() || props.isDuopaSelected() || props.isHumiraCitrateFreeSelectedByPatient() || props.isHumiraCitrateFreeSelectedByPPH() || props.isHumiraSelectedByPatient() || props.isHumiraSelectedByPPH()
       || props.isSkyriziPenSelectedByPatient() || props.isSkyriziPenSelectedByPPH() || props.isSkyriziSyringeSelectedByPatient() || props.isSkyriziSyringeSelectedByPPH() 
       || props.isLuprondepotSelected() || props.isRinvoqTabletsSelectedByPatient() || props.isRinvoqTabletsSelectedByPPH() 
       || props.isRinvoqLiquidSelectedByPatient() || props.isRinvoqLiquidSelectedByPPH()) {
         message = contingentMessage 
        
           if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
             // if(props.isSkyriziOBISelected())
              //  message = message + " "+ props.content.haveQuestions
             // else
                message = message + '\n\n' +props.content.patientAdditionalQuestions+ '\n\n' + props.content.haveQuestions
              }else{
                message = message + '\n\n' + props.content.pphHaveQuestions
                
              }
        
        }else{
          message = contingentMessage + '\n\n' + message
        } 
      } else {
        let contingentMessage = props.content.safeToUsePatient + ' ' + props.content.returnToFridgePatient + recRangeMessage
        // Change required Here for returnToFridgePatient
        // AS 
        //let contingentMessageLupron = props.content.safeToUsePatient + '\n \n' + props.content.returnToFridgePatient + recRangeMessage
        let contingentMessageLupron = props.content.contingentLupron
        // conditional messaging for Humira
         if (props.isHumiraSelectedByPPH()) {
          

           /*New logic for Humira 40mg/0.8mL PPH starts here */
            contingentMessage = props.messages.bad
            highlightClass = 'stability-bad'
            
            if (((props.tempIndicator=== 'C') && (props.tempActual < -10) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <14))) {
            
            contingentMessage = props.content.humira40mgNostability 
            highlightClass = 'stability-color-bad' 
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -10  && props.tempActual <= -1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 14  && props.tempActual <= 31) )	) {
             if (props.selectedMinutes() <= 10) {
                contingentMessage = props.content.humira40mgreturntToFridge 
                highlightClass = 'stability-color-good'
             }else{
                contingentMessage = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 0 && props.tempActual <= 8) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 32  && props.tempActual <= 46) )	) {
            
                contingentMessage = props.content.humira40mgreturntToFridge 
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 9  && props.tempActual <= 10) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 47  && props.tempActual <= 50) )	) {
             if (props.selectedMinutes() <= 120) {
                contingentMessage = props.content.humira40mgreturntToFridge
                highlightClass = 'stability-color-good'
             }else{
                contingentMessage = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 11  && props.tempActual <= 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 51  && props.tempActual <= 77) )	) {
             if (props.selectedMinutes() <= 48) {
                contingentMessage = props.content.humira40mgreturntToFridge
                highlightClass = 'stability-color-good'
             }else{
                contingentMessage = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >77) )	) {
            
            contingentMessage = props.content.humira40mgNostability 
            highlightClass = 'stability-color-bad' 
          
          }

         
          /*New logic for Humira 40mg/0.8mL PPH ends here */



        }else if (props.isHumiraSelectedByPatient()) {
          /*if (props.isWithinTempRangePatient()) {
            if (props.isLowerBoundPatient()) {
              contingentMessage =
                contingentMessage + props.content.humiraReturnToFridge + ' '
            } else {
              contingentMessage = props.content.humiraUseSoon + ' '
            }
          }*/

           /*New logic for Humira 40mg/0.8mL Patient starts here */
            contingentMessage = props.messages.bad
            highlightClass = 'stability-bad'
            
            if (((props.tempIndicator=== 'C') && (props.tempActual < -10) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <14))) {
            
            contingentMessage = props.content.humira40mgNostability 
            highlightClass = 'stability-color-bad' 
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -10  && props.tempActual <= -1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 14  && props.tempActual <= 31) )	) {
             if (props.selectedMinutes() <= 10) {
                contingentMessage = props.content.humira40mgreturntToFridge 
                highlightClass = 'stability-color-good'
             }else{
                contingentMessage = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 0 && props.tempActual <= 8) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 32  && props.tempActual <= 46) )	) {
            
                contingentMessage = props.content.humira40mgreturntToFridge 
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 9  && props.tempActual <= 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 47  && props.tempActual <= 77) )	) {
             if (props.selectedMinutes() <= 96) {
                contingentMessage = props.content.humira40mgreturntToFridge + props.content.humira40mgMayAlso 
                highlightClass = 'stability-color-good'
             }else if (props.selectedMinutes() > 96 && props.selectedMinutes() <= 336) {
                contingentMessage = props.content.humira40mgMay 
                highlightClass = 'stability-color-good'
             }else{
                contingentMessage = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 26  && props.tempActual <= 30) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 78  && props.tempActual <= 86) )	) {
             if (props.selectedMinutes() <= 24) {
                contingentMessage = props.content.humira40mgreturntToFridge  
                highlightClass = 'stability-color-good'
             }else{
                contingentMessage = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 30) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >86) )	) {
            
            contingentMessage = props.content.humira40mgNostability 
            highlightClass = 'stability-color-bad' 
          
          }

          /*New logic for Humira 40mg/0.8mL Patient ends here */



        }else  if (props.isHumiraCitrateFreeSelectedByPPH()) {
          

           /*New logic for Humira 40mg/0.8mL PPH starts here */
            contingentMessage = props.messages.bad
            highlightClass = 'stability-bad'
            
            if (((props.tempIndicator=== 'C') && (props.tempActual < -10) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <14))) {
            
            contingentMessage = props.content.humira40mgNostability 
            highlightClass = 'stability-color-bad' 
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -10  && props.tempActual <= -1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 14  && props.tempActual <= 31) )	) {
             if (props.selectedMinutes() <= 120) {
                contingentMessage = props.content.humira40mgreturntToFridge 
                highlightClass = 'stability-color-good'
             }else{
                contingentMessage = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 0 && props.tempActual <= 8) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 32  && props.tempActual <= 46) )	) {
            
                contingentMessage = props.content.humira40mgreturntToFridge 
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 9  && props.tempActual <= 15) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 47  && props.tempActual <= 59) )	) {
             if (props.selectedMinutes() <= 120) {
                contingentMessage = props.content.humira40mgreturntToFridge
                highlightClass = 'stability-color-good'
             }else{
                contingentMessage = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 16  && props.tempActual <= 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 60  && props.tempActual <= 77) )	) {
             if (props.selectedMinutes() <= 48) {
                contingentMessage = props.content.humira40mgreturntToFridge
                highlightClass = 'stability-color-good'
             }else{
                contingentMessage = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 26  && props.tempActual <= 30) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 78  && props.tempActual <= 86) )	) {
             if (props.selectedMinutes() <= 12) {
                contingentMessage = props.content.humira40mgreturntToFridge
                highlightClass = 'stability-color-good'
             }else{
                contingentMessage = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 30) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >86) )	) {
            
            contingentMessage = props.content.humira40mgNostability 
            highlightClass = 'stability-color-bad' 
          
          }

         
          /*New logic for Humira 40mg/0.8mL PPH ends here */



        }else if (props.isHumiraCitrateFreeSelectedByPatient()) {
          /*if (props.isWithinTempRangePatient()) {
            if (props.isLowerBoundPatient()) {
              contingentMessage =
                contingentMessage + props.content.humiraReturnToFridge + ' '
            } else {
              contingentMessage = props.content.humiraUseSoon + ' '
            }
          }*/

           /*New logic for Humira 40mg/0.8mL Patient starts here */
            contingentMessage = props.messages.bad
            highlightClass = 'stability-bad'
            
            if (((props.tempIndicator=== 'C') && (props.tempActual < -10) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <14))) {
            
            contingentMessage = props.content.humira40mgNostability 
            highlightClass = 'stability-color-bad' 
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -10  && props.tempActual <= -1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 14  && props.tempActual <= 31) )	) {
             if (props.selectedMinutes() <= 120) {
                contingentMessage = props.content.humira40mgreturntToFridge 
                highlightClass = 'stability-color-good'
             }else{
                contingentMessage = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 0 && props.tempActual <= 8) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 32  && props.tempActual <= 46) )	) {
            
                contingentMessage = props.content.humira40mgreturntToFridge 
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 9  && props.tempActual <= 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 47  && props.tempActual <= 77) )	) {
             if (props.selectedMinutes() <= 96) {
                contingentMessage = props.content.humira40mgreturntToFridge + props.content.humira40mgMayAlso 
                highlightClass = 'stability-color-good'
             }else if (props.selectedMinutes() > 96 && props.selectedMinutes() <= 336) {
                contingentMessage = props.content.humira40mgMay 
                highlightClass = 'stability-color-good'
             }else{
                contingentMessage = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 26  && props.tempActual <= 30) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 78  && props.tempActual <= 86) )	) {
             if (props.selectedMinutes() <= 24) {
                contingentMessage = props.content.humira40mgreturntToFridge  
                highlightClass = 'stability-color-good'
             }else{
                contingentMessage = props.content.humira40mgNostability 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 30) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >86) )	) {
            
            contingentMessage = props.content.humira40mgNostability 
            highlightClass = 'stability-color-bad' 
          
          }

          /*New logic for Humira 40mg/0.8mL Patient ends here */



        }else if (props.isRinvoqTabletsSelectedByPatient()) {
         

           /*New logic for Rinvoq (15 mg, 30 mg, 45 mg tablets) Patient starts here */
            contingentMessage = props.messages.bad
            if (((props.tempIndicator=== 'C') && (props.tempActual < -20) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <-4))) {
            
             
           contingentMessage = props.content.noStabilityStd 
           highlightClass = 'stability-color-bad'
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -20  && props.tempActual <= 1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= -4  && props.tempActual <= 35) )	) {
             if (props.selectedMinutes() <= 72) {
                 
                contingentMessage = props.content.rinvoqTabletStable
                highlightClass = 'stability-color-good'
             }else{
                 
               contingentMessage = props.content.noStabilityStd
               highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 2 && props.tempActual <= 30) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 36  && props.tempActual <= 86) )	) {
            
                 
                contingentMessage = props.content.rinvoqTabletStable
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 31  && props.tempActual <= 40) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 87  && props.tempActual <= 104) )	) {
              if (props.selectedMinutes() <= 144) {
                 
                contingentMessage = props.content.rinvoqTabletStable
                highlightClass = 'stability-color-good'
             }else{
                 
               contingentMessage = props.content.noStabilityStd
               highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 41  && props.tempActual <= 50) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 105  && props.tempActual <= 122) )	) {
              if (props.selectedMinutes() <= 72) {
                 
                contingentMessage = props.content.rinvoqTabletStable
                highlightClass = 'stability-color-good'
             }else{
                 
               contingentMessage = props.content.noStabilityStd
               highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 50) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >122) )	) {
            
             
           contingentMessage = props.content.noStabilityStd 
           highlightClass = 'stability-color-bad'
          
          }

          /*New logic for Rinvoq (15 mg, 30 mg, 45 mg tablets) Patient starts here */



        }else if (props.isRinvoqTabletsSelectedByPPH()) {
         

           /*New logic for Rinvoq (15 mg, 30 mg, 45 mg tablets) PPH starts here */
            contingentMessage = props.messages.bad
            if (((props.tempIndicator=== 'C') && (props.tempActual < -20) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <-4))) {
            
             
           contingentMessage = props.content.noStabilityStd 
           highlightClass = 'stability-color-bad'
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -20  && props.tempActual <= 1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= -4  && props.tempActual <= 35) )	) {
             if (props.selectedMinutes() <= 48) {
                 
                contingentMessage = props.content.rinvoqTabletStable
                highlightClass = 'stability-color-good'
             }else{
                 
               contingentMessage = props.content.noStabilityStd
               highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 2 && props.tempActual <= 30) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 36  && props.tempActual <= 86) )	) {
            
                 
                contingentMessage = props.content.rinvoqTabletStable
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 31  && props.tempActual <= 40) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 87  && props.tempActual <= 104) )	) {
              if (props.selectedMinutes() <= 96) {
                 
                contingentMessage = props.content.rinvoqTabletStable
                highlightClass = 'stability-color-good'
             }else{
                 
               contingentMessage = props.content.noStabilityStd
               highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 41  && props.tempActual <= 50) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 105  && props.tempActual <= 122) )	) {
              if (props.selectedMinutes() <= 48) {
                 
                contingentMessage = props.content.rinvoqTabletStable
                highlightClass = 'stability-color-good'
             }else{
                 
               contingentMessage = props.content.noStabilityStd
               highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 50) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >122) )	) {
            
             
           contingentMessage = props.content.noStabilityStd 
           highlightClass = 'stability-color-bad'
          
          }

          /*New logic for Rinvoq (15 mg, 30 mg, 45 mg tablets) PPH Ends here */



        }else if (props.isRinvoqLiquidSelectedByPatient()) {
         

           /*New logic for Rinvoq (15 mg, 30 mg, 45 mg tablets) Patient starts here */
            contingentMessage = props.messages.bad
            if (((props.tempIndicator=== 'C') && (props.tempActual < -20) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <-4))) {
            
             
           contingentMessage = props.content.noStabilityStd 
           highlightClass = 'stability-color-bad'
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -20  && props.tempActual <= 1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= -4  && props.tempActual <= 35) )	) {
             if (props.selectedMinutes() <= 72) {
                 
                contingentMessage = props.content.rinvoqLiquidStable
                highlightClass = 'stability-color-good'
             }else{
                 
               contingentMessage = props.content.noStabilityStd
               highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 2 && props.tempActual <= 30) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 36  && props.tempActual <= 86) )	) {
            
                 
                contingentMessage = props.content.rinvoqLiquidStable
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 31  && props.tempActual <= 40) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 87  && props.tempActual <= 104) )	) {
              if (props.selectedMinutes() <= 144) {
                 
                contingentMessage = props.content.rinvoqLiquidStable
                highlightClass = 'stability-color-good'
             }else{
                 
               contingentMessage = props.content.noStabilityStd
               highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 41  && props.tempActual <= 50) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 105  && props.tempActual <= 122) )	) {
              if (props.selectedMinutes() <= 96) {
                 
                contingentMessage = props.content.rinvoqLiquidStable
                highlightClass = 'stability-color-good'
             }else{
                 
               contingentMessage = props.content.noStabilityStd
               highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 50) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >122) )	) {
            
             
           contingentMessage = props.content.noStabilityStd 
           highlightClass = 'stability-color-bad'
          
          }

          /*New logic for Rinvoq (15 mg, 30 mg, 45 mg tablets) Patient starts here */



        }else if (props.isRinvoqLiquidSelectedByPPH()) {
         

           /*New logic for Rinvoq (15 mg, 30 mg, 45 mg tablets) PPH starts here */
            contingentMessage = props.messages.bad
            if (((props.tempIndicator=== 'C') && (props.tempActual < -20) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <-4))) {
            
             
           contingentMessage = props.content.noStabilityStd 
           highlightClass = 'stability-color-bad'
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -20  && props.tempActual <= 1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= -4  && props.tempActual <= 35) )	) {
             if (props.selectedMinutes() <= 72) {
                 
                contingentMessage = props.content.rinvoqLiquidStable
                highlightClass = 'stability-color-good'
             }else{
                 
               contingentMessage = props.content.noStabilityStd
               highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 2 && props.tempActual <= 30) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 36  && props.tempActual <= 86) )	) {
            
                 
                contingentMessage = props.content.rinvoqLiquidStable
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 31  && props.tempActual <= 40) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 87  && props.tempActual <= 104) )	) {
              if (props.selectedMinutes() <= 144) {
                 
                contingentMessage = props.content.rinvoqLiquidStable
                highlightClass = 'stability-color-good'
             }else{
                 
               contingentMessage = props.content.noStabilityStd
               highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 41  && props.tempActual <= 50) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 105  && props.tempActual <= 122) )	) {
              if (props.selectedMinutes() <= 72) {
                 
                contingentMessage = props.content.rinvoqLiquidStable
                highlightClass = 'stability-color-good'
             }else{
                 
               contingentMessage = props.content.noStabilityStd
               highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 50) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >122) )	) {
            
             
           contingentMessage = props.content.noStabilityStd 
           highlightClass = 'stability-color-bad'
          
          }

          /*New logic for Rinvoq (15 mg, 30 mg, 45 mg tablets) PPH Ends here */



        }  else if (props.isVenetoclaxSelected()) {
          contingentMessage = props.content.safeToUsePatient + '\n \n' + props.content.venetoclaxReturnToContainer + recRangeMessage
        }  else if(props.isLuprondepotSelected()){
              contingentMessage = props.content.notRecommendedLupron
              highlightClass = 'stability-color-bad' 
            if (((props.tempIndicator=== 'C') && (props.tempActual < -10) ) ||
              ((props.tempIndicator=== 'F') && (props.tempActual <14) )	){
              contingentMessage = props.content.notRecommendedLupron
              highlightClass = 'stability-color-bad' 
              }

            else if (((props.tempIndicator=== 'C') && (props.tempActual >= -10  && props.tempActual <= 1) ) ||
              ((props.tempIndicator=== 'F') && (props.tempActual >= 14  && props.tempActual <= 35) )	){
              if(props.tempRangeValue !== 'BOTH_UNDER_OVER' && props.selectedMinutes() <= 96)
              {
                contingentMessage = props.content.recommendedLupron 
                highlightClass = 'stability-color-good' 
              }
              else
              {
                contingentMessage = props.content.notRecommendedLupron 
                highlightClass = 'stability-color-bad' 
              }
              }
              else if (((props.tempIndicator=== 'C') && (props.tempActual >= 2  && props.tempActual <= 14) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 36 && props.tempActual <= 58) )	){
              if(props.tempRangeValue !== 'BOTH_UNDER_OVER' && props.selectedMinutes() <= 192)
            {
              contingentMessage = props.content.recommendedLupron 
              highlightClass = 'stability-color-good' 
            }
            else
              {
                contingentMessage = props.content.notRecommendedLupron 
                highlightClass = 'stability-color-bad' 
              }
            }
          
          else if (((props.tempIndicator=== 'C') && (props.tempActual >= 15  && props.tempActual <= 25) ) ||
        ((props.tempIndicator=== 'F') && (props.tempActual >= 59 && props.tempActual <= 77) )	){
        if(props.tempRangeValue !== 'BOTH_UNDER_OVER' )
        {
          contingentMessage = props.content.recommendedLupron 
          highlightClass = 'stability-color-good' 
        }
        }
        else if (((props.tempIndicator=== 'C') && (props.tempActual >= 26  && props.tempActual <= 40) ) ||
        ((props.tempIndicator=== 'F') && (props.tempActual >= 78 && props.tempActual <= 104) )	){
          if(props.tempRangeValue !== 'BOTH_UNDER_OVER' && props.selectedMinutes() <= 96)
        {
          contingentMessage = props.content.recommendedLupron 
          highlightClass = 'stability-color-good' 
        }
        else
              {
                contingentMessage = props.content.notRecommendedLupron 
                highlightClass = 'stability-color-bad' 
              }
        } else{
          contingentMessage = props.content.notRecommendedLupron 
          highlightClass = 'stability-color-bad' 
        }


          
        }else if (props.isSkyriziPenSelectedByPatient()) {
          

           /*New logic for Skyrizi Pen Patient starts here */
            contingentMessage = props.messages.bad
            highlightClass = 'stability-bad'
            
            if (((props.tempIndicator=== 'C') && (props.tempActual < -5) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <23))) {
            
            contingentMessage = props.content.noStabilityStd 
            highlightClass = 'stability-color-bad' 
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -5  && props.tempActual <= 1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 23  && props.tempActual <= 35) )	) {
             if (props.selectedMinutes() <= 120) {
                contingentMessage = props.content.skyriziPenStable 
                highlightClass = 'stability-color-good'
             }else{
                contingentMessage = props.content.noStabilityStd 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 2 && props.tempActual <= 8) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 36  && props.tempActual <= 46) )	) {
            
                contingentMessage = props.content.skyriziPenStable 
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 9  && props.tempActual <= 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 47  && props.tempActual <= 77) )	) {
              if (props.selectedMinutes() <= 24) {
                contingentMessage = props.content.skyriziPenStable 
                highlightClass = 'stability-color-good'
             }else{
                contingentMessage = props.content.noStabilityStd 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >77) )	) {
            
            contingentMessage = props.content.noStabilityStd 
            highlightClass = 'stability-color-bad' 
          
          }

          

          /*New logic for Skyrizi Pen Patient ends here */



        }else if (props.isSkyriziPenSelectedByPPH()) {
          

           /*New logic for Skyrizi Pen PPH starts here */
            contingentMessage = props.messages.bad
            highlightClass = 'stability-bad'
            
            if (((props.tempIndicator=== 'C') && (props.tempActual < -5) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <23))) {
            
            contingentMessage = props.content.noStabilityStd 
            highlightClass = 'stability-color-bad' 
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -5  && props.tempActual <= 1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 23  && props.tempActual <= 35) )	) {
             if (props.selectedMinutes() <= 72) {
                contingentMessage = props.content.skyriziPenStable 
                highlightClass = 'stability-color-good'
             }else{
                contingentMessage = props.content.noStabilityStd 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 2 && props.tempActual <= 8) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 36  && props.tempActual <= 46) )	) {
            
                contingentMessage = props.content.skyriziPenStable 
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 9  && props.tempActual <= 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 47  && props.tempActual <= 77) )	) {
             if (props.selectedMinutes() <= 24) {
                contingentMessage = props.content.skyriziPenStable 
                highlightClass = 'stability-color-good'
             }else{
                contingentMessage = props.content.noStabilityStd 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >77) )	) {
            
            contingentMessage = props.content.noStabilityStd 
            highlightClass = 'stability-color-bad' 
          
          }

         
          /*New logic for Skyrizi Pen PPH ends here */



        }else if (props.isSkyriziSyringeSelectedByPatient()) {
          

           /*New logic for Skyrizi Pen Patient starts here */
            contingentMessage = props.messages.bad
            highlightClass = 'stability-bad'
            
            if (((props.tempIndicator=== 'C') && (props.tempActual < -5) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <23))) {
            
            contingentMessage = props.content.noStabilityStd 
            highlightClass = 'stability-color-bad' 
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -5  && props.tempActual <= 1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 23  && props.tempActual <= 35) )	) {
             contingentMessage = props.content.noStabilityStd 
            highlightClass = 'stability-color-bad'          
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 2 && props.tempActual <= 8) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 36  && props.tempActual <= 46) )	) {
            
                contingentMessage = props.content.skyriziPenStable 
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 9  && props.tempActual <= 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 47  && props.tempActual <= 77) )	) {
              if (props.selectedMinutes() <= 24) {
                contingentMessage = props.content.skyriziPenStable 
                highlightClass = 'stability-color-good'
             }else{
                contingentMessage = props.content.noStabilityStd 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >77) )	) {
            
            contingentMessage = props.content.noStabilityStd 
            highlightClass = 'stability-color-bad' 
          
          }

          

          /*New logic for Skyrizi Pen Patient ends here */



        }else if (props.isSkyriziSyringeSelectedByPPH()) {
          

           /*New logic for Skyrizi Pen PPH starts here */
            contingentMessage = props.messages.bad
            highlightClass = 'stability-bad'
            
            if (((props.tempIndicator=== 'C') && (props.tempActual < -5) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual <23))) {
            
            contingentMessage = props.content.noStabilityStd 
            highlightClass = 'stability-color-bad' 
          
          }
          else if(((props.tempIndicator=== 'C') && (props.tempActual >= -5  && props.tempActual <= 1) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 23  && props.tempActual <= 35) )	) {
             contingentMessage = props.content.noStabilityStd 
            highlightClass = 'stability-color-bad'           
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 2 && props.tempActual <= 8) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 36  && props.tempActual <= 46) )	) {
            
                contingentMessage = props.content.skyriziPenStable 
                highlightClass = 'stability-color-good'
                     
            
          }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 9  && props.tempActual <= 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >= 47  && props.tempActual <= 77) )	) {
             if (props.selectedMinutes() <= 24) {
                contingentMessage = props.content.skyriziPenStable 
                highlightClass = 'stability-color-good'
             }else{
                contingentMessage = props.content.noStabilityStd 
                highlightClass = 'stability-color-bad'
             }           
            
          }else if (((props.tempIndicator=== 'C') && (props.tempActual > 25) ) ||
            ((props.tempIndicator=== 'F') && (props.tempActual >77) )	) {
            
            contingentMessage = props.content.noStabilityStd 
            highlightClass = 'stability-color-bad' 
          
          }

         
          /*New logic for Skyrizi Pen PPH ends here */



        }
        message = contingentMessage 

        if (props.isSkyriziSelected() || props.isDuopaSelected() || props.isHumiraCitrateFreeSelectedByPatient() 
        || props.isHumiraCitrateFreeSelectedByPPH()|| props.isHumiraSelectedByPatient()  || props.isHumiraSelectedByPPH() 
        || props.isSkyriziPenSelectedByPatient() || props.isSkyriziPenSelectedByPPH()
        || props.isSkyriziSyringeSelectedByPatient() || props.isSkyriziSyringeSelectedByPPH() 
        || props.isLuprondepotSelected() || props.isRinvoqTabletsSelectedByPatient() || 
        props.isRinvoqTabletsSelectedByPPH() || props.isRinvoqLiquidSelectedByPatient() || props.isRinvoqLiquidSelectedByPPH()) {
        
          if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
                message = message + '\n\n' +props.content.patientAdditionalQuestions + '\n\n' +   props.content.haveQuestions
              }
        
        } 
      }
      if(props.isBotoxSelected()) {
          message = props.messages.bad
          highlightClass = 'stability-bad'
          
          if (((props.tempIndicator=== 'C') && (props.tempActual < -20) ) ||
          ((props.tempIndicator=== 'F') && (props.tempActual <-4))) {
          
          message = props.content.botoxbelow70Above30 
          highlightClass = 'stability-color-bad' 
        
        }
        else if(((props.tempIndicator=== 'C') && (props.tempActual >= -20  && props.tempActual <= 8) ) ||
          ((props.tempIndicator=== 'F') && (props.tempActual >= -4  && props.tempActual <= 46) )	) {
          
          message = props.content.recommendedBotoxInjection 
          highlightClass = 'stability-color-good'
          
        }else if(((props.tempIndicator=== 'C') && (props.tempActual >= 9  && props.tempActual <= 30) ) ||
          ((props.tempIndicator=== 'F') && (props.tempActual >= 47  && props.tempActual <= 86) )	) {
          if(props.selectedMinutes() <= 120) {
            message = props.content.recommendedBotoxInjection 
            highlightClass = 'stability-color-good'
        
          }else{
          
            message = props.content.botoxBetween9_30Unstable 
            highlightClass = 'stability-color-bad' 
          }
          
          
        }else if (((props.tempIndicator=== 'C') && (props.tempActual > 30) ) ||
          ((props.tempIndicator=== 'F') && (props.tempActual >86) )	) {
          
          message = props.content.botoxbelow70Above30 
          highlightClass = 'stability-color-bad' 
        
        }
      }
      if (props.isImbruvicaOralSuspensionSelected()) { 
        if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
                message = message + '\n\n' + props.content.haveQuestions
              }
      }
       if (props.isImbruvicaSelected()) { 
        if(props.selectedRole === 'PATIENT'  || props.userType === PATIENT){
                message = message + '\n\n' +props.content.haveQuestions
              }
      }


      
    }
     break
    case 'MISMATCH':
      message = props.messages.mismatch
      highlightClass = 'stability-bad'
      // resultIcon = "fa-times-circle";
      break
    case 'ZERO_TIME':
      message = props.messages.zeroTime
      highlightClass = 'stability-bad'
      // resultIcon = "fa-times-circle";
      break
    default:
  }
  return (
    <div style={{ whiteSpace: 'pre-wrap' }} className={`stability-result ${highlightClass}`}>
      {message}
    </div>
  )
}

function mapStateToProps(state) {
  return {
    pageContent: state.pageContent,
    userType: getUserType(state.referenceData),
    country: getSelectedCountry(state.referenceData)
  }
}

const getUserType = referenceData => {
  const data = referenceData.filter(item => item.type === REF_DATA).pop()
  return data ? data.referenceData.UserType : null
}

const getSelectedCountry = referenceData => {
  const data = referenceData.filter(item => item.type === SELECTED_COUNTRY).pop()
  return data ? data.country.name : null
}

export default connect(mapStateToProps)(StabilityTool_common)



// WEBPACK FOOTER //
// ./src/mi-app/stabilityTool/StabilityTool_common.js